"use client"
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/index.ts
import { Accordion } from "@chakra-ui/react/accordion";
import { AspectRatio } from "@chakra-ui/react/aspect-ratio";
import { Box as Box2 } from "@chakra-ui/react/box";
import { Center } from "@chakra-ui/react/center";
import { Container } from "@chakra-ui/react/container";
import { Collapsible } from "@chakra-ui/react/collapsible";
import { Flex as Flex2 } from "@chakra-ui/react/flex";
import { Grid } from "@chakra-ui/react/grid";
import { GridItem } from "@chakra-ui/react/grid";
import { HStack } from "@chakra-ui/react/stack";
import { SimpleGrid } from "@chakra-ui/react/simple-grid";
import { Spacer } from "@chakra-ui/react/spacer";
import { Stack as Stack2 } from "@chakra-ui/react/stack";
import { VStack } from "@chakra-ui/react/stack";
import { Wrap } from "@chakra-ui/react/wrap";
import { WrapItem } from "@chakra-ui/react/wrap";
import { ProgressCircle } from "@chakra-ui/react/progress-circle";
import { Heading } from "@chakra-ui/react/heading";
import { Text } from "@chakra-ui/react/text";
import { Code } from "@chakra-ui/react/code";
import { Kbd } from "@chakra-ui/react/kbd";
import { Button as Button2 } from "@chakra-ui/react/button";
import { Checkbox } from "@chakra-ui/react/checkbox";
import { Editable } from "@chakra-ui/react/editable";
import { IconButton } from "@chakra-ui/react/button";
import { Input } from "@chakra-ui/react/input";
import { InputGroup } from "@chakra-ui/react/input-group";
import { NumberInput } from "@chakra-ui/react/number-input";
import { PinInput } from "@chakra-ui/react/pin-input";
import { RadioGroup } from "@chakra-ui/react/radio-group";
import { Select } from "@chakra-ui/react/select";
import { Slider } from "@chakra-ui/react/slider";
import { Switch } from "@chakra-ui/react/switch";
import { Separator } from "@chakra-ui/react/separator";
import { Textarea } from "@chakra-ui/react/textarea";
import { Field } from "@chakra-ui/react/field";
import { Combobox } from "@chakra-ui/react/combobox";
import { Avatar } from "@chakra-ui/react/avatar";
import { Badge } from "@chakra-ui/react/badge";
import { Card } from "@chakra-ui/react/card";
import { List } from "@chakra-ui/react/list";
import { Stat } from "@chakra-ui/react/stat";
import { Table } from "@chakra-ui/react/table";
import { Tag } from "@chakra-ui/react/tag";
import { Alert } from "@chakra-ui/react/alert";
import { Progress } from "@chakra-ui/react/progress";
import { Skeleton } from "@chakra-ui/react/skeleton";
import { SkeletonText } from "@chakra-ui/react/skeleton";
import { Spinner as Spinner2 } from "@chakra-ui/react/spinner";
import { Toast as Toast2 } from "@chakra-ui/react/toast";
import { Drawer } from "@chakra-ui/react/drawer";
import { Dialog } from "@chakra-ui/react/dialog";
import { Popover } from "@chakra-ui/react/popover";
import { Breadcrumb } from "@chakra-ui/react/breadcrumb";
import { Link } from "@chakra-ui/react/link";
import { Steps } from "@chakra-ui/react/steps";
import { Tabs } from "@chakra-ui/react/tabs";
import { CloseButton } from "@chakra-ui/react/button";
import { Icon as Icon2 } from "@chakra-ui/react/icon";
import { Image as Image2 } from "@chakra-ui/react/image";
import { Menu } from "@chakra-ui/react/menu";

// src/components/snippet/toaster.tsx
import { Toaster as ChakraToaster } from "@chakra-ui/react/toast";
import { Spinner } from "@chakra-ui/react/spinner";
import { Stack } from "@chakra-ui/react/stack";
import { Toast } from "@chakra-ui/react/toast";
import { createToaster } from "@chakra-ui/react/toast";
import { jsx, jsxs } from "react/jsx-runtime";
var toaster = createToaster({
  placement: "bottom-end",
  max: 5,
  offsets: "100px",
  pauseOnPageIdle: true,
  duration: 5e3
});
var Toaster = () => {
  return /* @__PURE__ */ jsx(ChakraToaster, { toaster, children: (toast) => /* @__PURE__ */ jsxs(Toast.Root, { children: [
    toast.type === "loading" ? /* @__PURE__ */ jsx(Spinner, { size: "sm", color: "blue.solid" }) : /* @__PURE__ */ jsx(Toast.Indicator, {}),
    /* @__PURE__ */ jsxs(Stack, { gap: "1", flex: "1", maxWidth: "100%", children: [
      toast.title && /* @__PURE__ */ jsx(Toast.Title, { children: toast.title }),
      toast.description && /* @__PURE__ */ jsx(Toast.Description, { children: toast.description })
    ] }),
    toast.action && /* @__PURE__ */ jsx(Toast.ActionTrigger, { children: toast.action.label }),
    toast.meta?.closable && /* @__PURE__ */ jsx(Toast.CloseTrigger, {})
  ] }) });
};

// src/components/snippet/tooltip.tsx
import { Tooltip as ChakraTooltip } from "@chakra-ui/react/tooltip";
import { Portal } from "@chakra-ui/react/portal";
import * as React from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Tooltip = React.forwardRef(function Tooltip2(props, ref) {
  const {
    showArrow,
    children,
    disabled,
    portalled = true,
    content,
    contentProps,
    portalRef,
    openDelay = 400,
    closeDelay = 100,
    ...rest2
  } = props;
  if (disabled) {
    return children;
  }
  return /* @__PURE__ */ jsxs2(ChakraTooltip.Root, { openDelay, closeDelay, ...rest2, children: [
    /* @__PURE__ */ jsx2(ChakraTooltip.Trigger, { asChild: true, children }),
    /* @__PURE__ */ jsx2(Portal, { disabled: !portalled, container: portalRef, children: /* @__PURE__ */ jsx2(ChakraTooltip.Positioner, { children: /* @__PURE__ */ jsxs2(ChakraTooltip.Content, { ref, ...contentProps, children: [
      showArrow && /* @__PURE__ */ jsx2(ChakraTooltip.Arrow, { children: /* @__PURE__ */ jsx2(ChakraTooltip.ArrowTip, {}) }),
      content
    ] }) }) })
  ] });
});

// src/components/snippet/carousel.tsx
import * as React5 from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Button, Box, Flex } from "@chakra-ui/react";

// ../utils/src/bridge/WpBridge.ts
var WP_EVENT_CHANNEL = "wp-event";
function isWindowAvailable() {
  return typeof window !== "undefined" && typeof window.addEventListener === "function";
}
function normalizePayload(detail) {
  const { type: _ignored, ...payload } = detail;
  return payload;
}
var WpBridge = class {
  debug;
  constructor(options) {
    this.debug = Boolean(options?.debug);
  }
  /**
   * Subscribe to a specific WP event type
   */
  on(type, handler) {
    if (!isWindowAvailable()) {
      return () => void 0;
    }
    const listener = (event) => {
      const customEvent = event;
      const detail = customEvent.detail;
      if (!detail || detail.type !== type) {
        return;
      }
      const payload = normalizePayload(detail);
      if (this.debug) {
        console.info("[WpBridge] event", type, payload);
      }
      handler(payload);
    };
    window.addEventListener(WP_EVENT_CHANNEL, listener);
    if (this.debug) {
      console.info("[WpBridge] on", type);
    }
    return () => {
      window.removeEventListener(WP_EVENT_CHANNEL, listener);
      if (this.debug) {
        console.info("[WpBridge] off", type);
      }
    };
  }
  /**
   * Subscribe once only
   */
  once(type, handler) {
    const unsubscribe = this.on(type, (payload) => {
      try {
        handler(payload);
      } finally {
        unsubscribe();
      }
    });
    return unsubscribe;
  }
  /**
   * Dispatch helper for tests/manual triggers
   */
  dispatch(type, payload) {
    if (!isWindowAvailable()) {
      return;
    }
    const detail = { type, ...payload };
    window.dispatchEvent(new CustomEvent(WP_EVENT_CHANNEL, { detail }));
  }
};
var wpBridge = new WpBridge();

// ../utils/src/function/env.ts
function isServer() {
  return typeof window === "undefined" && typeof global !== "undefined";
}

// ../utils/src/hooks/useAsyncEffect.ts
import { useEffect } from "react";

// ../utils/src/hooks/useCombinedRef.ts
import { useCallback } from "react";
function useCombinedRefs(...refs) {
  return useCallback(
    (value) => {
      for (const ref of refs) {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}

// ../utils/src/hooks/useDidUpdate.ts
import { useEffect as useEffect2, useRef } from "react";

// ../utils/src/hooks/useEffectOnce.ts
import { useEffect as useEffect3 } from "react";

// ../utils/src/hooks/useEventListener.ts
import { useEffect as useEffect4, useRef as useRef2 } from "react";

// ../utils/src/hooks/useImpression.ts
import { useCallback as useCallback2, useMemo } from "react";

// ../utils/src/hooks/useImpressionRef.ts
import { useCallback as useCallback5, useEffect as useEffect7, useMemo as useMemo2, useRef as useRef5 } from "react";

// ../utils/src/hooks/usePreservedCallback.ts
import { useCallback as useCallback3, useEffect as useEffect5, useRef as useRef3 } from "react";
function usePreservedCallback(callback) {
  const callbackRef = useRef3(callback);
  useEffect5(() => {
    callbackRef.current = callback;
  }, [callback]);
  return useCallback3((...args) => {
    return callbackRef.current(...args);
  }, []);
}

// ../utils/src/hooks/useVisibilityEvent.ts
import { useEffect as useEffect6 } from "react";
function useVisibilityEvent(callback) {
  const handleVisibilityChange = usePreservedCallback(() => {
    callback(document.visibilityState);
  });
  useEffect6(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
}

// ../utils/src/hooks/useRefEvent.ts
import { useCallback as useCallback4, useRef as useRef4 } from "react";

// ../../node_modules/es-toolkit/dist/function/debounce.mjs
function debounce(func, debounceMs, { signal, edges } = {}) {
  let pendingThis = void 0;
  let pendingArgs = null;
  const leading = edges != null && edges.includes("leading");
  const trailing = edges == null || edges.includes("trailing");
  const invoke = () => {
    if (pendingArgs !== null) {
      func.apply(pendingThis, pendingArgs);
      pendingThis = void 0;
      pendingArgs = null;
    }
  };
  const onTimerEnd = () => {
    if (trailing) {
      invoke();
    }
    cancel();
  };
  let timeoutId = null;
  const schedule = () => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      onTimerEnd();
    }, debounceMs);
  };
  const cancelTimer = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  const cancel = () => {
    cancelTimer();
    pendingThis = void 0;
    pendingArgs = null;
  };
  const flush = () => {
    invoke();
  };
  const debounced = function(...args) {
    if (signal?.aborted) {
      return;
    }
    pendingThis = this;
    pendingArgs = args;
    const isFirstCall = timeoutId == null;
    schedule();
    if (leading && isFirstCall) {
      invoke();
    }
  };
  debounced.schedule = schedule;
  debounced.cancel = cancel;
  debounced.flush = flush;
  signal?.addEventListener("abort", cancel, { once: true });
  return debounced;
}

// ../../node_modules/es-toolkit/dist/function/noop.mjs
function noop() {
}

// ../utils/src/hooks/useRefEvent.ts
function useRefEffect(callback, deps) {
  const preservedCallback = usePreservedCallback(callback);
  const disposeRef = useRef4(noop);
  const effect = useCallback4(
    (element) => {
      disposeRef.current();
      disposeRef.current = noop;
      if (element != null) {
        const cleanup = callback(element);
        if (typeof cleanup === "function") {
          disposeRef.current = cleanup;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preservedCallback, ...deps]
  );
  return effect;
}

// ../utils/src/hooks/useImpressionRef.ts
function useImpressionRef({
  onImpressionStart: _onImpressionStart = noop,
  onImpressionEnd: _onImpressionEnd = noop,
  timeThreshold = 0,
  root,
  rootMargin,
  areaThreshold: intersectThreshold = 0,
  impressionOnce = false
}) {
  const onImpressionStart = usePreservedCallback(_onImpressionStart);
  const onImpressionEnd = usePreservedCallback(_onImpressionEnd);
  const isIntersectingRef = useRef5(false);
  const hasImpressionStartedRef = useRef5(false);
  const hasImpressionEndedRef = useRef5(false);
  const setDebouncedIsImpressed = useSetDebouncedBooleanValue({
    onValueChange: (isImpressed) => {
      if (isImpressed) {
        if (impressionOnce && hasImpressionStartedRef.current) {
          return;
        }
        hasImpressionStartedRef.current = true;
        onImpressionStart();
      } else {
        if (impressionOnce && hasImpressionEndedRef.current) {
          return;
        }
        hasImpressionEndedRef.current = true;
        onImpressionEnd();
      }
    },
    timeThreshold
  });
  const intersectionObserverRef = useIntersectionObserver(
    ({ isIntersecting }) => {
      if (document.visibilityState === "hidden") {
        return;
      }
      isIntersectingRef.current = isIntersecting;
      setDebouncedIsImpressed(isIntersecting);
    },
    {
      root,
      rootMargin,
      threshold: intersectThreshold
    }
  );
  useVisibilityEvent((visibilityState) => {
    if (!isIntersectingRef.current) {
      return;
    }
    setDebouncedIsImpressed(visibilityState === "visible");
  });
  return intersectionObserverRef;
}
function useIntersectionObserver(_callback, options) {
  const callback = usePreservedCallback(_callback);
  const observer = useMemo2(() => {
    if (typeof IntersectionObserver === "undefined") {
      return;
    }
    const observer2 = new IntersectionObserver(([entry]) => {
      if (!entry) {
        return;
      }
      callback(entry);
    }, options);
    return observer2;
  }, [callback, options]);
  const ref = useRefEffect(
    (element) => {
      observer?.observe(element);
      return () => {
        observer?.unobserve(element);
      };
    },
    [callback, options]
  );
  return ref;
}
function useSetDebouncedBooleanValue(options) {
  const { onValueChange, timeThreshold } = options;
  const handleValueChange = usePreservedCallback(onValueChange);
  const ref = useRef5({ value: false, cancelPrevDebounce: noop });
  const setDebouncedValue = useCallback5(
    (newValue) => {
      if (newValue === ref.current.value) {
        return;
      }
      const debounced = debounce(() => {
        handleValueChange(newValue);
        ref.current.value = newValue;
      }, timeThreshold ?? 100);
      ref.current.cancelPrevDebounce();
      debounced();
      ref.current.cancelPrevDebounce = debounced.cancel;
    },
    [handleValueChange, timeThreshold]
  );
  useEffect7(() => {
    const current = ref.current;
    return () => {
      current.cancelPrevDebounce();
    };
  }, []);
  return setDebouncedValue;
}

// ../utils/src/hooks/useIsClient.ts
import { useSyncExternalStore } from "react";
var emptySubscribe = () => noop;
var getSnapshot = () => true;
var getServerSnapshot = () => false;
var useIsClient = () => useSyncExternalStore(emptySubscribe, getSnapshot, getServerSnapshot);

// ../utils/src/hooks/usePageInfo.ts
import { useEffect as useEffect8, useState } from "react";

// ../utils/src/hooks/useOutsideClickEffect.ts
import { useEffect as useEffect9, useRef as useRef6 } from "react";

// ../utils/src/hooks/useCallbackRef.ts
import { useRef as useRef7, useEffect as useEffect10, useMemo as useMemo3 } from "react";

// ../utils/src/hooks/useIsTouchDevice.ts
import { useEffect as useEffect11, useState as useState2 } from "react";

// ../utils/src/hooks/useMutationLoading.ts
import { useState as useState3, useEffect as useEffect12 } from "react";

// ../utils/src/hooks/useDebouncedNumberCommit.ts
import { useEffect as useEffect13, useMemo as useMemo4, useState as useState4 } from "react";

// ../utils/src/hooks/useStep.ts
import { useState as useState5, useCallback as useCallback6, useMemo as useMemo5 } from "react";

// ../utils/src/logger/Logger.tsx
import { createContext, useState as useState6, useEffect as useEffect14, useContext, useCallback as useCallback7, useMemo as useMemo6 } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var defaultAnalyticsContext = {
  isInitialized: false,
  debug: false,
  identify: () => {
  },
  group: () => {
  },
  trackEvent: () => {
  },
  metadata: {},
  appName: ""
};
var LoggerContext = createContext(defaultAnalyticsContext);

// ../utils/src/logger/hooks/useLogger.ts
import { useCallback as useCallback8, useMemo as useMemo7 } from "react";

// ../utils/src/logger/hooks/usePageLogger.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var PageLoggerContext = createContext2(void 0);

// ../utils/src/logger/components/LoggingEvent.tsx
import { cloneElement } from "react";

// ../utils/src/logger/components/LoggingClick.tsx
import { jsx as jsx5 } from "react/jsx-runtime";

// ../utils/src/react/ImpressionArea.tsx
import { forwardRef as forwardRef3 } from "react";

// ../utils/src/react/Slot/Slot.tsx
import React3 from "react";

// ../utils/src/react/Slot/@common/Sloattable/Slottable.tsx
import React2 from "react";
import { Fragment, jsx as jsx6 } from "react/jsx-runtime";
function Slottable({ children }) {
  return /* @__PURE__ */ jsx6(Fragment, { children });
}
function isSlottable(child) {
  return React2.isValidElement(child) && child.type === Slottable;
}

// ../../node_modules/react-simplikit/esm/index.js
import { forwardRef as forwardRef2 } from "react";
import { useRef as useRef42 } from "react";
import { useCallback as useCallback22, useEffect as useEffect22, useMemo as useMemo8, useRef as useRef22 } from "react";
import { useCallback as useCallback9, useEffect as useEffect15, useRef as useRef8 } from "react";
import { useMemo as useMemo22 } from "react";
import { useCallback as useCallback32, useRef as useRef32 } from "react";
import { useCallback as useCallback42, useEffect as useEffect32 } from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
import { Children, Fragment as Fragment2, isValidElement } from "react";
import { Fragment as Fragment22, jsx as jsx22, jsxs as jsxs3 } from "react/jsx-runtime";
import { useEffect as useEffect42 } from "react";
import { useCallback as useCallback52, useState as useState7 } from "react";
import { useEffect as useEffect52, useRef as useRef52 } from "react";
import { useCallback as useCallback62, useEffect as useEffect62, useRef as useRef62 } from "react";
import { useCallback as useCallback72, useState as useState22 } from "react";
import { useCallback as useCallback82, useState as useState32 } from "react";
import { useEffect as useEffect72 } from "react";
import { useMemo as useMemo32 } from "react";
import { useCallback as useCallback92, useEffect as useEffect82, useRef as useRef72 } from "react";
import { useCallback as useCallback10, useEffect as useEffect92, useRef as useRef82, useState as useState42 } from "react";
import { useCallback as useCallback11, useState as useState52 } from "react";
import { useEffect as useEffect102 } from "react";
import { useEffect as useEffect112, useLayoutEffect } from "react";
import { useCallback as useCallback12, useEffect as useEffect122, useMemo as useMemo42, useRef as useRef9, useState as useState62 } from "react";
import { useCallback as useCallback13, useRef as useRef10 } from "react";
import { useCallback as useCallback14, useMemo as useMemo62, useState as useState72 } from "react";
import { useMemo as useMemo52, useRef as useRef11 } from "react";
import { useEffect as useEffect132, useRef as useRef12 } from "react";
import { useRef as useRef13 } from "react";
import { useCallback as useCallback15, useRef as useRef14, useSyncExternalStore as useSyncExternalStore2 } from "react";
import { useEffect as useEffect142, useMemo as useMemo72 } from "react";
import { useEffect as useEffect152 } from "react";
import { useReducer } from "react";
import { createContext as createContext3, useContext as useContext3, useMemo as useMemo82 } from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
function debounce2(func, debounceMs, { edges = ["leading", "trailing"] } = {}) {
  let pendingThis = void 0;
  let pendingArgs = null;
  const leading = edges != null && edges.includes("leading");
  const trailing = edges == null || edges.includes("trailing");
  const invoke = () => {
    if (pendingArgs !== null) {
      func.apply(pendingThis, pendingArgs);
      pendingThis = void 0;
      pendingArgs = null;
    }
  };
  const onTimerEnd = () => {
    if (trailing) {
      invoke();
    }
    cancel();
  };
  let timeoutId = null;
  const schedule = () => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      onTimerEnd();
    }, debounceMs);
  };
  const cancelTimer = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  const cancel = () => {
    cancelTimer();
    pendingThis = void 0;
    pendingArgs = null;
  };
  const debounced = function(...args) {
    pendingThis = this;
    pendingArgs = args;
    const isFirstCall = timeoutId == null;
    schedule();
    if (leading && isFirstCall) {
      invoke();
    }
  };
  debounced.cancel = cancel;
  return debounced;
}
function usePreservedCallback2(callback) {
  const callbackRef = useRef8(callback);
  useEffect15(() => {
    callbackRef.current = callback;
  }, [callback]);
  return useCallback9((...args) => {
    return callbackRef.current(...args);
  }, []);
}
function useDebouncedCallback({
  onChange,
  timeThreshold,
  leading = false,
  trailing = true
}) {
  const handleChange = usePreservedCallback2(onChange);
  const ref = useRef22({ value: false, clearPreviousDebounce: () => {
  } });
  useEffect22(() => {
    const current = ref.current;
    return () => {
      current.clearPreviousDebounce();
    };
  }, []);
  const edges = useMemo8(() => {
    const _edges = [];
    if (leading) {
      _edges.push("leading");
    }
    if (trailing) {
      _edges.push("trailing");
    }
    return _edges;
  }, [leading, trailing]);
  return useCallback22(
    (nextValue) => {
      if (nextValue === ref.current.value) {
        return;
      }
      const debounced = debounce2(
        () => {
          handleChange(nextValue);
          ref.current.value = nextValue;
        },
        timeThreshold,
        { edges }
      );
      ref.current.clearPreviousDebounce();
      debounced();
      ref.current.clearPreviousDebounce = debounced.cancel;
    },
    [handleChange, timeThreshold, edges]
  );
}
function useRefEffect2(callback, deps) {
  const preservedCallback = usePreservedCallback2(callback);
  const cleanupCallbackRef = useRef32(() => {
  });
  const effect = useCallback32(
    (element) => {
      cleanupCallbackRef.current();
      cleanupCallbackRef.current = () => {
      };
      if (element == null) {
        return;
      }
      const cleanup = preservedCallback(element);
      if (typeof cleanup === "function") {
        cleanupCallbackRef.current = cleanup;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preservedCallback, ...deps]
  );
  return effect;
}
function useIntersectionObserver2(callback, options) {
  const preservedCallback = usePreservedCallback2(callback);
  const observer = useMemo22(() => {
    if (typeof IntersectionObserver === "undefined") {
      return;
    }
    return new IntersectionObserver(([entry]) => {
      preservedCallback(entry);
    }, options);
  }, [preservedCallback, options]);
  return useRefEffect2(
    (element) => {
      observer?.observe(element);
      return () => {
        observer?.unobserve(element);
      };
    },
    [preservedCallback, options]
  );
}
function useVisibilityEvent2(callback, options = {}) {
  const handleVisibilityChange = useCallback42(() => {
    callback(document.visibilityState);
  }, [callback]);
  useEffect32(() => {
    if (options?.immediate ?? false) {
      handleVisibilityChange();
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange, options?.immediate]);
}
function useImpressionRef2({
  onImpressionStart = () => {
  },
  onImpressionEnd = () => {
  },
  rootMargin,
  areaThreshold = 0,
  timeThreshold = 0
}) {
  const impressionStartHandler = usePreservedCallback2(onImpressionStart);
  const impressionEndHandler = usePreservedCallback2(onImpressionEnd);
  const isIntersectingRef = useRef42(false);
  const impressionEventHandler = useDebouncedCallback({
    timeThreshold,
    onChange: (impressed) => {
      (impressed ? impressionStartHandler : impressionEndHandler)();
    },
    leading: true
  });
  useVisibilityEvent2((documentVisible) => {
    if (!isIntersectingRef.current) {
      return;
    }
    impressionEventHandler(documentVisible === "visible");
  });
  return useIntersectionObserver2(
    (entry) => {
      if (document.visibilityState === "hidden") {
        return;
      }
      const currentRatio = entry.intersectionRatio;
      const isIntersecting = areaThreshold === 0 ? entry.isIntersecting : currentRatio >= areaThreshold;
      isIntersectingRef.current = isIntersecting;
      impressionEventHandler(isIntersecting);
    },
    { rootMargin, threshold: areaThreshold }
  );
}
function mergeRefs(...refs) {
  return (value) => {
    for (const ref of refs) {
      if (ref == null) {
        continue;
      }
      if (typeof ref === "function") {
        ref(value);
        continue;
      }
      ref.current = value;
    }
  };
}
var ImpressionArea = forwardRef2(ImpressionAreaImpl);
function ImpressionAreaImpl({ as, rootMargin, areaThreshold, timeThreshold, onImpressionStart, onImpressionEnd, ...props }, ref) {
  const Component2 = as ?? "div";
  const impressionRef = useImpressionRef2({
    onImpressionStart,
    onImpressionEnd,
    areaThreshold,
    timeThreshold,
    rootMargin
  });
  return /* @__PURE__ */ jsx7(Component2, { ref: mergeRefs(ref, impressionRef), ...props });
}
Object.assign(ImpressionArea, {
  displayName: "ImpressionArea"
});
var MemoStorage = class {
  storage = /* @__PURE__ */ new Map();
  get(key) {
    return this.storage.get(key) ?? null;
  }
  set(key, value) {
    this.storage.set(key, value);
  }
  remove(key) {
    this.storage.delete(key);
  }
  clear() {
    this.storage.clear();
  }
};
var LocalStorage = class {
  static canUse() {
    const TEST_KEY = generateTestKey();
    try {
      localStorage.setItem(TEST_KEY, "test");
      localStorage.removeItem(TEST_KEY);
      return true;
    } catch {
      return false;
    }
  }
  get(key) {
    return localStorage.getItem(key);
  }
  set(key, value) {
    localStorage.setItem(key, value);
  }
  remove(key) {
    localStorage.removeItem(key);
  }
  clear() {
    localStorage.clear();
  }
};
var SessionStorage = class {
  static canUse() {
    const TEST_KEY = generateTestKey();
    try {
      sessionStorage.setItem(TEST_KEY, "test");
      sessionStorage.removeItem(TEST_KEY);
      return true;
    } catch {
      return false;
    }
  }
  get(key) {
    return sessionStorage.getItem(key);
  }
  set(key, value) {
    sessionStorage.setItem(key, value);
  }
  remove(key) {
    sessionStorage.removeItem(key);
  }
  clear() {
    sessionStorage.clear();
  }
};
function generateTestKey() {
  return new Array(4).fill(null).map(() => Math.random().toString(36).slice(2)).join("");
}
function generateStorage() {
  if (LocalStorage.canUse()) {
    return new LocalStorage();
  }
  return new MemoStorage();
}
function generateSessionStorage() {
  if (SessionStorage.canUse()) {
    return new SessionStorage();
  }
  return new MemoStorage();
}
var safeLocalStorage = generateStorage();
var safeSessionStorage = generateSessionStorage();
function mergeProps(...props) {
  return props.reduce(pushProp, {});
}
function pushProp(prev, curr) {
  for (const key in curr) {
    if (curr[key] === void 0) continue;
    switch (key) {
      case "className": {
        prev[key] = [prev[key], curr[key]].join(" ").trim();
        break;
      }
      case "style": {
        prev[key] = mergeStyle(prev[key], curr[key]);
        break;
      }
      default: {
        const mergedFunction = mergeFunction(prev[key], curr[key]);
        if (mergedFunction) {
          prev[key] = mergedFunction;
        } else if (curr[key] !== void 0) {
          prev[key] = curr[key];
        }
      }
    }
  }
  return prev;
}
function mergeStyle(a, b) {
  if (a == null) return b;
  return { ...a, ...b };
}
function mergeFunction(a, b) {
  if (typeof a === "function" && typeof b === "function") {
    return (...args) => {
      a(...args);
      b(...args);
    };
  }
}

// ../utils/src/react/Slot/Slot.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var Slot = React3.forwardRef(({ children, ...slotProps }, ref) => {
  const childrenList = React3.Children.toArray(children);
  const slottable = childrenList.find(isSlottable);
  if (slottable != null) {
    const newElement = slottable.props.children;
    const newChildren = childrenList.map((child) => {
      if (child !== slottable) {
        return child;
      }
      if (React3.Children.count(newElement) > 1) {
        return React3.Children.only(null);
      }
      return React3.isValidElement(newElement) ? newElement.props.children : null;
    });
    return /* @__PURE__ */ jsx8(SlotClone, { ...slotProps, ref, children: React3.isValidElement(newElement) ? React3.cloneElement(newElement, void 0, newChildren) : null });
  }
  return /* @__PURE__ */ jsx8(SlotClone, { ...slotProps, ref, children });
});
var SlotClone = React3.forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (React3.isValidElement(children)) {
    const mergedProps = mergeProps(slotProps, children.props);
    const childRef = children.ref;
    const mergedRef = forwardedRef ? mergeRefs(forwardedRef, childRef) : childRef;
    return React3.cloneElement(
      children,
      {
        ...mergedProps,
        ref: mergedRef
      }
    );
  }
  return null;
});

// ../utils/src/react/ImpressionArea.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var ImpressionArea2 = forwardRef3(
  ({
    root,
    rootMargin,
    areaThreshold,
    timeThreshold,
    impressionOnce,
    className,
    children,
    onImpressionStart,
    onImpressionEnd,
    style,
    ...otherProps
  }, forwardedRef) => {
    const impressionRef = useImpressionRef({
      onImpressionStart,
      onImpressionEnd,
      areaThreshold,
      timeThreshold,
      impressionOnce,
      root,
      rootMargin
    });
    const ref = useCombinedRefs(forwardedRef, impressionRef);
    return /* @__PURE__ */ jsx9(Slot, { className, ref, style, ...otherProps, children });
  }
);
ImpressionArea2.displayName = "ImpressionArea";

// ../utils/src/logger/components/LoggingImpression.tsx
import { jsx as jsx10 } from "react/jsx-runtime";

// ../utils/src/logger/components/LoggingView.tsx
import { useEffect as useEffect16, useState as useState8, useRef as useRef15 } from "react";
import { Fragment as Fragment3, jsx as jsx11 } from "react/jsx-runtime";

// ../utils/src/react/TextHighlighter.tsx
import React4, { useMemo as useMemo9 } from "react";
import { Fragment as Fragment4, jsx as jsx12 } from "react/jsx-runtime";

// ../utils/src/react/ErrorBoundary.tsx
import { cloneElement as cloneElement2, Component } from "react";

// ../utils/src/react/createSafeContext.ts
import { createContext as createContext4, useContext as useContext4 } from "react";
var NullSymbol = Symbol("Null");
function createSafeContext(displayName) {
  const Context = createContext4(NullSymbol);
  Context.displayName = displayName ?? "SafeContext";
  function useSafeContext() {
    const context = useContext4(Context);
    if (context === NullSymbol) {
      const error2 = new Error(`[${Context.displayName}]: Provider not found.`);
      error2.name = "[Error] Context";
      throw error2;
    }
    return context;
  }
  return [Context.Provider, useSafeContext];
}

// ../utils/src/react/ClientOnly.tsx
import { Fragment as Fragment5, jsx as jsx13 } from "react/jsx-runtime";
var ClientOnly = Object.assign(
  ({ children, fallback }) => /* @__PURE__ */ jsx13(Fragment5, { children: useIsClient() ? children : fallback }),
  {
    displayName: "ClientOnly",
    with: (clientOnlyProps, Component2) => Object.assign(
      (props) => /* @__PURE__ */ jsx13(ClientOnly, { ...clientOnlyProps, children: /* @__PURE__ */ jsx13(Component2, { ...props }) }),
      { displayName: `${ClientOnly.displayName}.with(${Component2.displayName || Component2.name || "Component"})` }
    )
  }
);

// ../utils/src/storage/makeExternalStore.ts
import { useSyncExternalStore as useSyncExternalStore3 } from "react";

// ../utils/src/storage/localStorageEngine.ts
var clientLocalStorageEngine = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key)
};
var serverStorageEngine = {
  getItem: () => null,
  setItem: noop,
  removeItem: noop
};
var localStorageEngine = isServer() ? serverStorageEngine : clientLocalStorageEngine;

// src/assets/lucideIcons.ts
var lucideIcons_exports = {};
__export(lucideIcons_exports, {
  ArrowDownIcon: () => ArrowDownIcon,
  ArrowLeftIcon: () => ArrowLeftIcon,
  ArrowRightIcon: () => ArrowRightIcon,
  ArrowUpIcon: () => ArrowUpIcon,
  Check: () => Check,
  ChevronDown: () => ChevronDown,
  ChevronLeft: () => ChevronLeft,
  ChevronRight: () => ChevronRight,
  ChevronUp: () => ChevronUp,
  CircleAlert: () => CircleAlert,
  CircleCheck: () => CircleCheck,
  CircleMinus: () => CircleMinus,
  CirclePlus: () => CirclePlus,
  CircleUserRound: () => CircleUserRound,
  ExternalLink: () => ExternalLink,
  Eye: () => Eye,
  EyeOff: () => EyeOff,
  Heart: () => Heart,
  Image: () => Image,
  Info: () => Info,
  MailOpen: () => MailOpen,
  MapPin: () => MapPin,
  Minus: () => Minus,
  MoveLeft: () => MoveLeft,
  MoveRight: () => MoveRight,
  Package: () => Package,
  PercentCircle: () => PercentCircle,
  Phone: () => Phone,
  Plus: () => Plus,
  RefreshCcwIcon: () => RefreshCcwIcon,
  RefreshCwIcon: () => RefreshCwIcon,
  Search: () => Search,
  ShieldCheck: () => ShieldCheck,
  SlidersHorizontal: () => SlidersHorizontal,
  Sparkles: () => Sparkles,
  Star: () => Star,
  ThumbsUp: () => ThumbsUp,
  User: () => User,
  Volume2: () => Volume2,
  VolumeX: () => VolumeX,
  X: () => X
});
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Check,
  Phone,
  PercentCircle,
  Sparkles,
  MailOpen,
  MapPin,
  CircleUserRound,
  Heart,
  Minus,
  Plus,
  RefreshCcwIcon,
  RefreshCwIcon,
  Search,
  Star,
  X,
  CircleCheck,
  CircleAlert,
  User,
  Image,
  ThumbsUp,
  MoveLeft,
  MoveRight,
  Info,
  CirclePlus,
  CircleMinus,
  ExternalLink,
  Volume2,
  VolumeX,
  SlidersHorizontal,
  Eye,
  EyeOff,
  ShieldCheck,
  Package
} from "lucide-react";

// src/assets/icons.ts
var LUCIDE_ICONS = {
  ...lucideIcons_exports
};

// src/components/LucideIcon.tsx
import { Icon } from "@chakra-ui/react";
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var LucideIcon = forwardRef4(
  ({ name, ...props }, ref) => {
    const LucideIconComponent = LUCIDE_ICONS[name];
    if (!LucideIconComponent) {
      console.error(`Icon "${name}" not found in Icons, please add icon in src/assets/icons.ts`);
      return null;
    }
    return /* @__PURE__ */ jsx14(Icon, { asChild: true, ref, ...props, children: /* @__PURE__ */ jsx14(LucideIconComponent, {}) });
  }
);
LucideIcon.displayName = "LucideIcon";

// src/components/snippet/carousel.tsx
import { Fragment as Fragment6, jsx as jsx15, jsxs as jsxs4 } from "react/jsx-runtime";
var [CarouselProvider, useCarousel] = createSafeContext("CarouselContext");
var CarouselContent = React5.forwardRef(
  ({ className, ...props }, ref) => {
    const { carouselRef, orientation } = useCarousel();
    return /* @__PURE__ */ jsx15(Box, { ref: carouselRef, overflow: "hidden", children: /* @__PURE__ */ jsx15(
      Flex,
      {
        ref,
        className,
        flexDirection: orientation === "horizontal" ? "row" : "column",
        ...props
      }
    ) });
  }
);
CarouselContent.displayName = "CarouselContent";
var CarouselItem = React5.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx15(
    Box,
    {
      ref,
      role: "group",
      "aria-roledescription": "slide",
      className,
      minW: "0",
      flexShrink: "0",
      flexGrow: "0",
      flexBasis: "full",
      ...props
    }
  );
});
CarouselItem.displayName = "CarouselItem";
var CarouselDotButton = React5.forwardRef(
  ({ className, index, children, render, ...props }, ref) => {
    const { selectedIndex, onDotButtonClick } = useCarousel();
    const isSelected = index === selectedIndex;
    const onClick = React5.useCallback(() => {
      onDotButtonClick(index);
    }, [onDotButtonClick, index]);
    if (render) {
      return /* @__PURE__ */ jsx15(Fragment6, { children: render({ onClick, isSelected, index }) });
    }
    return /* @__PURE__ */ jsx15(
      Button,
      {
        ref,
        onClick,
        size: "xs",
        "aria-current": isSelected,
        variant: "ghost",
        "data-selected": isSelected,
        className,
        ...props,
        children
      }
    );
  }
);
CarouselDotButton.displayName = "CarouselDotButton";
var CarouselDots = React5.forwardRef(({ renderDot, className, ...props }, ref) => {
  const { scrollSnaps } = useCarousel();
  return /* @__PURE__ */ jsx15(Flex, { ref, className, ...props, children: scrollSnaps.map((_, index) => /* @__PURE__ */ jsx15(
    CarouselDotButton,
    {
      index,
      render: renderDot ? (buttonProps) => renderDot(buttonProps) : void 0
    },
    index
  )) });
});
CarouselDots.displayName = "CarouselDots";
var CarouselPrevious = React5.forwardRef(
  ({ className, variant = "outline", size = "sm", children, ...props }, ref) => {
    const { orientation, scrollPrev, canScrollPrev } = useCarousel();
    return /* @__PURE__ */ jsx15(
      Button,
      {
        ref,
        variant,
        size,
        position: "absolute",
        height: "8",
        width: "8",
        borderRadius: "full",
        left: orientation === "horizontal" ? "-3rem" : "50%",
        top: orientation === "horizontal" ? "50%" : "-3rem",
        transform: orientation === "horizontal" ? "translateY(-50%)" : "translateX(-50%) rotate(90deg)",
        className,
        disabled: !canScrollPrev,
        onClick: scrollPrev,
        ...props,
        children: children || /* @__PURE__ */ jsxs4(Fragment6, { children: [
          /* @__PURE__ */ jsx15(LucideIcon, { name: "ChevronLeft", boxSize: 16 }),
          /* @__PURE__ */ jsx15("span", { className: "sr-only", children: "Previous" })
        ] })
      }
    );
  }
);
CarouselPrevious.displayName = "CarouselPrevious";
var CarouselNext = React5.forwardRef(
  ({ className, variant = "outline", size = "sm", children, ...props }, ref) => {
    const { orientation, scrollNext, canScrollNext } = useCarousel();
    return /* @__PURE__ */ jsx15(
      Button,
      {
        ref,
        variant,
        size,
        position: "absolute",
        height: "8",
        width: "8",
        borderRadius: "full",
        right: orientation === "horizontal" ? "-3rem" : void 0,
        bottom: orientation === "vertical" ? "-3rem" : void 0,
        left: orientation === "vertical" ? "50%" : void 0,
        top: orientation === "horizontal" ? "50%" : void 0,
        transform: orientation === "horizontal" ? "translateY(-50%)" : "translateX(-50%) rotate(90deg)",
        className,
        disabled: !canScrollNext,
        onClick: scrollNext,
        ...props,
        children: children || /* @__PURE__ */ jsxs4(Fragment6, { children: [
          /* @__PURE__ */ jsx15(LucideIcon, { name: "ChevronRight", boxSize: 16 }),
          /* @__PURE__ */ jsx15("span", { className: "sr-only", children: "Next" })
        ] })
      }
    );
  }
);
CarouselNext.displayName = "CarouselNext";
var CarouselComponent = React5.forwardRef(
  ({ orientation = "horizontal", opts, setApi, plugins, className, children, ...props }, ref) => {
    const [carouselRef, api] = useEmblaCarousel(
      {
        ...opts,
        axis: orientation === "horizontal" ? "x" : "y"
      },
      plugins
    );
    const [canScrollPrev, setCanScrollPrev] = React5.useState(false);
    const [canScrollNext, setCanScrollNext] = React5.useState(false);
    const [selectedIndex, setSelectedIndex] = React5.useState(0);
    const [scrollSnaps, setScrollSnaps] = React5.useState([]);
    const onDotButtonClick = React5.useCallback(
      (index) => {
        if (!api) {
          return;
        }
        api.scrollTo(index);
      },
      [api]
    );
    const onSelect = React5.useCallback((api2) => {
      if (!api2) {
        return;
      }
      setSelectedIndex(api2.selectedScrollSnap());
      setScrollSnaps(api2.scrollSnapList());
      setCanScrollPrev(api2.canScrollPrev());
      setCanScrollNext(api2.canScrollNext());
    }, []);
    const scrollPrev = React5.useCallback(() => {
      api?.scrollPrev();
    }, [api]);
    const scrollNext = React5.useCallback(() => {
      api?.scrollNext();
    }, [api]);
    const handleKeyDown = React5.useCallback(
      (event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          scrollPrev();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          scrollNext();
        }
      },
      [scrollPrev, scrollNext]
    );
    React5.useEffect(() => {
      if (!api || !setApi) {
        return;
      }
      setApi(api);
    }, [api, setApi]);
    React5.useEffect(() => {
      if (!api) {
        return;
      }
      onSelect(api);
      api.on("reInit", onSelect);
      api.on("select", onSelect);
      return () => {
        api?.off("select", onSelect);
      };
    }, [api, onSelect]);
    return /* @__PURE__ */ jsx15(
      CarouselProvider,
      {
        value: {
          carouselRef,
          api,
          opts,
          orientation: orientation || (opts?.axis === "y" ? "vertical" : "horizontal"),
          scrollPrev,
          scrollNext,
          canScrollPrev,
          canScrollNext,
          selectedIndex,
          scrollSnaps,
          onDotButtonClick
        },
        children: /* @__PURE__ */ jsx15(
          Box,
          {
            ref,
            onKeyDownCapture: handleKeyDown,
            className,
            position: "relative",
            role: "region",
            "aria-roledescription": "carousel",
            ...props,
            children
          }
        )
      }
    );
  }
);
CarouselComponent.displayName = "Carousel";
var Carousel = Object.assign(CarouselComponent, {
  Content: CarouselContent,
  Item: CarouselItem,
  Previous: CarouselPrevious,
  Next: CarouselNext,
  DotButton: CarouselDotButton,
  Dots: CarouselDots
});

// src/core/SSDesignSystemProvider.tsx
import { ChakraProvider } from "@chakra-ui/react/styled-system";
import { ThemeProvider } from "next-themes";

// src/core/theme/index.ts
import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

// src/core/theme/animation-styles.ts
import { defineAnimationStyles } from "@chakra-ui/react";
var animationStyles = defineAnimationStyles({
  "slide-fade-in": {
    value: {
      transformOrigin: "var(--transform-origin)",
      "&[data-placement^=top]": {
        animationName: "slide-from-bottom, fade-in"
      },
      "&[data-placement^=bottom]": {
        animationName: "slide-from-top, fade-in"
      },
      "&[data-placement^=left]": {
        animationName: "slide-from-right, fade-in"
      },
      "&[data-placement^=right]": {
        animationName: "slide-from-left, fade-in"
      }
    }
  },
  "slide-fade-out": {
    value: {
      transformOrigin: "var(--transform-origin)",
      "&[data-placement^=top]": {
        animationName: "slide-to-bottom, fade-out"
      },
      "&[data-placement^=bottom]": {
        animationName: "slide-to-top, fade-out"
      },
      "&[data-placement^=left]": {
        animationName: "slide-to-right, fade-out"
      },
      "&[data-placement^=right]": {
        animationName: "slide-to-left, fade-out"
      }
    }
  },
  "scale-fade-in": {
    value: {
      transformOrigin: "var(--transform-origin)",
      animationName: "scale-in, fade-in"
    }
  },
  "scale-fade-out": {
    value: {
      transformOrigin: "var(--transform-origin)",
      animationName: "scale-out, fade-out"
    }
  }
});

// src/core/theme/breakpoints.ts
var breakpoints = {
  mobile: "480px",
  tablet: "768px",
  desktop: "1160px"
};

// src/core/theme/global-css.ts
import { defineGlobalStyles } from "@chakra-ui/react";
var globalCss = defineGlobalStyles({
  "html, body, div, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
    margin: 0,
    padding: 0,
    border: 0,
    boxSizing: "border-box",
    fontSize: "100%",
    font: "generalSans",
    fontFamily: '"General Sans", system-ui, sans-serif',
    verticalAlign: "baseline"
  },
  // Span specific reset
  span: {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    fontSize: "100%",
    font: "inherit",
    verticalAlign: "baseline"
  },
  // HTML5 display-role reset for older browsers
  "article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section": {
    display: "block"
  },
  body: {
    lineHeight: 1
  },
  "ol, ul": {
    listStyle: "none"
  },
  "blockquote, q": {
    quotes: "none"
  },
  "blockquote:before, blockquote:after, q:before, q:after": {
    content: "''"
  },
  table: {
    borderCollapse: "collapse",
    borderSpacing: 0
  },
  html: {
    color: "generic.100",
    background: "generic.0",
    colorPalette: "neutral"
  },
  "::selection": {
    backgroundColor: "colorPalette.200"
  }
});

// src/core/theme/keyframes.ts
var keyframes = {
  spin: {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" }
  },
  pulse: {
    "50%": { opacity: 0.5 }
  },
  ping: {
    "75%, 100%": { transform: "scale(2)", opacity: 0 }
  },
  bounce: {
    "0%, 100%": { transform: "translateY(-25%)" },
    "50%": { transform: "translateY(0)" }
  },
  "fade-in": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  "fade-out": {
    from: { opacity: 1 },
    to: { opacity: 0 }
  },
  "slide-from-left-full": {
    from: { transform: "translateX(-100%)" },
    to: { transform: "translateX(0)" }
  },
  "slide-from-right-full": {
    from: { transform: "translateX(100%)" },
    to: { transform: "translateX(0)" }
  },
  "slide-from-top": {
    "0%": { translate: "0 -12px" },
    to: { translate: "0" }
  },
  "slide-from-bottom": {
    "0%": { translate: "0 12px" },
    to: { translate: "0" }
  },
  "slide-from-left": {
    "0%": { translate: "-0.5rem 0" },
    to: { translate: "0" }
  },
  "slide-from-right": {
    "0%": { translate: "0.5rem 0" },
    to: { translate: "0" }
  },
  "slide-from-top-full": {
    from: { transform: "translateY(-100%)" },
    to: { transform: "translateY(0)" }
  },
  "slide-from-bottom-full": {
    from: { transform: "translateY(100%)" },
    to: { transform: "translateY(0)" }
  },
  "slide-to-left-full": {
    from: { transform: "translateX(0)" },
    to: { transform: "translateX(-100%)" }
  },
  "slide-to-right-full": {
    from: { transform: "translateX(0)" },
    to: { transform: "translateX(100%)" }
  },
  "slide-to-top-full": {
    from: { transform: "translateY(0)" },
    to: { transform: "translateY(-100%)" }
  },
  "slide-to-bottom-full": {
    from: { transform: "translateY(0)" },
    to: { transform: "translateY(100%)" }
  },
  "scale-in": {
    from: { transform: "scale(0.95)" },
    to: { transform: "scale(1)" }
  },
  "scale-out": {
    from: { transform: "scale(1)" },
    to: { transform: "scale(0.95)" }
  },
  "circular-progress": {
    "0%": {
      strokeDasharray: "1, 400",
      strokeDashoffset: "0"
    },
    "50%": {
      strokeDasharray: "400, 400",
      strokeDashoffset: "-100%"
    },
    "100%": {
      strokeDasharray: "400, 400",
      strokeDashoffset: "-260%"
    }
  }
};

// src/core/theme/layer-styles.ts
import { defineLayerStyles } from "@chakra-ui/react";
var layerStyles = defineLayerStyles({
  "fill.muted": {
    value: {
      background: "colorPalette.muted",
      color: "colorPalette.fg"
    }
  },
  "fill.subtle": {
    value: {
      background: "colorPalette.subtle",
      color: "colorPalette.fg"
    }
  },
  "fill.surface": {
    value: {
      background: "colorPalette.subtle",
      color: "colorPalette.fg",
      boxShadow: "0 0 0px 1px var(--shadow-color)",
      boxShadowColor: "colorPalette.muted"
    }
  },
  "fill.solid": {
    value: {
      background: "colorPalette.solid",
      color: "colorPalette.contrast"
    }
  },
  "outline.subtle": {
    value: {
      color: "colorPalette.fg",
      boxShadow: "inset 0 0 0px 1px var(--shadow-color)",
      boxShadowColor: "colorPalette.subtle"
    }
  },
  "outline.solid": {
    value: {
      borderWidth: "1px",
      borderColor: "colorPalette.solid",
      color: "colorPalette.fg"
    }
  },
  "indicator.bottom": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        bottom: "var(--indicator-offset-y, 0)",
        insetInline: "var(--indicator-offset-x, 0)",
        height: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.top": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        top: "var(--indicator-offset-y, 0)",
        insetInline: "var(--indicator-offset-x, 0)",
        height: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.start": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        insetInlineStart: "var(--indicator-offset-x, 0)",
        insetBlock: "var(--indicator-offset-y, 0)",
        width: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.end": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        insetInlineEnd: "var(--indicator-offset-x, 0)",
        insetBlock: "var(--indicator-offset-y, 0)",
        width: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  disabled: {
    value: {
      opacity: "0.5",
      cursor: "not-allowed"
    }
  },
  none: {
    value: {}
  }
});

// src/core/theme/recipes/badge.ts
import { defineRecipe } from "@chakra-ui/react";
var badgeRecipe = defineRecipe({
  className: "chakra-badge",
  base: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "8px",
    gap: "4px",
    fontWeight: "500",
    // "medium" = 500
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
    userSelect: "none"
  },
  variants: {
    variant: {
      solid: {
        background: "colorPalette.solid",
        color: "colorPalette.contrast"
      },
      subtle: {
        background: "colorPalette.subtle",
        color: "colorPalette.fg"
      },
      outline: {
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      surface: {
        background: "colorPalette.subtle",
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      plain: {
        color: "colorPalette.fg"
      }
    },
    size: {
      xs: {
        fontSize: "10px",
        // '2xs'
        paddingX: "4px",
        minHeight: "16px"
      },
      sm: {
        fontSize: "12px",
        // 'xs'
        paddingX: "6px",
        minHeight: "20px"
      },
      md: {
        fontSize: "14px",
        // 'sm'
        paddingX: "8px",
        minHeight: "24px"
      },
      lg: {
        fontSize: "14px",
        // 'sm'
        paddingX: "10px",
        minHeight: "28px"
      }
    }
  },
  defaultVariants: {
    variant: "subtle",
    size: "sm"
  }
});

// src/core/theme/recipes/button.ts
import { defineRecipe as defineRecipe2 } from "@chakra-ui/react";
var buttonRecipe = defineRecipe2({
  className: "chakra-button",
  base: {
    display: "inline-flex",
    appearance: "none",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    position: "relative",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    borderWidth: "1px",
    borderColor: "transparent",
    cursor: "button",
    color: "white",
    flexShrink: "0",
    outline: "0",
    isolation: "isolate",
    fontWeight: "500",
    transitionProperty: "all",
    transitionDuration: "200ms",
    focusVisibleRing: "outside",
    backgroundColor: "brand.90",
    background: "brand.90",
    _disabled: {
      layerStyle: "disabled"
    },
    _icon: {
      flexShrink: "0"
    }
  },
  variants: {
    size: {
      "2xs": {
        height: "24px",
        minWidth: "24px",
        fontSize: "12px",
        paddingX: "8px",
        gap: "4px",
        _icon: {
          width: "14px",
          height: "14px"
        }
      },
      xs: {
        height: "32px",
        minWidth: "32px",
        fontSize: "12px",
        paddingX: "10px",
        gap: "4px",
        _icon: {
          width: "16px",
          height: "16px"
        }
      },
      sm: {
        height: "36px",
        minWidth: "36px",
        paddingX: "14px",
        fontSize: "14px",
        borderRadius: "4px",
        gap: "8px",
        _icon: {
          width: "16px",
          height: "16px"
        }
      },
      md: {
        height: "40px",
        minWidth: "40px",
        fontSize: "14px",
        paddingX: "16px",
        gap: "8px",
        borderRadius: "8px",
        _icon: {
          width: "20px",
          height: "20px"
        }
      },
      lg: {
        height: "44px",
        minWidth: "44px",
        fontSize: "16px",
        paddingX: "20px",
        gap: "12px",
        _icon: {
          width: "20px",
          height: "20px"
        }
      },
      xl: {
        height: "48px",
        minWidth: "48px",
        fontSize: "16px",
        paddingX: "20px",
        gap: "10px",
        _icon: {
          width: "20px",
          height: "20px"
        }
      },
      "2xl": {
        height: "64px",
        minWidth: "64px",
        fontSize: "18px",
        paddingX: "28px",
        gap: "12px",
        _icon: {
          width: "24px",
          height: "24px"
        }
      }
    },
    variant: {
      primary: {
        background: "colorPalette.90",
        color: "white",
        _hover: {
          background: "colorPalette.80"
        },
        _expanded: {
          background: "colorPalette.70"
        }
      },
      secondary: {
        borderWidth: "1px",
        borderColor: "colorPalette.muted",
        color: "colorPalette.fg",
        _hover: {
          background: "colorPalette.subtle"
        },
        _expanded: {
          background: "colorPalette.subtle"
        }
      },
      ghost: {
        background: "transparent",
        color: "colorPalette.90",
        _hover: {
          background: "neutral.10/10"
        }
        // _expanded: {
        //   background: 'colorPalette.subtle',
        // },
      },
      plain: {
        color: "colorPalette.fg"
      },
      outline: {
        background: "transparent",
        borderColor: "colorPalette.20",
        color: "colorPalette.fg",
        _hover: {
          background: "colorPalette.20"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "primary"
  }
});

// src/core/theme/recipes/code.ts
import { defineRecipe as defineRecipe3 } from "@chakra-ui/react";
var codeRecipe = defineRecipe3({
  className: "chakra-code",
  base: {
    fontFamily: "mono",
    alignItems: "center",
    display: "inline-flex",
    borderRadius: "8px"
  },
  variants: {
    variant: {
      solid: {
        background: "colorPalette.solid",
        color: "colorPalette.contrast"
      },
      subtle: {
        background: "colorPalette.subtle",
        color: "colorPalette.fg"
      },
      outline: {
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      surface: {
        background: "colorPalette.subtle",
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      plain: {
        color: "colorPalette.fg"
      }
    },
    size: {
      xs: {
        fontSize: "10px",
        paddingX: "4px",
        minHeight: "16px"
      },
      sm: {
        fontSize: "12px",
        paddingX: "6px",
        minHeight: "20px"
      },
      md: {
        fontSize: "14px",
        paddingX: "8px",
        minHeight: "24px"
      },
      lg: {
        fontSize: "14px",
        paddingX: "10px",
        minHeight: "28px"
      }
    }
  },
  defaultVariants: {
    variant: "subtle",
    size: "sm"
  }
});

// src/core/theme/recipes/container.ts
import { defineRecipe as defineRecipe4 } from "@chakra-ui/react";
var containerRecipe = defineRecipe4({
  className: "chakra-container",
  base: {
    position: "relative",
    maxWidth: "1280px",
    width: "100%",
    marginX: "auto",
    paddingX: {
      base: "16px",
      tablet: "24px",
      desktop: "32px"
    }
  },
  variants: {
    centerContent: {
      true: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }
    },
    fluid: {
      true: {
        maxWidth: "100%"
      }
    }
  }
});

// src/core/theme/recipes/heading.ts
import { defineRecipe as defineRecipe5 } from "@chakra-ui/react";
var FONT_FAMILY = "var(--general-sans)";
var headingRecipe = defineRecipe5({
  className: "chakra-heading",
  base: {
    fontFamily: FONT_FAMILY,
    fontWeight: "bold"
  },
  variants: {
    size: {
      xs: {
        textStyle: "xs"
      },
      sm: {
        textStyle: "sm"
      },
      md: {
        textStyle: "md"
      },
      lg: {
        textStyle: "lg"
      },
      xl: {
        textStyle: "xl"
      },
      "2xl": {
        textStyle: "2xl"
      },
      "3xl": {
        textStyle: "3xl"
      },
      "4xl": {
        textStyle: "4xl"
      },
      "5xl": {
        textStyle: "5xl"
      },
      "6xl": {
        textStyle: "6xl"
      },
      "7xl": {
        textStyle: "7xl"
      }
    }
  },
  defaultVariants: {
    size: "xl"
  }
});

// src/core/theme/recipes/input.ts
import { defineRecipe as defineRecipe6 } from "@chakra-ui/react";
var inputRecipe = defineRecipe6({
  className: "chakra-input",
  base: {
    width: "100%",
    outline: "0",
    position: "relative",
    appearance: "none",
    textAlign: "start",
    borderRadius: "8px",
    _disabled: {
      layerStyle: "disabled"
    },
    height: "var(--input-height)",
    minWidth: "var(--input-height)",
    "--focus-color": "colors.colorPalette.focusRing",
    "--error-color": "colors.border.error",
    _invalid: {
      focusRingColor: "var(--error-color)",
      borderColor: "var(--error-color)"
    }
  },
  variants: {
    size: {
      "2xs": {
        fontSize: "12px",
        paddingX: "8px",
        "--input-height": "28px"
      },
      xs: {
        fontSize: "12px",
        paddingX: "8px",
        "--input-height": "32px"
      },
      sm: {
        fontSize: "14px",
        paddingX: "10px",
        "--input-height": "36px"
      },
      md: {
        fontSize: "14px",
        paddingX: "12px",
        "--input-height": "40px"
      },
      lg: {
        fontSize: "16px",
        paddingX: "16px",
        "--input-height": "44px"
      },
      xl: {
        fontSize: "16px",
        paddingX: "18px",
        "--input-height": "48px"
      },
      "2xl": {
        fontSize: "18px",
        paddingX: "20px",
        "--input-height": "64px"
      }
    },
    variant: {
      outline: {
        background: "transparent",
        borderWidth: "1px",
        borderColor: "border",
        focusVisibleRing: "inside"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        background: "bg.muted",
        focusVisibleRing: "inside"
      },
      flushed: {
        background: "transparent",
        borderBottomWidth: "1px",
        borderBottomColor: "border",
        borderRadius: "0px",
        paddingX: "0px",
        _focusVisible: {
          borderColor: "var(--focus-color)",
          boxShadow: "0px 1px 0px 0px var(--focus-color)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/recipes/input-addon.ts
import { defineRecipe as defineRecipe7 } from "@chakra-ui/react";
var inputAddonRecipe = defineRecipe7({
  className: "chakra-input-addon",
  base: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    alignSelf: "stretch",
    borderRadius: "8px"
  },
  variants: {
    size: {
      "2xs": {
        fontSize: "12px",
        paddingX: "8px",
        "--input-height": "28px"
      },
      xs: {
        fontSize: "12px",
        paddingX: "8px",
        "--input-height": "32px"
      },
      sm: {
        fontSize: "14px",
        paddingX: "10px",
        "--input-height": "36px"
      },
      md: {
        fontSize: "14px",
        paddingX: "12px",
        "--input-height": "40px"
      },
      lg: {
        fontSize: "16px",
        paddingX: "16px",
        "--input-height": "44px"
      },
      xl: {
        fontSize: "16px",
        paddingX: "18px",
        "--input-height": "48px"
      },
      "2xl": {
        fontSize: "18px",
        paddingX: "20px",
        "--input-height": "64px"
      }
    },
    variant: {
      outline: {
        borderWidth: "1px",
        borderColor: "border",
        background: "bg.muted"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        background: "bg.emphasized"
      },
      flushed: {
        borderBottom: "1px solid",
        borderColor: "inherit",
        borderRadius: "0px",
        paddingX: "0px",
        background: "transparent"
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/recipes/kbd.ts
import { defineRecipe as defineRecipe8 } from "@chakra-ui/react";
var kbdRecipe = defineRecipe8({
  className: "chakra-kbd",
  base: {
    display: "inline-flex",
    alignItems: "center",
    fontWeight: "medium",
    fontFamily: "mono",
    flexShrink: "0",
    whiteSpace: "nowrap",
    wordSpacing: "-0.5em",
    userSelect: "none",
    paddingX: "1",
    borderRadius: "8px"
  },
  variants: {
    variant: {
      raised: {
        background: "colorPalette.subtle",
        color: "colorPalette.fg",
        borderWidth: "1px",
        borderBottomWidth: "2px",
        borderColor: "colorPalette.muted"
      },
      outline: {
        borderWidth: "1px",
        color: "colorPalette.fg"
      },
      subtle: {
        background: "colorPalette.muted",
        color: "colorPalette.fg"
      },
      plain: {
        color: "colorPalette.fg"
      }
    },
    size: {
      sm: {
        textStyle: "xs",
        height: "4.5"
      },
      md: {
        textStyle: "sm",
        height: "5"
      },
      lg: {
        textStyle: "md",
        height: "6"
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "raised"
  }
});

// src/core/theme/recipes/link.ts
import { defineRecipe as defineRecipe9 } from "@chakra-ui/react";
var linkRecipe = defineRecipe9({
  className: "chakra-link",
  base: {
    display: "inline-flex",
    alignItems: "center",
    outline: "none",
    gap: "1.5",
    cursor: "pointer",
    borderRadius: "4px",
    focusVisibleRing: "outside",
    colorPalette: "neutral"
  },
  variants: {
    variant: {
      underline: {
        color: "colorPalette.fg",
        textDecoration: "underline",
        textUnderlineOffset: "3px",
        textDecorationColor: "currentColor/20"
      },
      plain: {
        color: "colorPalette.fg",
        _hover: {
          textDecoration: "underline",
          textUnderlineOffset: "3px",
          textDecorationColor: "currentColor/20"
        }
      }
    }
  },
  defaultVariants: {
    variant: "plain"
  }
});

// src/core/theme/recipes/mark.ts
import { defineRecipe as defineRecipe10 } from "@chakra-ui/react";
var markRecipe = defineRecipe10({
  className: "chakra-mark",
  base: {
    background: "transparent",
    color: "inherit",
    whiteSpace: "nowrap"
  },
  variants: {
    variant: {
      subtle: {
        background: "colorPalette.subtle",
        color: "inherit"
      },
      solid: {
        background: "colorPalette.solid",
        color: "colorPalette.contrast"
      },
      text: {
        fontWeight: "medium"
      },
      plain: {}
    }
  }
});

// src/core/theme/recipes/separator.ts
import { defineRecipe as defineRecipe11 } from "@chakra-ui/react";
var separatorRecipe = defineRecipe11({
  className: "chakra-separator",
  base: {
    display: "block",
    borderColor: "border"
  },
  variants: {
    variant: {
      solid: {
        borderStyle: "solid"
      },
      dashed: {
        borderStyle: "dashed"
      },
      dotted: {
        borderStyle: "dotted"
      }
    },
    orientation: {
      vertical: {
        borderInlineStartWidth: "var(--separator-thickness)"
      },
      horizontal: {
        borderTopWidth: "var(--separator-thickness)"
      }
    },
    size: {
      xs: {
        "--separator-thickness": "0.5px"
      },
      sm: {
        "--separator-thickness": "1px"
      },
      md: {
        "--separator-thickness": "2px"
      },
      lg: {
        "--separator-thickness": "3px"
      }
    }
  },
  defaultVariants: {
    size: "sm",
    variant: "solid",
    orientation: "horizontal"
  }
});

// src/core/theme/recipes/skeleton.ts
import { defineRecipe as defineRecipe12 } from "@chakra-ui/react";
var skeletonRecipe = defineRecipe12({
  className: "chakra-skeleton",
  base: {},
  variants: {
    loading: {
      true: {
        borderRadius: "8px",
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        flexShrink: "0",
        "&::before, &::after, *": {
          visibility: "hidden"
        }
      },
      false: {
        background: "unset",
        animation: "fade-in var(--fade-duration, 0.1s) ease-out !important"
      }
    },
    variant: {
      pulse: {
        background: "neutral.100",
        animation: "pulse",
        animationDuration: "var(--duration, 1.2s)"
      },
      shine: {
        "--animate-from": "200%",
        "--animate-to": "-200%",
        "--start-color": "colors.neutral.100",
        "--end-color": "colors.neutral.50",
        backgroundImage: "linear-gradient(270deg,var(--start-color),var(--end-color),var(--end-color),var(--start-color))",
        backgroundSize: "400% 100%",
        animation: "bg-position var(--duration, 5s) ease-in-out infinite"
      },
      none: {
        animation: "none"
      }
    }
  },
  defaultVariants: {
    variant: "pulse",
    loading: true
  }
});

// src/core/theme/recipes/skip-nav-link.ts
import { defineRecipe as defineRecipe13 } from "@chakra-ui/react";
var skipNavLinkRecipe = defineRecipe13({
  className: "chakra-skip-nav",
  base: {
    display: "inline-flex",
    background: "bg.panel",
    padding: "2.5",
    borderRadius: "8px",
    fontWeight: "semibold",
    focusVisibleRing: "outside",
    textStyle: "sm",
    userSelect: "none",
    border: "0",
    height: "1px",
    width: "1px",
    margin: "-1px",
    outline: "0",
    overflow: "hidden",
    position: "absolute",
    clip: "rect(0 0 0 0)",
    _focusVisible: {
      clip: "auto",
      width: "auto",
      height: "auto",
      position: "fixed",
      top: "6",
      insetStart: "6"
    }
  }
});

// src/core/theme/recipes/spinner.ts
import { defineRecipe as defineRecipe14 } from "@chakra-ui/react";
var spinnerRecipe = defineRecipe14({
  className: "chakra-spinner",
  base: {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "50%",
    width: "var(--spinner-size)",
    height: "var(--spinner-size)",
    animation: "spin",
    animationDuration: "slowest",
    "--spinner-track-color": "transparent",
    borderBottomColor: "var(--spinner-track-color)",
    borderInlineStartColor: "var(--spinner-track-color)"
  },
  variants: {
    size: {
      inherit: {
        "--spinner-size": "1em"
      },
      xs: {
        "--spinner-size": "12px"
      },
      sm: {
        "--spinner-size": "16px"
      },
      md: {
        "--spinner-size": "20px"
      },
      lg: {
        "--spinner-size": "32px"
      },
      xl: {
        "--spinner-size": "40px"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/recipes/textarea.ts
import { defineRecipe as defineRecipe15 } from "@chakra-ui/react";
var textareaRecipe = defineRecipe15({
  className: "chakra-textarea",
  base: {
    width: "100%",
    minWidth: "0",
    outline: "0",
    position: "relative",
    appearance: "none",
    textAlign: "start",
    borderRadius: "8px",
    _disabled: {
      layerStyle: "disabled"
    },
    "--focus-color": "colors.colorPalette.focusRing",
    "--error-color": "colors.border.error",
    _invalid: {
      focusRingColor: "var(--error-color)",
      borderColor: "var(--error-color)"
    }
  },
  variants: {
    size: {
      xs: {
        fontSize: "12px",
        paddingX: "8px",
        paddingY: "6px",
        scrollPaddingBottom: "6px"
      },
      sm: {
        fontSize: "14px",
        paddingX: "10px",
        paddingY: "8px",
        scrollPaddingBottom: "8px"
      },
      md: {
        fontSize: "14px",
        paddingX: "12px",
        paddingY: "8px",
        scrollPaddingBottom: "8px"
      },
      lg: {
        fontSize: "16px",
        paddingX: "16px",
        paddingY: "12px",
        scrollPaddingBottom: "12px"
      },
      xl: {
        fontSize: "16px",
        paddingX: "18px",
        paddingY: "14px",
        scrollPaddingBottom: "14px"
      }
    },
    variant: {
      outline: {
        background: "transparent",
        borderWidth: "1px",
        borderColor: "border",
        focusVisibleRing: "inside"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        background: "bg.muted",
        focusVisibleRing: "inside"
      },
      flushed: {
        background: "transparent",
        borderBottomWidth: "1px",
        borderBottomColor: "border",
        borderRadius: "0px",
        paddingX: "0px",
        _focusVisible: {
          borderColor: "var(--focus-color)",
          boxShadow: "0px 1px 0px 0px var(--focus-color)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/recipes/icon.ts
import { defineRecipe as defineRecipe16 } from "@chakra-ui/react";
var iconRecipe = defineRecipe16({
  className: "chakra-icon",
  base: {
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: "0",
    color: "currentcolor",
    verticalAlign: "middle"
  },
  variants: {
    size: {
      inherit: {},
      xs: {
        boxSize: "12px"
      },
      sm: {
        boxSize: "16px"
      },
      md: {
        boxSize: "20px"
      },
      lg: {
        boxSize: "24px"
      },
      xl: {
        boxSize: "28px"
      },
      "2xl": {
        boxSize: "32px"
      }
    }
  },
  defaultVariants: {
    size: "inherit"
  }
});

// src/core/theme/recipes/checkmark.ts
import { defineRecipe as defineRecipe17 } from "@chakra-ui/react";
var checkmarkRecipe = defineRecipe17({
  className: "chakra-checkmark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    color: "white",
    borderWidth: "1px",
    borderColor: "transparent",
    borderRadius: "4px",
    focusVisibleRing: "outside",
    _icon: {
      boxSize: "100%"
    },
    _invalid: {
      colorPalette: "red",
      borderColor: "border.error"
    },
    _disabled: {
      opacity: "0.5"
    }
  },
  variants: {
    size: {
      xs: {
        boxSize: "12px"
      },
      sm: {
        boxSize: "16px"
      },
      md: {
        boxSize: "20px",
        padding: "2px"
      },
      lg: {
        boxSize: "24px",
        padding: "2px"
      }
    },
    variant: {
      solid: {
        borderColor: "border",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          background: "colorPalette.solid",
          color: "colorPalette.contrast",
          borderColor: "colorPalette.solid"
        }
      },
      outline: {
        borderColor: "border",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg",
          borderColor: "colorPalette.solid"
        }
      },
      subtle: {
        background: "colorPalette.muted",
        borderColor: "colorPalette.muted",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg"
        }
      },
      plain: {
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg"
        }
      },
      inverted: {
        borderColor: "border",
        color: "colorPalette.fg",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          borderColor: "colorPalette.solid"
        }
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
});

// src/core/theme/recipes/radiomark.ts
import { defineRecipe as defineRecipe18 } from "@chakra-ui/react";
var radiomarkRecipe = defineRecipe18({
  className: "chakra-radiomark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    verticalAlign: "top",
    color: "white",
    borderWidth: "1px",
    borderColor: "transparent",
    borderRadius: "full",
    cursor: "radio",
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "colorPalette.focusRing",
      outlineOffset: "2px"
    },
    _invalid: {
      colorPalette: "red",
      borderColor: "red.50"
    },
    _disabled: {
      opacity: "0.5",
      cursor: "disabled"
    },
    "& .dot": {
      height: "100%",
      width: "100%",
      borderRadius: "full",
      background: "currentColor",
      scale: "0.4"
    }
  },
  variants: {
    variant: {
      solid: {
        borderWidth: "1px",
        borderColor: "border",
        _checked: {
          background: "colorPalette.solid",
          color: "colorPalette.contrast",
          borderColor: "colorPalette.solid"
        }
      },
      subtle: {
        borderWidth: "1px",
        background: "colorPalette.muted",
        borderColor: "colorPalette.muted",
        color: "transparent",
        _checked: {
          color: "colorPalette.fg"
        }
      },
      outline: {
        borderWidth: "1px",
        borderColor: "inherit",
        _checked: {
          color: "colorPalette.fg",
          borderColor: "colorPalette.solid"
        },
        "& .dot": {
          scale: "0.6"
        }
      },
      inverted: {
        background: "bg",
        borderWidth: "1px",
        borderColor: "inherit",
        _checked: {
          color: "colorPalette.solid",
          borderColor: "currentcolor"
        }
      }
    },
    size: {
      xs: {
        boxSize: "3"
      },
      sm: {
        boxSize: "4"
      },
      md: {
        boxSize: "5"
      },
      lg: {
        boxSize: "6"
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
});

// src/core/theme/recipes/color-swatch.ts
import { defineRecipe as defineRecipe19 } from "@chakra-ui/react";
var colorSwatchRecipe = defineRecipe19({
  className: "color-swatch",
  base: {
    boxSize: "var(--swatch-size)",
    shadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
    "--checker-size": "8px",
    "--checker-bg": "colors.bg",
    "--checker-fg": "colors.bg.emphasized",
    background: "linear-gradient(var(--color), var(--color)), repeating-conic-gradient(var(--checker-fg) 0%, var(--checker-fg) 25%, var(--checker-bg) 0%, var(--checker-bg) 50%) 0% 50% / var(--checker-size) var(--checker-size) !important",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0"
  },
  variants: {
    size: {
      "2xs": {
        "--swatch-size": "14px"
      },
      xs: {
        "--swatch-size": "16px"
      },
      sm: {
        "--swatch-size": "18px"
      },
      md: {
        "--swatch-size": "20px"
      },
      lg: {
        "--swatch-size": "24px"
      },
      xl: {
        "--swatch-size": "28px"
      },
      "2xl": {
        "--swatch-size": "32px"
      },
      inherit: {
        "--swatch-size": "inherit"
      },
      full: {
        "--swatch-size": "100%"
      }
    },
    shape: {
      square: {
        borderRadius: "0px"
      },
      circle: {
        borderRadius: "50%"
      },
      rounded: {
        borderRadius: "4px"
      }
    }
  },
  defaultVariants: {
    size: "md",
    shape: "rounded"
  }
});

// src/core/theme/recipes/index.ts
var recipes = {
  badge: badgeRecipe,
  button: buttonRecipe,
  code: codeRecipe,
  container: containerRecipe,
  heading: headingRecipe,
  input: inputRecipe,
  inputAddon: inputAddonRecipe,
  kbd: kbdRecipe,
  link: linkRecipe,
  mark: markRecipe,
  separator: separatorRecipe,
  skeleton: skeletonRecipe,
  skipNavLink: skipNavLinkRecipe,
  spinner: spinnerRecipe,
  textarea: textareaRecipe,
  icon: iconRecipe,
  checkmark: checkmarkRecipe,
  radiomark: radiomarkRecipe,
  colorSwatch: colorSwatchRecipe
};

// src/core/theme/semantic-tokens/colors.ts
import { defineSemanticTokens } from "@chakra-ui/react";
var colors = defineSemanticTokens.colors({
  bg: {
    DEFAULT: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    primary: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    secondary: {
      value: {
        _light: "{colors.neutral.5}"
      }
    },
    tertiary: {
      value: {
        _light: "{colors.brand.50}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.5}",
        _dark: "{colors.neutral.40}"
      }
    },
    muted: {
      value: {
        _light: "{colors.neutral.10}",
        _dark: "{colors.neutral.90}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.neutral.20}",
        _dark: "{colors.neutral.80}"
      }
    },
    inverted: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    panel: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.neutral.40}"
      }
    },
    error: {
      value: {
        _light: "{colors.red.5}",
        _dark: "{colors.red.950}"
      }
    },
    warning: {
      value: {
        _light: "{colors.orange.5}",
        _dark: "{colors.orange.950}"
      }
    },
    success: {
      value: {
        _light: "{colors.green.5}",
        _dark: "{colors.green.950}"
      }
    },
    info: {
      value: {
        _light: "{colors.blue.5}",
        _dark: "{colors.blue.950}"
      }
    }
  },
  text: {
    DEFAULT: {
      value: {
        _light: "{colors.neutral.80}"
      }
    },
    strong: {
      value: {
        _light: "{colors.neutral.100}"
      }
    },
    "strong.inverse": {
      value: {
        _light: "{colors.neutral.10}"
      }
    },
    primary: {
      value: {
        _light: "{colors.neutral.80}"
      }
    },
    "primary.inverse": {
      value: {
        _light: "{colors.neutral.10}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.50}"
      }
    },
    "subtle.inverse": {
      value: {
        _light: "{colors.neutral.20}"
      }
    }
  },
  stroke: {
    DEFAULT: {
      value: {
        _light: "{colors.neutral.5}"
      }
    },
    primary: {
      value: {
        _light: "{colors.neutral.5}"
      }
    },
    strong: {
      value: {
        _light: "{colors.neutral.20}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.10}"
      }
    }
  },
  status: {
    positive: {
      value: {
        _light: "{colors.green.60}"
      }
    },
    negative: {
      value: {
        _light: "{colors.red.60}"
      }
    },
    cautionary: {
      value: {
        _light: "{colors.orange.60}"
      }
    }
  },
  fg: {
    DEFAULT: {
      value: {
        _light: "{colors.common.0}",
        _dark: "{colors.common.100}"
      }
    },
    muted: {
      value: {
        _light: "{colors.neutral.60}",
        _dark: "{colors.neutral.40}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.40}",
        _dark: "{colors.neutral.50}"
      }
    },
    inverted: {
      value: {
        _light: "{colors.neutral.5}",
        _dark: "{colors.common.0}"
      }
    },
    error: {
      value: {
        _light: "{colors.red.50}",
        _dark: "{colors.red.40}"
      }
    },
    warning: {
      value: {
        _light: "{colors.orange.60}",
        _dark: "{colors.orange.30}"
      }
    },
    success: {
      value: {
        _light: "{colors.green.60}",
        _dark: "{colors.green.30}"
      }
    },
    info: {
      value: {
        _light: "{colors.blue.60}",
        _dark: "{colors.blue.30}"
      }
    }
  },
  border: {
    DEFAULT: {
      value: {
        _light: "{colors.neutral.20}",
        _dark: "{colors.neutral.80}"
      }
    },
    muted: {
      value: {
        _light: "{colors.neutral.10}",
        _dark: "{colors.neutral.90}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.5}",
        _dark: "{colors.neutral.40}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.neutral.30}",
        _dark: "{colors.neutral.70}"
      }
    },
    inverted: {
      value: {
        _light: "{colors.neutral.80}",
        _dark: "{colors.neutral.20}"
      }
    },
    error: {
      value: {
        _light: "{colors.red.50}",
        _dark: "{colors.red.40}"
      }
    },
    warning: {
      value: {
        _light: "{colors.orange.50}",
        _dark: "{colors.orange.40}"
      }
    },
    success: {
      value: {
        _light: "{colors.green.50}",
        _dark: "{colors.green.40}"
      }
    },
    info: {
      value: {
        _light: "{colors.blue.50}",
        _dark: "{colors.blue.40}"
      }
    }
  },
  neutral: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.neutral.80}",
        _dark: "{colors.neutral.20}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.neutral.10}",
        _dark: "{colors.neutral.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.neutral.20}",
        _dark: "{colors.neutral.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.neutral.30}",
        _dark: "{colors.neutral.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.brand.90}",
        _dark: "{colors.common.0}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.neutral.80}",
        _dark: "{colors.neutral.20}"
      }
    }
  },
  red: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.red.70}",
        _dark: "{colors.red.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.red.10}",
        _dark: "{colors.red.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.red.20}",
        _dark: "{colors.red.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.red.30}",
        _dark: "{colors.red.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.red.60}",
        _dark: "{colors.red.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.red.60}",
        _dark: "{colors.red.60}"
      }
    }
  },
  orange: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "common.0"
      }
    },
    fg: {
      value: {
        _light: "{colors.orange.70}",
        _dark: "{colors.orange.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.orange.10}",
        _dark: "{colors.orange.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.orange.20}",
        _dark: "{colors.orange.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.orange.30}",
        _dark: "{colors.orange.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.orange.60}",
        _dark: "{colors.orange.50}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.orange.60}",
        _dark: "{colors.orange.50}"
      }
    }
  },
  green: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.green.70}",
        _dark: "{colors.green.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.green.10}",
        _dark: "{colors.green.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.green.20}",
        _dark: "{colors.green.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.green.30}",
        _dark: "{colors.green.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.green.60}",
        _dark: "{colors.green.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.green.60}",
        _dark: "{colors.green.60}"
      }
    }
  },
  blue: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.blue.70}",
        _dark: "{colors.blue.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.blue.10}",
        _dark: "{colors.blue.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.blue.20}",
        _dark: "{colors.blue.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.blue.30}",
        _dark: "{colors.blue.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.blue.60}",
        _dark: "{colors.blue.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.blue.60}",
        _dark: "{colors.blue.60}"
      }
    }
  },
  yellow: {
    contrast: {
      value: {
        _light: "common.0",
        _dark: "common.0"
      }
    },
    fg: {
      value: {
        _light: "{colors.yellow.80}",
        _dark: "{colors.yellow.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.yellow.10}",
        _dark: "{colors.yellow.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.yellow.20}",
        _dark: "{colors.yellow.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.yellow.30}",
        _dark: "{colors.yellow.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.yellow.30}",
        _dark: "{colors.yellow.30}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.yellow.30}",
        _dark: "{colors.yellow.30}"
      }
    }
  },
  teal: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.teal.70}",
        _dark: "{colors.teal.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.teal.10}",
        _dark: "{colors.teal.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.teal.20}",
        _dark: "{colors.teal.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.teal.30}",
        _dark: "{colors.teal.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.teal.60}",
        _dark: "{colors.teal.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.teal.60}",
        _dark: "{colors.teal.60}"
      }
    }
  },
  purple: {
    contrast: {
      value: {
        _light: "{colors.common.100}",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.purple.70}",
        _dark: "{colors.purple.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.purple.10}",
        _dark: "{colors.purple.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.purple.20}",
        _dark: "{colors.purple.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.purple.30}",
        _dark: "{colors.purple.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.purple.60}",
        _dark: "{colors.purple.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.purple.60}",
        _dark: "{colors.purple.60}"
      }
    }
  },
  pink: {
    contrast: {
      value: {
        _light: "common.0",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.pink.70}",
        _dark: "{colors.pink.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.pink.10}",
        _dark: "{colors.pink.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.pink.20}",
        _dark: "{colors.pink.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.pink.30}",
        _dark: "{colors.pink.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.pink.60}",
        _dark: "{colors.pink.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.pink.60}",
        _dark: "{colors.pink.60}"
      }
    }
  },
  cyan: {
    contrast: {
      value: {
        _light: "common.0",
        _dark: "{colors.common.0}"
      }
    },
    fg: {
      value: {
        _light: "{colors.cyan.70}",
        _dark: "{colors.cyan.30}"
      }
    },
    subtle: {
      value: {
        _light: "{colors.cyan.10}",
        _dark: "{colors.cyan.90}"
      }
    },
    muted: {
      value: {
        _light: "{colors.cyan.20}",
        _dark: "{colors.cyan.80}"
      }
    },
    emphasized: {
      value: {
        _light: "{colors.cyan.30}",
        _dark: "{colors.cyan.70}"
      }
    },
    solid: {
      value: {
        _light: "{colors.cyan.60}",
        _dark: "{colors.cyan.60}"
      }
    },
    focusRing: {
      value: {
        _light: "{colors.cyan.60}",
        _dark: "{colors.cyan.60}"
      }
    }
  }
});

// src/core/theme/semantic-tokens/shadows.ts
import { defineSemanticTokens as defineSemanticTokens2 } from "@chakra-ui/react";
var shadows = defineSemanticTokens2.shadows({
  xs: {
    value: {
      _light: "0px 1px 2px {colors.neutral.90/10}, 0px 0px 1px {colors.neutral.90/20}",
      _dark: "0px 1px 1px {black/64}, 0px 0px 1px inset {colors.neutral.30/20}"
    }
  },
  sm: {
    value: {
      _light: "0px 2px 4px {colors.neutral.90/10}, 0px 0px 1px {colors.neutral.90/30}",
      _dark: "0px 2px 4px {black/64}, 0px 0px 1px inset {colors.neutral.30/30}"
    }
  },
  md: {
    value: {
      _light: "0px 4px 8px {colors.neutral.90/10}, 0px 0px 1px {colors.neutral.90/30}",
      _dark: "0px 4px 8px {black/64}, 0px 0px 1px inset {colors.neutral.30/30}"
    }
  },
  lg: {
    value: {
      _light: "0px 8px 16px {colors.neutral.90/10}, 0px 0px 1px {colors.neutral.90/30}",
      _dark: "0px 8px 16px {black/64}, 0px 0px 1px inset {colors.neutral.30/30}"
    }
  },
  xl: {
    value: {
      _light: "0px 16px 24px {colors.neutral.90/10}, 0px 0px 1px {colors.neutral.90/30}",
      _dark: "0px 16px 24px {black/64}, 0px 0px 1px inset {colors.neutral.30/30}"
    }
  },
  "2xl": {
    value: {
      _light: "0px 24px 40px {colors.neutral.90/16}, 0px 0px 1px {colors.neutral.90/30}",
      _dark: "0px 24px 40px {black/64}, 0px 0px 1px inset {colors.neutral.30/30}"
    }
  },
  inner: {
    value: {
      _light: "inset 0 2px 4px 0 {black/5}",
      _dark: "inset 0 2px 4px 0 black"
    }
  },
  inset: {
    value: {
      _light: "inset 0 0 0 1px {black/5}",
      _dark: "inset 0 0 0 1px {colors.neutral.30/5}"
    }
  }
});

// src/core/theme/semantic-tokens/radii.ts
import { defineSemanticTokens as defineSemanticTokens3 } from "@chakra-ui/react";
var radii = defineSemanticTokens3.radii({
  l1: {
    value: "{radii.xs}"
  },
  l2: {
    value: "{radii.sm}"
  },
  l3: {
    value: "{radii.md}"
  }
});

// src/core/theme/semantic-tokens/index.ts
var semanticTokens = {
  colors,
  shadows,
  radii
};

// src/core/theme/slot-recipes/accordion.ts
import { defineSlotRecipe } from "@chakra-ui/react";
var accordionSlotRecipe = defineSlotRecipe({
  className: "chakra-accordion",
  slots: ["root", "item", "itemTrigger", "itemContent", "itemIndicator", "itemBody"],
  base: {
    root: {
      width: "100%",
      "--accordion-radius": "8px"
    },
    item: {
      overflowAnchor: "none"
    },
    itemTrigger: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: "0",
      gap: "12px",
      fontWeight: "500",
      borderRadius: "var(--accordion-radius)",
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing"
      },
      _disabled: {
        layerStyle: "disabled"
      }
    },
    itemBody: {
      paddingTop: "var(--accordion-padding-y)",
      paddingBottom: "calc(var(--accordion-padding-y) * 2)"
    },
    itemContent: {
      overflow: "hidden",
      borderRadius: "var(--accordion-radius)",
      _open: {
        animationName: "expand-height, fade-in",
        animationDuration: "default"
      },
      _closed: {
        animationName: "collapse-height, fade-out",
        animationDuration: "default"
      }
    },
    itemIndicator: {
      transition: "rotate 0.2s",
      transformOrigin: "center",
      color: "fg.subtle",
      _open: {
        rotate: "180deg"
      },
      _icon: {
        width: "1.2em",
        height: "1.2em"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        item: {
          borderBottomWidth: "1px"
        }
      },
      subtle: {
        itemTrigger: {
          paddingX: "var(--accordion-padding-x)"
        },
        itemContent: {
          paddingX: "var(--accordion-padding-x)"
        },
        item: {
          borderRadius: "var(--accordion-radius)",
          _open: {
            background: "colorPalette.subtle"
          }
        }
      },
      enclosed: {
        root: {
          borderWidth: "1px",
          borderRadius: "var(--accordion-radius)",
          divideY: "1px",
          overflow: "hidden"
        },
        itemTrigger: {
          paddingX: "var(--accordion-padding-x)"
        },
        itemContent: {
          paddingX: "var(--accordion-padding-x)"
        },
        item: {
          _open: {
            background: "bg.subtle"
          }
        }
      },
      plain: {}
    },
    size: {
      sm: {
        root: {
          "--accordion-padding-x": "12px",
          "--accordion-padding-y": "8px"
        },
        itemTrigger: {
          fontSize: "14px",
          paddingY: "var(--accordion-padding-y)"
        }
      },
      md: {
        root: {
          "--accordion-padding-x": "16px",
          "--accordion-padding-y": "8px"
        },
        itemTrigger: {
          fontSize: "16px",
          paddingY: "var(--accordion-padding-y)"
        }
      },
      lg: {
        root: {
          "--accordion-padding-x": "18px",
          "--accordion-padding-y": "10px"
        },
        itemTrigger: {
          fontSize: "18px",
          paddingY: "var(--accordion-padding-y)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/action-bar.ts
import { defineSlotRecipe as defineSlotRecipe2 } from "@chakra-ui/react";
var actionBarSlotRecipe = defineSlotRecipe2({
  className: "chakra-action-bar",
  slots: ["positioner", "content", "separator", "selectionTrigger", "closeTrigger"],
  base: {
    positioner: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      pointerEvents: "none",
      insetInline: "0",
      top: "unset",
      bottom: "calc(env(safe-area-inset-bottom) + 20px)"
    },
    content: {
      background: "bg.panel",
      shadow: "md",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      borderRadius: "12px",
      paddingY: "10px",
      paddingX: "12px",
      pointerEvents: "auto",
      translate: "calc(-1 * var(--scrollbar-width) / 2) 0px",
      _open: {
        animationName: "slide-from-bottom, fade-in",
        animationDuration: "default"
      },
      _closed: {
        animationName: "slide-to-bottom, fade-out",
        animationDuration: "faster"
      }
    },
    separator: {
      width: "1px",
      height: "20px",
      background: "border"
    },
    selectionTrigger: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      alignSelf: "stretch",
      fontSize: "14px",
      paddingX: "16px",
      paddingY: "4px",
      borderRadius: "8px",
      borderWidth: "1px",
      borderStyle: "dashed"
    }
  }
});

// src/core/theme/slot-recipes/alert.ts
import { defineSlotRecipe as defineSlotRecipe3 } from "@chakra-ui/react";
var alertSlotRecipe = defineSlotRecipe3({
  slots: ["title", "description", "root", "indicator", "content"],
  className: "chakra-alert",
  base: {
    root: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      position: "relative",
      borderRadius: "12px"
    },
    title: {
      fontWeight: "500"
    },
    description: {
      display: "inline"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      width: "1em",
      height: "1em",
      _icon: {
        boxSize: "100%"
      }
    },
    content: {
      display: "flex",
      flex: "1",
      gap: "4px"
    }
  },
  variants: {
    status: {
      info: {
        root: {
          colorPalette: "blue"
        }
      },
      warning: {
        root: {
          colorPalette: "orange"
        }
      },
      success: {
        root: {
          colorPalette: "green"
        }
      },
      error: {
        root: {
          colorPalette: "red"
        }
      },
      neutral: {
        root: {
          colorPalette: "gray"
        }
      }
    },
    inline: {
      true: {
        content: {
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "center"
        }
      },
      false: {
        content: {
          display: "flex",
          flexDirection: "column"
        }
      }
    },
    variant: {
      subtle: {
        root: {
          background: "colorPalette.subtle",
          color: "colorPalette.fg"
        }
      },
      surface: {
        root: {
          background: "colorPalette.subtle",
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        },
        indicator: {
          color: "colorPalette.fg"
        }
      },
      outline: {
        root: {
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        },
        indicator: {
          color: "colorPalette.fg"
        }
      },
      solid: {
        root: {
          background: "colorPalette.solid",
          color: "colorPalette.contrast"
        },
        indicator: {
          color: "colorPalette.contrast"
        }
      }
    },
    size: {
      sm: {
        root: {
          gap: "8px",
          paddingX: "12px",
          paddingY: "12px",
          fontSize: "12px"
        },
        indicator: {
          fontSize: "20px"
        }
      },
      md: {
        root: {
          gap: "12px",
          paddingX: "16px",
          paddingY: "16px",
          fontSize: "14px"
        },
        indicator: {
          fontSize: "24px"
        }
      },
      lg: {
        root: {
          gap: "12px",
          paddingX: "16px",
          paddingY: "16px",
          fontSize: "16px"
        },
        indicator: {
          fontSize: "28px"
        }
      }
    }
  },
  defaultVariants: {
    status: "info",
    variant: "subtle",
    size: "md",
    inline: false
  }
});

// src/core/theme/slot-recipes/avatar.ts
import { defineSlotRecipe as defineSlotRecipe4 } from "@chakra-ui/react";
var avatarSlotRecipe = defineSlotRecipe4({
  slots: ["root", "image", "fallback"],
  className: "chakra-avatar",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "500",
      position: "relative",
      verticalAlign: "top",
      flexShrink: "0",
      userSelect: "none",
      width: "var(--avatar-size)",
      height: "var(--avatar-size)",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)",
      "&[data-group-item]": {
        borderWidth: "2px",
        borderColor: "bg"
      }
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "var(--avatar-radius)"
    },
    fallback: {
      lineHeight: "1",
      textTransform: "uppercase",
      fontWeight: "500",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)"
    }
  },
  variants: {
    size: {
      full: {
        root: {
          "--avatar-size": "100%",
          "--avatar-font-size": "100%"
        }
      },
      "2xs": {
        root: {
          "--avatar-font-size": "10px",
          "--avatar-size": "24px"
        }
      },
      xs: {
        root: {
          "--avatar-font-size": "12px",
          "--avatar-size": "32px"
        }
      },
      sm: {
        root: {
          "--avatar-font-size": "14px",
          "--avatar-size": "36px"
        }
      },
      md: {
        root: {
          "--avatar-font-size": "16px",
          "--avatar-size": "40px"
        }
      },
      lg: {
        root: {
          "--avatar-font-size": "16px",
          "--avatar-size": "44px"
        }
      },
      xl: {
        root: {
          "--avatar-font-size": "18px",
          "--avatar-size": "48px"
        }
      },
      "2xl": {
        root: {
          "--avatar-font-size": "20px",
          "--avatar-size": "64px"
        }
      }
    },
    variant: {
      solid: {
        root: {
          background: "colorPalette.solid",
          color: "colorPalette.contrast"
        }
      },
      subtle: {
        root: {
          background: "colorPalette.muted",
          color: "colorPalette.fg"
        }
      },
      outline: {
        root: {
          color: "colorPalette.fg",
          borderWidth: "1px",
          borderColor: "colorPalette.muted"
        }
      }
    },
    shape: {
      square: {},
      rounded: {
        root: {
          "--avatar-radius": "8px"
        }
      },
      full: {
        root: {
          "--avatar-radius": "50%"
        }
      }
    },
    borderless: {
      true: {
        root: {
          "&[data-group-item]": {
            borderWidth: "0px"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    shape: "full",
    variant: "subtle"
  }
});

// src/core/theme/slot-recipes/blockquote.ts
import { defineSlotRecipe as defineSlotRecipe5 } from "@chakra-ui/react";
var blockquoteSlotRecipe = defineSlotRecipe5({
  className: "chakra-blockquote",
  slots: ["root", "icon", "content", "caption"],
  base: {
    root: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    caption: {
      fontSize: "14px",
      color: "fg.muted"
    },
    icon: {
      width: "20px",
      height: "20px"
    }
  },
  variants: {
    justify: {
      start: {
        root: {
          alignItems: "flex-start",
          textAlign: "start"
        }
      },
      center: {
        root: {
          alignItems: "center",
          textAlign: "center"
        }
      },
      end: {
        root: {
          alignItems: "flex-end",
          textAlign: "end"
        }
      }
    },
    variant: {
      subtle: {
        root: {
          paddingX: "20px",
          borderStartWidth: "4px",
          borderStartColor: "colorPalette.muted"
        },
        icon: {
          color: "colorPalette.fg"
        }
      },
      solid: {
        root: {
          paddingX: "20px",
          borderStartWidth: "4px",
          borderStartColor: "colorPalette.solid"
        },
        icon: {
          color: "colorPalette.solid"
        }
      },
      plain: {
        root: {
          paddingX: "20px"
        },
        icon: {
          color: "colorPalette.solid"
        }
      }
    }
  },
  defaultVariants: {
    variant: "subtle",
    justify: "start"
  }
});

// src/core/theme/slot-recipes/breadcrumb.ts
import { defineSlotRecipe as defineSlotRecipe6 } from "@chakra-ui/react";
var breadcrumbSlotRecipe = defineSlotRecipe6({
  className: "chakra-breadcrumb",
  slots: ["link", "currentLink", "item", "list", "root", "ellipsis", "separator"],
  base: {
    list: {
      display: "flex",
      alignItems: "center",
      wordBreak: "break-word",
      color: "fg.muted",
      listStyle: "none"
    },
    link: {
      outline: "0",
      textDecoration: "none",
      borderRadius: "4px",
      focusVisibleRing: "outside",
      display: "inline-flex",
      alignItems: "center",
      gap: "2"
    },
    item: {
      display: "inline-flex",
      alignItems: "center"
    },
    separator: {
      color: "fg.muted",
      opacity: "0.8",
      _icon: {
        boxSize: "1em"
      },
      _rtl: {
        rotate: "180deg"
      }
    },
    ellipsis: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      _icon: {
        boxSize: "1em"
      }
    }
  },
  variants: {
    variant: {
      underline: {
        link: {
          color: "colorPalette.fg",
          textDecoration: "underline",
          textUnderlineOffset: "0.2em",
          textDecorationColor: "colorPalette.muted"
        },
        currentLink: {
          color: "colorPalette.fg"
        }
      },
      plain: {
        link: {
          color: "fg.muted",
          _hover: {
            color: "fg"
          }
        },
        currentLink: {
          color: "fg"
        }
      }
    },
    size: {
      sm: {
        list: {
          gap: "1",
          textStyle: "xs"
        }
      },
      md: {
        list: {
          gap: "1.5",
          textStyle: "sm"
        }
      },
      lg: {
        list: {
          gap: "2",
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    variant: "plain",
    size: "md"
  }
});

// src/core/theme/slot-recipes/card.ts
import { defineSlotRecipe as defineSlotRecipe7 } from "@chakra-ui/react";
var cardSlotRecipe = defineSlotRecipe7({
  className: "chakra-card",
  slots: ["root", "header", "body", "footer", "title", "description"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: "0",
      wordWrap: "break-word",
      borderRadius: "12px",
      color: "fg",
      textAlign: "start"
    },
    title: {
      fontWeight: "semibold"
    },
    description: {
      color: "fg.muted",
      fontSize: "sm"
    },
    header: {
      paddingInline: "var(--card-padding)",
      paddingTop: "var(--card-padding)",
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    body: {
      padding: "var(--card-padding)",
      flex: "1",
      display: "flex",
      flexDirection: "column"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      gap: "2",
      paddingInline: "var(--card-padding)",
      paddingBottom: "var(--card-padding)"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          "--card-padding": "spacing.4"
        },
        title: {
          textStyle: "md"
        }
      },
      md: {
        root: {
          "--card-padding": "spacing.6"
        },
        title: {
          textStyle: "lg"
        }
      },
      lg: {
        root: {
          "--card-padding": "spacing.7"
        },
        title: {
          textStyle: "xl"
        }
      }
    },
    variant: {
      elevated: {
        root: {
          background: "bg.panel",
          boxShadow: "md"
        }
      },
      outline: {
        root: {
          background: "bg.panel",
          borderWidth: "1px",
          borderColor: "border"
        }
      },
      subtle: {
        root: {
          background: "bg.muted"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outline",
    size: "md"
  }
});

// src/core/theme/slot-recipes/checkbox.ts
import { defineSlotRecipe as defineSlotRecipe8 } from "@chakra-ui/react";
var checkboxSlotRecipe = defineSlotRecipe8({
  slots: ["root", "label", "control", "indicator", "group"],
  className: "chakra-checkbox",
  base: {
    root: {
      display: "inline-flex",
      gap: "8px",
      alignItems: "center",
      verticalAlign: "top",
      position: "relative",
      cursor: "pointer"
    },
    control: {
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer",
      justifyContent: "center",
      flexShrink: "0",
      color: "white",
      borderWidth: "1px",
      borderColor: "transparent",
      borderRadius: "4px",
      focusVisibleRing: "outside",
      _icon: {
        boxSize: "100%"
      },
      _invalid: {
        colorPalette: "red",
        borderColor: "border.error"
      },
      _disabled: {
        opacity: "0.5"
      }
    },
    label: {
      fontWeight: "500",
      userSelect: "none",
      _disabled: {
        opacity: "0.5"
      }
    }
  },
  variants: {
    size: {
      xs: {
        root: {
          gap: "6px"
        },
        label: {
          fontSize: "12px"
        },
        control: {
          width: "12px",
          height: "12px"
        }
      },
      sm: {
        root: {
          gap: "8px"
        },
        label: {
          fontSize: "14px"
        },
        control: {
          width: "16px",
          height: "16px"
        }
      },
      md: {
        root: {
          gap: "10px"
        },
        label: {
          fontSize: "14px"
        },
        control: {
          width: "20px",
          height: "20px",
          padding: "2px"
        }
      },
      lg: {
        root: {
          gap: "12px"
        },
        label: {
          fontSize: "16px"
        },
        control: {
          width: "24px",
          height: "24px",
          padding: "2px"
        }
      }
    },
    variant: {
      outline: {
        control: {
          borderColor: "border",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            color: "colorPalette.fg",
            borderColor: "colorPalette.solid"
          }
        }
      },
      solid: {
        control: {
          borderColor: "border",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      },
      subtle: {
        control: {
          background: "colorPalette.muted",
          borderColor: "colorPalette.muted",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            color: "colorPalette.fg"
          }
        }
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
});

// src/core/theme/slot-recipes/checkbox-card.ts
import { defineSlotRecipe as defineSlotRecipe9 } from "@chakra-ui/react";
var checkboxCardSlotRecipe = defineSlotRecipe9({
  slots: ["root", "control", "label", "description", "addon", "indicator", "content"],
  className: "chakra-checkbox-card",
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      userSelect: "none",
      position: "relative",
      borderRadius: "8px",
      flex: "1",
      focusVisibleRing: "outside",
      _disabled: {
        opacity: "0.8",
        borderColor: "border.subtle"
      },
      _invalid: {
        outline: "2px solid",
        outlineColor: "border.error"
      }
    },
    control: {
      display: "inline-flex",
      flex: "1",
      position: "relative",
      borderRadius: "inherit",
      justifyContent: "var(--checkbox-card-justify)",
      alignItems: "var(--checkbox-card-align)"
    },
    label: {
      fontWeight: "medium",
      display: "flex",
      alignItems: "center",
      gap: "2",
      _disabled: {
        opacity: "0.5"
      }
    },
    description: {
      opacity: "0.64",
      textStyle: "sm"
    },
    addon: {
      _disabled: {
        opacity: "0.5"
      }
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      color: "white",
      borderWidth: "1px",
      borderColor: "transparent",
      borderRadius: "4px",
      focusVisibleRing: "outside",
      _icon: {
        boxSize: "full"
      },
      _invalid: {
        colorPalette: "red",
        borderColor: "border.error"
      },
      _disabled: {
        opacity: "0.5"
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      gap: "1",
      justifyContent: "var(--checkbox-card-justify)",
      alignItems: "var(--checkbox-card-align)"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        control: {
          padding: "3",
          gap: "1.5"
        },
        addon: {
          paddingX: "3",
          paddingY: "1.5",
          borderTopWidth: "1px"
        },
        indicator: {
          boxSize: "4"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        },
        control: {
          padding: "4",
          gap: "2.5"
        },
        addon: {
          paddingX: "4",
          paddingY: "2",
          borderTopWidth: "1px"
        },
        indicator: {
          boxSize: "5",
          p: "0.5"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        },
        control: {
          padding: "4",
          gap: "3.5"
        },
        addon: {
          paddingX: "4",
          paddingY: "2",
          borderTopWidth: "1px"
        },
        indicator: {
          boxSize: "6",
          p: "0.5"
        }
      }
    },
    variant: {
      surface: {
        root: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg",
            borderColor: "colorPalette.muted"
          },
          _disabled: {
            background: "bg.muted"
          }
        },
        indicator: {
          borderColor: "border",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      },
      subtle: {
        root: {
          background: "bg.muted"
        },
        control: {
          _checked: {
            background: "colorPalette.muted",
            color: "colorPalette.fg"
          }
        },
        indicator: {
          "&:is([data-state=checked], [data-state=indeterminate])": {
            color: "colorPalette.fg"
          }
        }
      },
      outline: {
        root: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            boxShadow: "0 0 0 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.solid",
            borderColor: "colorPalette.solid"
          }
        },
        indicator: {
          borderColor: "border",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      },
      solid: {
        root: {
          borderWidth: "1px",
          _checked: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        },
        indicator: {
          borderColor: "border",
          color: "colorPalette.fg",
          "&:is([data-state=checked], [data-state=indeterminate])": {
            borderColor: "colorPalette.solid"
          }
        }
      }
    },
    justify: {
      start: {
        root: {
          "--checkbox-card-justify": "flex-start"
        }
      },
      end: {
        root: {
          "--checkbox-card-justify": "flex-end"
        }
      },
      center: {
        root: {
          "--checkbox-card-justify": "center"
        }
      }
    },
    align: {
      start: {
        root: {
          "--checkbox-card-align": "flex-start"
        },
        content: {
          textAlign: "start"
        }
      },
      end: {
        root: {
          "--checkbox-card-align": "flex-end"
        },
        content: {
          textAlign: "end"
        }
      },
      center: {
        root: {
          "--checkbox-card-align": "center"
        },
        content: {
          textAlign: "center"
        }
      }
    },
    orientation: {
      vertical: {
        control: {
          flexDirection: "column"
        }
      },
      horizontal: {
        control: {
          flexDirection: "row"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    align: "start",
    orientation: "horizontal"
  }
});

// src/core/theme/slot-recipes/collapsible.ts
import { defineSlotRecipe as defineSlotRecipe10 } from "@chakra-ui/react";
var collapsibleSlotRecipe = defineSlotRecipe10({
  slots: ["root", "trigger", "content"],
  className: "chakra-collapsible",
  base: {
    content: {
      overflow: "hidden",
      _open: {
        animationName: "expand-height, fade-in",
        animationDuration: "default"
      },
      _closed: {
        animationName: "collapse-height, fade-out",
        animationDuration: "default"
      }
    }
  }
});

// src/core/theme/slot-recipes/data-list.ts
import { defineSlotRecipe as defineSlotRecipe11 } from "@chakra-ui/react";
var dataListSlotRecipe = defineSlotRecipe11({
  slots: ["root", "item", "itemLabel", "itemValue"],
  className: "chakra-data-list",
  base: {
    itemLabel: {
      display: "flex",
      alignItems: "center",
      gap: "1"
    },
    itemValue: {
      display: "flex",
      minWidth: "0",
      flex: "1"
    }
  },
  variants: {
    orientation: {
      horizontal: {
        root: {
          display: "flex",
          flexDirection: "column"
        },
        item: {
          display: "inline-flex",
          alignItems: "center",
          gap: "4"
        },
        itemLabel: {
          minWidth: "120px"
        }
      },
      vertical: {
        root: {
          display: "flex",
          flexDirection: "column"
        },
        item: {
          display: "flex",
          flexDirection: "column",
          gap: "1"
        }
      }
    },
    size: {
      sm: {
        root: {
          gap: "3"
        },
        item: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          gap: "4"
        },
        item: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          gap: "5"
        },
        item: {
          textStyle: "md"
        }
      }
    },
    variant: {
      subtle: {
        itemLabel: {
          color: "fg.muted"
        }
      },
      bold: {
        itemLabel: {
          fontWeight: "medium"
        },
        itemValue: {
          color: "fg.muted"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    orientation: "vertical",
    variant: "subtle"
  }
});

// src/core/theme/slot-recipes/dialog.ts
import { defineSlotRecipe as defineSlotRecipe12 } from "@chakra-ui/react";
var dialogSlotRecipe = defineSlotRecipe12({
  slots: [
    "trigger",
    "backdrop",
    "positioner",
    "content",
    "title",
    "description",
    "closeTrigger",
    "header",
    "body",
    "footer",
    "backdrop"
  ],
  className: "chakra-dialog",
  base: {
    backdrop: {
      background: "blackAlpha.50",
      pos: "fixed",
      left: 0,
      top: 0,
      w: "100vw",
      height: "100dvh",
      zIndex: "modal",
      _open: {
        animationName: "fade-in",
        animationDuration: "slow"
      },
      _closed: {
        animationName: "fade-out",
        animationDuration: "default"
      }
    },
    positioner: {
      display: "flex",
      width: "100vw",
      height: "100dvh",
      position: "fixed",
      left: 0,
      top: 0,
      "--dialog-z-index": "zIndex.modal",
      zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
      justifyContent: "center",
      overscrollBehaviorY: "none"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      borderRadius: "12px",
      textStyle: "body2",
      my: "var(--dialog-margin, var(--dialog-base-margin))",
      "--dialog-z-index": "zIndex.modal",
      zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
      background: "generic.0",
      boxShadow: "lg",
      _open: {
        animationDuration: "default"
      },
      _closed: {
        animationDuration: "faster"
      }
    },
    header: {
      flex: 0,
      paddingX: "6",
      pt: "6",
      pb: "4"
    },
    body: {
      flex: "1",
      paddingX: "6",
      pt: "2",
      pb: "6"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "3",
      paddingX: "6",
      pt: "2",
      pb: "4"
    },
    title: {
      textStyle: "body1",
      fontWeight: "medium"
    },
    description: {
      color: "generic.100"
    }
  },
  variants: {
    placement: {
      center: {
        positioner: {
          alignItems: "center"
        },
        content: {
          "--dialog-base-margin": "auto",
          mx: "auto"
        }
      },
      top: {
        positioner: {
          alignItems: "flex-start"
        },
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto"
        }
      },
      bottom: {
        positioner: {
          alignItems: "flex-end"
        },
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto"
        }
      }
    },
    scrollBehavior: {
      inside: {
        positioner: {
          overflow: "hidden"
        },
        content: {
          maxH: "calc(100% - 7.5rem)"
        },
        body: {
          overflow: "auto"
        }
      },
      outside: {
        positioner: {
          overflow: "auto",
          pointerEvents: "auto"
        }
      }
    },
    size: {
      xs: {
        content: {
          maxW: "sm"
        }
      },
      sm: {
        content: {
          maxW: "md"
        }
      },
      md: {
        content: {
          maxW: "lg"
        }
      },
      lg: {
        content: {
          maxW: "2xl"
        }
      },
      xl: {
        content: {
          maxW: "4xl"
        }
      },
      cover: {
        positioner: {
          padding: "10"
        },
        content: {
          width: "100%",
          height: "100%",
          "--dialog-margin": "0"
        }
      },
      full: {
        content: {
          maxW: "100vw",
          minH: "100vh",
          "--dialog-margin": "0",
          borderRadius: "0"
        }
      }
    },
    motionPreset: {
      "fade-in-out": {
        content: {
          _open: {
            animationName: "fade-in"
          },
          _closed: {
            animationName: "fade-out"
          }
        }
      },
      scale: {
        content: {
          _open: {
            animationName: "scale-in, fade-in"
          },
          _closed: {
            animationName: "scale-out, fade-out"
          }
        }
      },
      "slide-in-bottom": {
        content: {
          _open: {
            animationName: "slide-from-bottom, fade-in"
          },
          _closed: {
            animationName: "slide-to-bottom, fade-out"
          }
        }
      },
      "slide-in-top": {
        content: {
          _open: {
            animationName: "slide-from-top, fade-in"
          },
          _closed: {
            animationName: "slide-to-top, fade-out"
          }
        }
      },
      "slide-in-left": {
        content: {
          _open: {
            animationName: "slide-from-left, fade-in"
          },
          _closed: {
            animationName: "slide-to-left, fade-out"
          }
        }
      },
      "slide-in-right": {
        content: {
          _open: {
            animationName: "slide-from-right, fade-in"
          },
          _closed: {
            animationName: "slide-to-right, fade-out"
          }
        }
      },
      none: {}
    }
  },
  defaultVariants: {
    size: "md",
    scrollBehavior: "outside",
    placement: "top",
    motionPreset: "scale"
  }
});

// src/core/theme/slot-recipes/drawer.ts
import { defineSlotRecipe as defineSlotRecipe13 } from "@chakra-ui/react";
var drawerSlotRecipe = defineSlotRecipe13({
  slots: [
    "trigger",
    "backdrop",
    "positioner",
    "content",
    "title",
    "description",
    "closeTrigger",
    "header",
    "body",
    "footer"
  ],
  className: "chakra-drawer",
  base: {
    backdrop: {
      backgroundColor: "black/25",
      position: "fixed",
      insetInlineStart: 0,
      top: 0,
      width: "100vw",
      height: "100dvh",
      zIndex: "modal",
      _open: {
        animationName: "fade-in",
        animationDuration: "slowest"
      },
      _closed: {
        animationName: "fade-out",
        animationDuration: "default"
      }
    },
    positioner: {
      display: "flex",
      width: "100vw",
      height: "100dvh",
      position: "fixed",
      insetInlineStart: 0,
      top: 0,
      zIndex: "modal",
      overscrollBehaviorY: "none"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      zIndex: "modal",
      fontSize: "14px",
      maxHeight: "100dvh",
      color: "inherit",
      backgroundColor: "white",
      boxShadow: "lg",
      _open: {
        animationDuration: "0.6s",
        animationTimingFunction: "ease-in-smooth"
      },
      _closed: {
        animationDuration: "0.6s",
        animationTimingFunction: "ease-in-smooth"
      }
    },
    header: {
      flex: "0 0 auto",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "24px",
      paddingBottom: "16px"
    },
    body: {
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "8px",
      paddingBottom: "8px",
      flex: "1 1 auto",
      overflow: "auto"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "12px",
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingTop: "8px",
      paddingBottom: "16px"
    },
    title: {
      fontSize: "18px",
      fontWeight: "600"
    },
    description: {
      color: "fg.muted"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          maxWidth: "320px"
        }
      },
      sm: {
        content: {
          maxWidth: "450px"
        }
      },
      md: {
        content: {
          maxWidth: "768px"
        }
      },
      lg: {
        content: {
          maxWidth: "1024px"
        }
      },
      xl: {
        content: {
          maxWidth: "1280px"
        }
      },
      full: {
        content: {
          maxWidth: "100vw",
          height: "100dvh"
        }
      }
    },
    placement: {
      start: {
        positioner: {
          justifyContent: "flex-start"
        },
        content: {
          _open: {
            animationName: {
              base: "slide-from-left-full, fade-in",
              _rtl: "slide-from-right-full, fade-in"
            }
          },
          _closed: {
            animationName: {
              base: "slide-to-left-full, fade-out",
              _rtl: "slide-to-right-full, fade-out"
            }
          }
        }
      },
      end: {
        positioner: {
          justifyContent: "flex-end"
        },
        content: {
          _open: {
            animationName: {
              base: "slide-from-right-full, fade-in",
              _rtl: "slide-from-left-full, fade-in"
            }
          },
          _closed: {
            animationName: {
              base: "slide-to-right-full, fade-out",
              _rtl: "slide-to-left-full, fade-out"
            }
          }
        }
      },
      top: {
        positioner: {
          alignItems: "flex-start"
        },
        content: {
          maxWidth: "100%",
          _open: {
            animationName: "slide-from-top-full, fade-in"
          },
          _closed: {
            animationName: "slide-to-top-full, fade-out"
          }
        }
      },
      bottom: {
        positioner: {
          alignItems: "flex-end"
        },
        content: {
          maxWidth: "100%",
          _open: {
            animationName: "slide-from-bottom-full, fade-in"
          },
          _closed: {
            animationName: "slide-to-bottom-full, fade-out"
          }
        }
      }
    },
    contained: {
      true: {
        positioner: {
          padding: "16px"
        },
        content: {
          borderRadius: "12px"
        }
      }
    }
  },
  defaultVariants: {
    size: "xs",
    placement: "end"
  }
});

// src/core/theme/slot-recipes/editable.ts
import { defineSlotRecipe as defineSlotRecipe14 } from "@chakra-ui/react";
var editableSlotRecipe = defineSlotRecipe14({
  slots: [
    "root",
    "area",
    "label",
    "preview",
    "input",
    "editTrigger",
    "submitTrigger",
    "cancelTrigger",
    "control",
    "textarea"
  ],
  className: "chakra-editable",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative",
      gap: "1.5",
      width: "full"
    },
    preview: {
      fontSize: "inherit",
      fontWeight: "inherit",
      textAlign: "inherit",
      background: "transparent",
      borderRadius: "8px",
      paddingY: "1",
      paddingX: "1",
      display: "inline-flex",
      alignItems: "center",
      transitionProperty: "common",
      transitionDuration: "normal",
      cursor: "text",
      _hover: {
        background: "bg.muted"
      },
      _disabled: {
        userSelect: "none"
      }
    },
    input: {
      fontSize: "inherit",
      fontWeight: "inherit",
      textAlign: "inherit",
      background: "transparent",
      borderRadius: "8px",
      outline: "0",
      paddingY: "1",
      paddingX: "1",
      transitionProperty: "common",
      transitionDuration: "normal",
      width: "full",
      focusVisibleRing: "inside",
      focusRingWidth: "2px",
      _placeholder: {
        opacity: 0.6
      }
    },
    control: {
      display: "inline-flex",
      alignItems: "center",
      gap: "1.5"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        preview: {
          minH: "8"
        },
        input: {
          minH: "8"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        },
        preview: {
          minH: "9"
        },
        input: {
          minH: "9"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        },
        preview: {
          minH: "10"
        },
        input: {
          minH: "10"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/empty-state.ts
import { defineSlotRecipe as defineSlotRecipe15 } from "@chakra-ui/react";
var emptyStateSlotRecipe = defineSlotRecipe15({
  slots: ["root", "content", "indicator", "title", "description"],
  className: "chakra-empty-state",
  base: {
    root: {
      width: "full"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    indicator: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "fg.subtle",
      _icon: {
        boxSize: "1em"
      }
    },
    title: {
      fontWeight: "semibold"
    },
    description: {
      textStyle: "sm",
      color: "fg.muted"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          paddingX: "4",
          paddingY: "6"
        },
        title: {
          textStyle: "md"
        },
        content: {
          gap: "4"
        },
        indicator: {
          textStyle: "2xl"
        }
      },
      md: {
        root: {
          paddingX: "8",
          paddingY: "12"
        },
        title: {
          textStyle: "lg"
        },
        content: {
          gap: "6"
        },
        indicator: {
          textStyle: "4xl"
        }
      },
      lg: {
        root: {
          paddingX: "12",
          paddingY: "16"
        },
        title: {
          textStyle: "xl"
        },
        content: {
          gap: "8"
        },
        indicator: {
          textStyle: "6xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/field.ts
import { defineSlotRecipe as defineSlotRecipe16 } from "@chakra-ui/react";
var fieldSlotRecipe = defineSlotRecipe16({
  className: "chakra-field",
  slots: [
    "root",
    "errorText",
    "helperText",
    "input",
    "label",
    "select",
    "textarea",
    "requiredIndicator",
    "requiredIndicator"
  ],
  base: {
    requiredIndicator: {
      color: "fg.error",
      lineHeight: "1"
    },
    root: {
      display: "flex",
      width: "100%",
      position: "relative",
      gap: "1.5"
    },
    label: {
      display: "flex",
      alignItems: "center",
      textAlign: "start",
      textStyle: "sm",
      fontWeight: "medium",
      gap: "1",
      userSelect: "none",
      _disabled: {
        opacity: "0.5"
      }
    },
    errorText: {
      display: "inline-flex",
      alignItems: "center",
      fontWeight: "medium",
      gap: "1",
      color: "fg.error",
      textStyle: "xs"
    },
    helperText: {
      color: "fg.muted",
      textStyle: "xs"
    }
  },
  variants: {
    orientation: {
      vertical: {
        root: {
          flexDirection: "column",
          alignItems: "flex-start"
        }
      },
      horizontal: {
        root: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        },
        label: {
          flex: "0 0 var(--field-label-width, 80px)"
        }
      }
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
});

// src/core/theme/slot-recipes/fieldset.ts
import { defineSlotRecipe as defineSlotRecipe17 } from "@chakra-ui/react";
var fieldsetSlotRecipe = defineSlotRecipe17({
  className: "fieldset",
  slots: ["root", "errorText", "helperText", "legend", "content"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "full"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: "full"
    },
    legend: {
      color: "fg",
      fontWeight: "medium",
      _disabled: {
        opacity: "0.5"
      }
    },
    helperText: {
      color: "fg.muted",
      textStyle: "sm"
    },
    errorText: {
      display: "inline-flex",
      alignItems: "center",
      color: "fg.error",
      gap: "2",
      fontWeight: "medium",
      textStyle: "sm"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          spaceY: "2"
        },
        content: {
          gap: "1.5"
        },
        legend: {
          textStyle: "sm"
        }
      },
      md: {
        root: {
          spaceY: "4"
        },
        content: {
          gap: "4"
        },
        legend: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          spaceY: "6"
        },
        content: {
          gap: "4"
        },
        legend: {
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/file-upload.ts
import { defineSlotRecipe as defineSlotRecipe18 } from "@chakra-ui/react";
var fileUploadSlotRecipe = defineSlotRecipe18({
  className: "chakra-file-upload",
  slots: [
    "root",
    "dropzone",
    "item",
    "itemDeleteTrigger",
    "itemGroup",
    "itemName",
    "itemPreview",
    "itemPreviewImage",
    "itemSizeText",
    "label",
    "trigger",
    "clearTrigger",
    "itemContent",
    "dropzoneContent"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "4",
      width: "100%",
      alignItems: "flex-start"
    },
    label: {
      fontWeight: "medium",
      textStyle: "sm"
    },
    dropzone: {
      background: "bg",
      borderRadius: "12px",
      borderWidth: "2px",
      borderStyle: "dashed",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      gap: "4",
      justifyContent: "center",
      minHeight: "2xs",
      paddingX: "3",
      paddingY: "2",
      transition: "backgrounds",
      focusVisibleRing: "outside",
      _hover: {
        background: "bg.subtle"
      },
      _dragging: {
        background: "colorPalette.subtle",
        borderStyle: "solid",
        borderColor: "colorPalette.solid"
      }
    },
    dropzoneContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "1",
      textStyle: "sm"
    },
    item: {
      textStyle: "sm",
      animationName: "fade-in",
      animationDuration: "default",
      background: "bg",
      borderRadius: "8px",
      borderWidth: "1px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "3",
      p: "4"
    },
    itemGroup: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "3"
    },
    itemName: {
      color: "fg",
      fontWeight: "medium",
      lineClamp: "1"
    },
    itemContent: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5",
      flex: "1"
    },
    itemSizeText: {
      color: "fg.muted",
      textStyle: "xs"
    },
    itemDeleteTrigger: {
      alignSelf: "flex-start"
    },
    itemPreviewImage: {
      width: "10",
      height: "10",
      objectFit: "scale-down"
    }
  },
  defaultVariants: {}
});

// src/core/theme/slot-recipes/hover-card.ts
import { defineSlotRecipe as defineSlotRecipe19 } from "@chakra-ui/react";
var hoverCardSlotRecipe = defineSlotRecipe19({
  className: "chakra-hover-card",
  slots: ["arrow", "arrowTip", "trigger", "positioner", "content"],
  base: {
    content: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      textStyle: "sm",
      "--hovercard-bg": "colors.bg.panel",
      background: "var(--hovercard-bg)",
      boxShadow: "lg",
      maxWidth: "80",
      borderRadius: "12px",
      zIndex: "popover",
      transformOrigin: "var(--transform-origin)",
      outline: "0",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    arrow: {
      "--arrow-size": "sizes.3",
      "--arrow-background": "var(--hovercard-bg)"
    },
    arrowTip: {
      borderTopWidth: "0.5px",
      borderInlineStartWidth: "0.5px"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          padding: "3"
        }
      },
      sm: {
        content: {
          padding: "4"
        }
      },
      md: {
        content: {
          padding: "5"
        }
      },
      lg: {
        content: {
          padding: "6"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/list.ts
import { defineSlotRecipe as defineSlotRecipe20 } from "@chakra-ui/react";
var listSlotRecipe = defineSlotRecipe20({
  className: "chakra-list",
  slots: ["root", "item", "indicator"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "var(--list-gap)",
      "& :where(ul, ol)": {
        marginTop: "var(--list-gap)"
      }
    },
    item: {
      whiteSpace: "normal",
      display: "list-item"
    },
    indicator: {
      marginEnd: "2",
      minHeight: "1lh",
      flexShrink: 0,
      display: "inline-block",
      verticalAlign: "middle"
    }
  },
  variants: {
    variant: {
      marker: {
        root: {
          listStyle: "revert"
        },
        item: {
          _marker: {
            color: "fg.subtle"
          }
        }
      },
      plain: {
        item: {
          alignItems: "flex-start",
          display: "inline-flex"
        }
      }
    },
    align: {
      center: {
        item: {
          alignItems: "center"
        }
      },
      start: {
        item: {
          alignItems: "flex-start"
        }
      },
      end: {
        item: {
          alignItems: "flex-end"
        }
      }
    }
  },
  defaultVariants: {
    variant: "marker"
  }
});

// src/core/theme/slot-recipes/menu.ts
import { defineSlotRecipe as defineSlotRecipe21 } from "@chakra-ui/react";
var menuSlotRecipe = defineSlotRecipe21({
  className: "chakra-menu",
  slots: [
    "arrow",
    "arrowTip",
    "content",
    "contextTrigger",
    "indicator",
    "item",
    "itemGroup",
    "itemGroupLabel",
    "itemIndicator",
    "itemText",
    "positioner",
    "separator",
    "trigger",
    "triggerItem",
    "itemCommand"
  ],
  base: {
    content: {
      outline: 0,
      background: "bg.panel",
      boxShadow: "lg",
      color: "fg",
      maxHeight: "var(--available-height)",
      "--menu-z-index": "zIndex.dropdown",
      zIndex: "calc(var(--menu-z-index) + var(--layer-index, 0))",
      borderRadius: "8px",
      overflow: "hidden",
      overflowY: "auto",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    item: {
      textDecoration: "none",
      color: "fg",
      userSelect: "none",
      borderRadius: "4px",
      width: "100%",
      display: "flex",
      cursor: "menuitem",
      alignItems: "center",
      textAlign: "start",
      position: "relative",
      flex: "0 0 auto",
      outline: 0,
      _disabled: {
        layerStyle: "disabled"
      }
    },
    itemText: {
      flex: "1"
    },
    itemGroupLabel: {
      paddingX: "2",
      paddingY: "1.5",
      fontWeight: "semibold",
      textStyle: "sm"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0"
    },
    itemCommand: {
      opacity: "0.6",
      textStyle: "xs",
      ms: "auto",
      ps: "4",
      letterSpacing: "widest"
    },
    separator: {
      height: "1px",
      background: "bg.muted",
      my: "1",
      mx: "-1"
    }
  },
  variants: {
    variant: {
      subtle: {
        item: {
          _highlighted: {
            background: "bg.emphasized/60"
          }
        }
      },
      solid: {
        item: {
          _highlighted: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast"
          }
        }
      }
    },
    size: {
      sm: {
        content: {
          minWidth: "8rem",
          padding: "1"
        },
        item: {
          gap: "1",
          textStyle: "xs",
          paddingY: "1",
          paddingX: "1.5"
        }
      },
      md: {
        content: {
          minWidth: "8rem",
          padding: "1.5"
        },
        item: {
          gap: "2",
          textStyle: "sm",
          paddingY: "1.5",
          paddingX: "2"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "subtle"
  }
});

// src/core/theme/slot-recipes/native-select.ts
import { defineSlotRecipe as defineSlotRecipe22 } from "@chakra-ui/react";
var nativeSelectSlotRecipe = defineSlotRecipe22({
  className: "chakra-native-select",
  slots: ["root", "field", "indicator"],
  base: {
    root: {
      height: "fit-content",
      display: "flex",
      width: "100%",
      position: "relative"
    },
    field: {
      width: "100%",
      minWidth: "0",
      outline: "0",
      appearance: "none",
      borderRadius: "8px",
      "--error-color": "colors.border.error",
      _disabled: {
        layerStyle: "disabled"
      },
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      },
      focusVisibleRing: "inside",
      lineHeight: "normal",
      "& > option, & > optgroup": {
        background: "bg"
      }
    },
    indicator: {
      position: "absolute",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      top: "50%",
      transform: "translateY(-50%)",
      height: "100%",
      color: "fg.muted",
      _disabled: {
        opacity: "0.5"
      },
      _invalid: {
        color: "fg.error"
      },
      _icon: {
        width: "1em",
        height: "1em"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        field: {
          background: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          _expanded: {
            borderColor: "border.emphasized"
          }
        }
      },
      subtle: {
        field: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted"
        }
      },
      plain: {
        field: {
          background: "transparent",
          color: "fg",
          focusRingWidth: "2px"
        }
      }
    },
    size: {
      xs: {
        field: {
          fontSize: "12px",
          paddingLeft: "8px",
          paddingRight: "24px",
          height: "24px"
        },
        indicator: {
          fontSize: "14px",
          insetInlineEnd: "6px"
        }
      },
      sm: {
        field: {
          fontSize: "14px",
          paddingLeft: "10px",
          paddingRight: "32px",
          height: "32px"
        },
        indicator: {
          fontSize: "16px",
          insetInlineEnd: "8px"
        }
      },
      md: {
        field: {
          fontSize: "14px",
          paddingLeft: "12px",
          paddingRight: "32px",
          height: "40px"
        },
        indicator: {
          fontSize: "18px",
          insetInlineEnd: "8px"
        }
      },
      lg: {
        field: {
          fontSize: "16px",
          paddingLeft: "16px",
          paddingRight: "32px",
          height: "44px"
        },
        indicator: {
          fontSize: "20px",
          insetInlineEnd: "12px"
        }
      },
      xl: {
        field: {
          fontSize: "16px",
          paddingLeft: "18px",
          paddingRight: "40px",
          height: "48px"
        },
        indicator: {
          fontSize: "20px",
          insetInlineEnd: "12px"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/number-input.ts
import { defineSlotRecipe as defineSlotRecipe23 } from "@chakra-ui/react";
var numberInputSlotRecipe = defineSlotRecipe23({
  className: "chakra-number-input",
  slots: ["root", "label", "input", "control", "valueText", "incrementTrigger", "decrementTrigger", "scrubber"],
  base: {
    root: {
      position: "relative",
      zIndex: "0",
      isolation: "isolate"
    },
    input: {
      width: "100%",
      outline: "0",
      position: "relative",
      appearance: "none",
      textAlign: "start",
      borderRadius: "8px",
      _disabled: {
        layerStyle: "disabled"
      },
      height: "var(--input-height)",
      minWidth: "var(--input-height)",
      "--focus-color": "colors.colorPalette.focusRing",
      "--error-color": "colors.border.error",
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      },
      verticalAlign: "top",
      pe: "calc(var(--stepper-width) + 0.5rem)"
    },
    control: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      top: "0",
      insetEnd: "0px",
      margin: "1px",
      width: "var(--stepper-width)",
      height: "calc(100% - 2px)",
      zIndex: "1",
      borderStartWidth: "1px",
      divideY: "1px"
    },
    incrementTrigger: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flex: "1",
      userSelect: "none",
      cursor: "button",
      lineHeight: "1",
      color: "fg.muted",
      "--stepper-base-radius": "radii.l1",
      "--stepper-radius": "calc(var(--stepper-base-radius) + 1px)",
      _icon: {
        boxSize: "1em"
      },
      _disabled: {
        opacity: "0.5"
      },
      _hover: {
        background: "bg.muted"
      },
      _active: {
        background: "bg.emphasized"
      },
      borderTopEndRadius: "var(--stepper-radius)"
    },
    decrementTrigger: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flex: "1",
      userSelect: "none",
      cursor: "button",
      lineHeight: "1",
      color: "fg.muted",
      "--stepper-base-radius": "radii.l1",
      "--stepper-radius": "calc(var(--stepper-base-radius) + 1px)",
      _icon: {
        boxSize: "1em"
      },
      _disabled: {
        opacity: "0.5"
      },
      _hover: {
        background: "bg.muted"
      },
      _active: {
        background: "bg.emphasized"
      },
      borderBottomEndRadius: "var(--stepper-radius)"
    },
    valueText: {
      fontWeight: "medium",
      fontFeatureSettings: "pnum",
      fontVariantNumeric: "proportional-nums"
    }
  },
  variants: {
    size: {
      xs: {
        input: {
          textStyle: "xs",
          paddingX: "2",
          "--input-height": "24px"
        },
        control: {
          fontSize: "2xs",
          "--stepper-width": "24px"
        }
      },
      sm: {
        input: {
          textStyle: "sm",
          paddingX: "2.5",
          "--input-height": "sizes.9"
        },
        control: {
          fontSize: "xs",
          "--stepper-width": "sizes.5"
        }
      },
      md: {
        input: {
          textStyle: "sm",
          paddingX: "3",
          "--input-height": "sizes.100"
        },
        control: {
          fontSize: "sm",
          "--stepper-width": "sizes.6"
        }
      },
      lg: {
        input: {
          textStyle: "md",
          paddingX: "4",
          "--input-height": "sizes.11"
        },
        control: {
          fontSize: "sm",
          "--stepper-width": "sizes.6"
        }
      }
    },
    variant: {
      outline: {
        input: {
          background: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          focusVisibleRing: "inside"
        }
      },
      subtle: {
        input: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted",
          focusVisibleRing: "inside"
        }
      },
      flushed: {
        input: {
          background: "transparent",
          borderBottomWidth: "1px",
          borderBottomColor: "border",
          borderRadius: "0",
          paddingX: "0",
          _focusVisible: {
            borderColor: "var(--focus-color)",
            boxShadow: "0px 1px 0px 0px var(--focus-color)"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/pin-input.ts
import { defineSlotRecipe as defineSlotRecipe24 } from "@chakra-ui/react";
var pinInputSlotRecipe = defineSlotRecipe24({
  className: "chakra-pin-input",
  slots: ["root", "label", "input", "control"],
  base: {
    input: {
      width: "var(--input-height)",
      outline: "0",
      position: "relative",
      appearance: "none",
      textAlign: "center",
      borderRadius: "8px",
      _disabled: {
        layerStyle: "disabled"
      },
      height: "var(--input-height)",
      minWidth: "var(--input-height)",
      "--focus-color": "colors.colorPalette.focusRing",
      "--error-color": "colors.border.error",
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      }
    }
  },
  variants: {
    size: {
      "2xs": {
        input: {
          textStyle: "xs",
          paddingX: "2",
          "--input-height": "sizes.7"
        }
      },
      xs: {
        input: {
          textStyle: "xs",
          paddingX: "2",
          "--input-height": "sizes.8"
        }
      },
      sm: {
        input: {
          textStyle: "sm",
          paddingX: "2.5",
          "--input-height": "sizes.9"
        }
      },
      md: {
        input: {
          textStyle: "sm",
          paddingX: "3",
          "--input-height": "sizes.100"
        }
      },
      lg: {
        input: {
          textStyle: "md",
          paddingX: "4",
          "--input-height": "sizes.11"
        }
      },
      xl: {
        input: {
          textStyle: "md",
          paddingX: "4.5",
          "--input-height": "sizes.12"
        }
      },
      "2xl": {
        input: {
          textStyle: "lg",
          paddingX: "5",
          "--input-height": "sizes.16"
        }
      }
    },
    variant: {
      outline: {
        input: {
          background: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          focusVisibleRing: "inside"
        }
      },
      subtle: {
        input: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted",
          focusVisibleRing: "inside"
        }
      },
      flushed: {
        input: {
          background: "transparent",
          borderBottomWidth: "1px",
          borderBottomColor: "border",
          borderRadius: "0",
          paddingX: "0",
          _focusVisible: {
            borderColor: "var(--focus-color)",
            boxShadow: "0px 1px 0px 0px var(--focus-color)"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/popover.ts
import { defineSlotRecipe as defineSlotRecipe25 } from "@chakra-ui/react";
var popoverSlotRecipe = defineSlotRecipe25({
  className: "chakra-popover",
  slots: [
    "arrow",
    "arrowTip",
    "anchor",
    "trigger",
    "indicator",
    "positioner",
    "content",
    "title",
    "description",
    "closeTrigger",
    "header",
    "body",
    "footer"
  ],
  base: {
    content: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      textStyle: "sm",
      "--popover-bg": "colors.bg.panel",
      background: "var(--popover-bg)",
      boxShadow: "lg",
      "--popover-size": "sizes.xs",
      "--popover-mobile-size": "calc(100dvw - 1rem)",
      width: {
        base: "min(var(--popover-mobile-size), var(--popover-size))",
        mobile: "var(--popover-size)"
      },
      borderRadius: "12px",
      "--popover-z-index": "zIndex.popover",
      zIndex: "calc(var(--popover-z-index) + var(--layer-index, 0))",
      outline: "0",
      transformOrigin: "var(--transform-origin)",
      maxHeight: "var(--available-height)",
      _open: {
        animationStyle: "scale-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "scale-fade-out",
        animationDuration: "faster"
      }
    },
    header: {
      paddingInline: "var(--popover-padding)",
      paddingTop: "var(--popover-padding)"
    },
    body: {
      padding: "var(--popover-padding)",
      flex: "1"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      paddingInline: "var(--popover-padding)",
      paddingBottom: "var(--popover-padding)"
    },
    arrow: {
      "--arrow-size": "sizes.3",
      "--arrow-background": "var(--popover-bg)"
    },
    arrowTip: {
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          "--popover-padding": "spacing.3"
        }
      },
      sm: {
        content: {
          "--popover-padding": "spacing.4"
        }
      },
      md: {
        content: {
          "--popover-padding": "spacing.5"
        }
      },
      lg: {
        content: {
          "--popover-padding": "spacing.6"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/progress.ts
import { defineSlotRecipe as defineSlotRecipe26 } from "@chakra-ui/react";
var progressSlotRecipe = defineSlotRecipe26({
  slots: ["root", "label", "track", "range", "valueText", "view", "circle", "circleTrack", "circleRange"],
  className: "chakra-progress",
  base: {
    root: {
      textStyle: "sm",
      position: "relative"
    },
    track: {
      overflow: "hidden",
      position: "relative"
    },
    range: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transitionProperty: "width, height",
      transitionDuration: "slow",
      height: "100%",
      bgColor: "var(--track-color)",
      _indeterminate: {
        "--animate-from-x": "-40%",
        "--animate-to-x": "100%",
        position: "absolute",
        willChange: "left",
        minWidth: "50%",
        animation: "position 1s ease infinite normal none running",
        backgroundImage: "linear-gradient(to right, transparent 0%, var(--track-color) 50%, transparent 100%)"
      }
    },
    label: {
      display: "inline-flex",
      fontWeight: "medium",
      alignItems: "center",
      gap: "1"
    },
    valueText: {
      textStyle: "body2"
    }
  },
  variants: {
    variant: {
      outline: {
        track: {
          shadow: "inset",
          bgColor: "bg.muted"
        },
        range: {
          bgColor: "colorPalette.solid"
        }
      },
      subtle: {
        track: {
          bgColor: "colorPalette.muted"
        },
        range: {
          bgColor: "colorPalette.solid/72"
        }
      },
      primary: {
        track: {
          bgColor: "primary.100"
        },
        range: {
          bgColor: "primary.500"
        }
      },
      legacy: {
        track: {
          backgroundColor: "#a8b3ff33"
        },
        range: {
          background: "linear-gradient(90deg,#616ec8 68%,rgb(168 179 255 / .6) 100%)",
          _indeterminate: {
            backgroundImage: "linear-gradient(to right, transparent 0%, var(--track-color) 50%, transparent 100%)"
          }
        }
      }
    },
    shape: {
      square: {},
      rounded: {
        track: {
          borderRadius: "4px"
        }
      },
      full: {
        track: {
          borderRadius: "full"
        }
      }
    },
    striped: {
      true: {
        range: {
          backgroundImage: "linear-gradient(45deg, var(--stripe-color) 25%, transparent 25%, transparent 50%, var(--stripe-color) 50%, var(--stripe-color) 75%, transparent 75%, transparent)",
          backgroundSize: "var(--stripe-size) var(--stripe-size)",
          "--stripe-size": "1rem",
          "--stripe-color": {
            _light: "rgba(255, 255, 255, 0.3)",
            _dark: "rgba(0, 0, 0, 0.3)"
          }
        }
      }
    },
    animated: {
      true: {
        range: {
          "--animate-from": "var(--stripe-size)",
          animation: "bg-position 1s linear infinite"
        }
      }
    },
    size: {
      xs: {
        track: {
          height: "6px"
        }
      },
      sm: {
        track: {
          height: "8px"
        }
      },
      md: {
        track: {
          height: "10px"
        }
      },
      lg: {
        track: {
          height: "12px"
        }
      },
      xl: {
        track: {
          height: "16px"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outline",
    size: "md",
    shape: "rounded"
  }
});

// src/core/theme/slot-recipes/progress-circle.ts
import { defineSlotRecipe as defineSlotRecipe27 } from "@chakra-ui/react";
var progressCircleSlotRecipe = defineSlotRecipe27({
  className: "chakra-progress-circle",
  slots: ["root", "label", "track", "range", "valueText", "view", "circle", "circleTrack", "circleRange"],
  base: {
    root: {
      display: "inline-flex",
      textStyle: "sm",
      position: "relative"
    },
    circle: {
      _indeterminate: {
        animation: "spin 2s linear infinite"
      }
    },
    circleTrack: {
      "--track-color": "colors.colorPalette.muted",
      stroke: "var(--track-color)"
    },
    circleRange: {
      stroke: "colorPalette.solid",
      transitionProperty: "stroke-dasharray",
      transitionDuration: "0.6s",
      _indeterminate: {
        animation: "circular-progress 1.5s linear infinite"
      }
    },
    label: {
      display: "inline-flex"
    },
    valueText: {
      lineHeight: "1",
      fontWeight: "medium",
      letterSpacing: "tight",
      fontVariantNumeric: "tabular-nums"
    }
  },
  variants: {
    size: {
      xs: {
        circle: {
          "--size": "24px",
          "--thickness": "4px"
        },
        valueText: {
          textStyle: "2xs"
        }
      },
      sm: {
        circle: {
          "--size": "32px",
          "--thickness": "5px"
        },
        valueText: {
          textStyle: "2xs"
        }
      },
      md: {
        circle: {
          "--size": "40px",
          "--thickness": "6px"
        },
        valueText: {
          textStyle: "xs"
        }
      },
      lg: {
        circle: {
          "--size": "48px",
          "--thickness": "7px"
        },
        valueText: {
          textStyle: "sm"
        }
      },
      xl: {
        circle: {
          "--size": "64px",
          "--thickness": "8px"
        },
        valueText: {
          textStyle: "sm"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/radio-card.ts
import { defineSlotRecipe as defineSlotRecipe28 } from "@chakra-ui/react";
var radioCardSlotRecipe = defineSlotRecipe28({
  className: "chakra-radio-card",
  slots: [
    "root",
    "label",
    "item",
    "itemText",
    "itemControl",
    "indicator",
    "itemAddon",
    "itemIndicator",
    "itemContent",
    "itemDescription"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5",
      isolation: "isolate"
    },
    item: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      userSelect: "none",
      position: "relative",
      borderRadius: "8px",
      _focus: {
        background: "colorPalette.muted/20"
      },
      _disabled: {
        opacity: "0.8",
        borderColor: "border.disabled"
      },
      _checked: {
        zIndex: "1"
      }
    },
    label: {
      display: "inline-flex",
      fontWeight: "medium",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    },
    itemText: {
      fontWeight: "medium"
    },
    itemDescription: {
      opacity: "0.64",
      textStyle: "sm"
    },
    itemControl: {
      display: "inline-flex",
      flex: "1",
      pos: "relative",
      rounded: "inherit",
      justifyContent: "var(--radio-card-justify)",
      alignItems: "var(--radio-card-align)",
      _disabled: {
        background: "bg.muted"
      }
    },
    itemIndicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      verticalAlign: "top",
      color: "white",
      borderWidth: "1px",
      borderColor: "transparent",
      borderRadius: "full",
      cursor: "radio",
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing",
        outlineOffset: "2px"
      },
      _invalid: {
        colorPalette: "red",
        borderColor: "red.50"
      },
      _disabled: {
        opacity: "0.5",
        cursor: "disabled"
      },
      "& .dot": {
        height: "100%",
        width: "100%",
        borderRadius: "full",
        background: "currentColor",
        scale: "0.4"
      }
    },
    itemAddon: {
      roundedBottom: "inherit",
      _disabled: {
        color: "fg.muted"
      }
    },
    itemContent: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      gap: "1",
      justifyContent: "var(--radio-card-justify)",
      alignItems: "var(--radio-card-align)"
    }
  },
  variants: {
    size: {
      sm: {
        item: {
          textStyle: "sm"
        },
        itemControl: {
          padding: "3",
          gap: "1.5"
        },
        itemAddon: {
          paddingX: "3",
          paddingY: "1.5",
          borderTopWidth: "1px"
        },
        itemIndicator: {
          boxSize: "4"
        }
      },
      md: {
        item: {
          textStyle: "sm"
        },
        itemControl: {
          padding: "4",
          gap: "2.5"
        },
        itemAddon: {
          paddingX: "4",
          paddingY: "2",
          borderTopWidth: "1px"
        },
        itemIndicator: {
          boxSize: "5"
        }
      },
      lg: {
        item: {
          textStyle: "md"
        },
        itemControl: {
          padding: "4",
          gap: "3.5"
        },
        itemAddon: {
          paddingX: "4",
          paddingY: "2",
          borderTopWidth: "1px"
        },
        itemIndicator: {
          boxSize: "6"
        }
      }
    },
    variant: {
      surface: {
        item: {
          borderWidth: "1px",
          _checked: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg",
            borderColor: "colorPalette.muted"
          }
        },
        itemIndicator: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      },
      subtle: {
        item: {
          background: "bg.muted"
        },
        itemControl: {
          _checked: {
            background: "colorPalette.muted",
            color: "colorPalette.fg"
          }
        },
        itemIndicator: {
          borderWidth: "1px",
          borderColor: "inherit",
          _checked: {
            color: "colorPalette.fg",
            borderColor: "colorPalette.solid"
          },
          "& .dot": {
            scale: "0.6"
          }
        }
      },
      outline: {
        item: {
          borderWidth: "1px",
          _checked: {
            boxShadow: "0 0 0 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.solid",
            borderColor: "colorPalette.solid"
          }
        },
        itemIndicator: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      },
      solid: {
        item: {
          borderWidth: "1px",
          _checked: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        },
        itemIndicator: {
          background: "bg",
          borderWidth: "1px",
          borderColor: "inherit",
          _checked: {
            color: "colorPalette.solid",
            borderColor: "currentcolor"
          }
        }
      }
    },
    justify: {
      start: {
        item: {
          "--radio-card-justify": "flex-start"
        }
      },
      end: {
        item: {
          "--radio-card-justify": "flex-end"
        }
      },
      center: {
        item: {
          "--radio-card-justify": "center"
        }
      }
    },
    align: {
      start: {
        item: {
          "--radio-card-align": "flex-start"
        },
        itemControl: {
          textAlign: "start"
        }
      },
      end: {
        item: {
          "--radio-card-align": "flex-end"
        },
        itemControl: {
          textAlign: "end"
        }
      },
      center: {
        item: {
          "--radio-card-align": "center"
        },
        itemControl: {
          textAlign: "center"
        }
      }
    },
    orientation: {
      vertical: {
        itemControl: {
          flexDirection: "column"
        }
      },
      horizontal: {
        itemControl: {
          flexDirection: "row"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    align: "start",
    orientation: "horizontal"
  }
});

// src/core/theme/slot-recipes/radio-group.ts
import { defineSlotRecipe as defineSlotRecipe29 } from "@chakra-ui/react";
var radioGroupSlotRecipe = defineSlotRecipe29({
  className: "chakra-radio-group",
  slots: ["root", "label", "item", "itemText", "itemControl", "indicator", "itemAddon", "itemIndicator"],
  base: {
    item: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative",
      fontWeight: "medium",
      _disabled: {
        cursor: "disabled"
      }
    },
    itemControl: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      verticalAlign: "top",
      color: "white",
      borderWidth: "1px",
      borderColor: "transparent",
      borderRadius: "full",
      cursor: "radio",
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing",
        outlineOffset: "2px"
      },
      _invalid: {
        colorPalette: "red",
        borderColor: "red.50"
      },
      _disabled: {
        opacity: "0.5",
        cursor: "disabled"
      },
      "& .dot": {
        height: "100%",
        width: "100%",
        borderRadius: "full",
        background: "currentColor",
        scale: "0.4"
      }
    },
    label: {
      userSelect: "none",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        itemControl: {
          borderWidth: "1px",
          borderColor: "inherit",
          _checked: {
            color: "colorPalette.fg",
            borderColor: "colorPalette.solid"
          },
          "& .dot": {
            scale: "0.6"
          }
        }
      },
      subtle: {
        itemControl: {
          borderWidth: "1px",
          background: "colorPalette.muted",
          borderColor: "colorPalette.muted",
          color: "transparent",
          _checked: {
            color: "colorPalette.fg"
          }
        }
      },
      solid: {
        itemControl: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        }
      }
    },
    size: {
      xs: {
        item: {
          textStyle: "xs",
          gap: "1.5"
        },
        itemControl: {
          boxSize: "3"
        }
      },
      sm: {
        item: {
          textStyle: "sm",
          gap: "2"
        },
        itemControl: {
          boxSize: "4"
        }
      },
      md: {
        item: {
          textStyle: "sm",
          gap: "2.5"
        },
        itemControl: {
          boxSize: "5"
        }
      },
      lg: {
        item: {
          textStyle: "md",
          gap: "3"
        },
        itemControl: {
          boxSize: "6"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid"
  }
});

// src/core/theme/slot-recipes/rating-group.ts
import { defineSlotRecipe as defineSlotRecipe30 } from "@chakra-ui/react";
var ratingGroupSlotRecipe = defineSlotRecipe30({
  className: "chakra-rating-group",
  slots: ["root", "label", "item", "control", "itemIndicator"],
  base: {
    root: {
      display: "inline-flex"
    },
    control: {
      display: "inline-flex",
      alignItems: "center"
    },
    item: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none"
    },
    itemIndicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "1em",
      height: "1em",
      position: "relative",
      _icon: {
        stroke: "currentColor",
        width: "100%",
        height: "100%",
        display: "inline-block",
        flexShrink: 0,
        position: "absolute",
        left: 0,
        top: 0
      },
      "& [data-bg]": {
        color: "bg.emphasized"
      },
      "& [data-fg]": {
        color: "transparent"
      },
      "&[data-highlighted]:not([data-half])": {
        "& [data-fg]": {
          color: "colorPalette.solid"
        }
      },
      "&[data-half]": {
        "& [data-fg]": {
          color: "colorPalette.solid",
          clipPath: "inset(0 50% 0 0)"
        }
      }
    }
  },
  variants: {
    size: {
      xs: {
        item: {
          textStyle: "sm"
        }
      },
      sm: {
        item: {
          textStyle: "md"
        }
      },
      md: {
        item: {
          textStyle: "xl"
        }
      },
      lg: {
        item: {
          textStyle: "2xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/segment-group.ts
import { defineSlotRecipe as defineSlotRecipe31 } from "@chakra-ui/react";
var segmentGroupSlotRecipe = defineSlotRecipe31({
  className: "chakra-segment-group",
  slots: ["root", "label", "item", "itemText", "itemControl", "indicator"],
  base: {
    root: {
      "--segment-radius": "radii.l2",
      borderRadius: "8px",
      display: "inline-flex",
      boxShadow: "inset",
      minWidth: "max-content",
      textAlign: "center",
      position: "relative",
      isolation: "isolate",
      background: "bg.muted"
    },
    item: {
      display: "flex",
      alignItems: "center",
      userSelect: "none",
      fontSize: "sm",
      position: "relative",
      color: "fg",
      borderRadius: "var(--segment-radius)",
      _disabled: {
        opacity: "0.5"
      },
      "&:has(input:focus-visible)": {
        focusVisibleRing: "outside"
      },
      _before: {
        content: '""',
        position: "absolute",
        insetInlineStart: 0,
        insetBlock: "1.5",
        background: "border",
        width: "1px",
        transition: "opacity 0.2s"
      },
      "& + &[data-state=checked], &[data-state=checked] + &, &:first-of-type": {
        _before: {
          opacity: "0"
        }
      },
      "&[data-state=checked][data-ssr]": {
        shadow: "sm",
        background: "bg",
        borderRadius: "var(--segment-radius)"
      }
    },
    indicator: {
      shadow: "sm",
      pos: "absolute",
      background: {
        _light: "bg",
        _dark: "bg.emphasized"
      },
      width: "var(--width)",
      height: "var(--height)",
      top: "var(--top)",
      left: "var(--left)",
      zIndex: -1,
      borderRadius: "var(--segment-radius)"
    }
  },
  variants: {
    size: {
      xs: {
        root: {
          height: "6"
        },
        item: {
          textStyle: "xs",
          paddingX: "3",
          gap: "1"
        }
      },
      sm: {
        root: {
          height: "8"
        },
        item: {
          textStyle: "sm",
          paddingX: "4",
          gap: "2"
        }
      },
      md: {
        root: {
          height: "10"
        },
        item: {
          textStyle: "sm",
          paddingX: "4",
          gap: "2"
        }
      },
      lg: {
        root: {
          height: "10"
        },
        item: {
          textStyle: "md",
          paddingX: "5",
          gap: "3"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/select.ts
import { defineSlotRecipe as defineSlotRecipe32 } from "@chakra-ui/react";
var selectSlotRecipe = defineSlotRecipe32({
  className: "chakra-select",
  slots: [
    "label",
    "positioner",
    "trigger",
    "indicator",
    "clearTrigger",
    "item",
    "itemText",
    "itemIndicator",
    "itemGroup",
    "itemGroupLabel",
    "list",
    "content",
    "root",
    "control",
    "valueText",
    "indicatorGroup"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: "100%"
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      minHeight: "var(--select-trigger-height)",
      paddingX: "var(--select-trigger-padding-x)",
      borderRadius: "8px",
      userSelect: "none",
      textAlign: "start",
      cursor: "pointer",
      color: "fg",
      focusVisibleRing: "inside",
      _placeholderShown: {
        color: "fg.muted/80"
      },
      _disabled: {
        layerStyle: "disabled"
      },
      _invalid: {
        borderColor: "border.error"
      }
    },
    indicatorGroup: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      position: "absolute",
      right: "0",
      top: "0",
      bottom: "0",
      paddingX: "var(--select-trigger-padding-x)",
      pointerEvents: "none"
    },
    indicator: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: {
        base: "fg.muted",
        _disabled: "fg.subtle",
        _invalid: "fg.error"
      }
    },
    content: {
      background: "generic.0",
      display: "flex",
      flexDirection: "column",
      zIndex: "dropdown",
      borderRadius: "8px",
      outline: 0,
      maxHeight: "96px",
      overflowY: "auto",
      boxShadow: "md",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "fast"
      }
    },
    item: {
      position: "relative",
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      justifyContent: "space-between",
      flex: "1",
      textAlign: "start",
      background: "generic.0",
      color: "neutral.600",
      borderRadius: "4px",
      _highlighted: {
        background: "neutral.50",
        color: "neutral.600"
      },
      _checked: {
        background: "primary.100",
        color: "primary.600"
      },
      _hover: {
        background: "neutral.50",
        color: "neutral.600"
      },
      _disabled: {
        pointerEvents: "none",
        opacity: "0.5"
      },
      _icon: {
        width: "16px",
        height: "16px"
      }
    },
    control: {
      position: "relative"
    },
    itemText: {
      flex: "1"
    },
    itemGroup: {
      _first: {
        marginTop: "0"
      }
    },
    itemGroupLabel: {
      paddingY: "4px",
      fontWeight: "500"
    },
    label: {
      fontWeight: "500",
      color: "neutral.90",
      userSelect: "none",
      textStyle: "paragraph.medium",
      _disabled: {
        layerStyle: "disabled"
      }
    },
    valueText: {
      display: "-webkit-box",
      WebkitLineClamp: "1",
      maxWidth: "80%",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  variants: {
    variant: {
      outline: {
        trigger: {
          background: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          _expanded: {
            borderColor: "border.emphasized"
          }
        }
      },
      subtle: {
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted"
        }
      }
    },
    size: {
      xs: {
        root: {
          "--select-trigger-height": "32px",
          "--select-trigger-padding-x": "8px"
        },
        content: {
          padding: "4px",
          gap: "4px",
          fontSize: "12px"
        },
        trigger: {
          fontSize: "12px",
          gap: "4px"
        },
        item: {
          paddingY: "4px",
          paddingX: "8px"
        },
        itemGroupLabel: {
          paddingY: "4px",
          paddingX: "8px"
        },
        indicator: {
          _icon: {
            width: "14px",
            height: "14px"
          }
        }
      },
      sm: {
        root: {
          "--select-trigger-height": "36px",
          "--select-trigger-padding-x": "10px"
        },
        content: {
          padding: "4px",
          fontSize: "14px"
        },
        trigger: {
          fontSize: "14px",
          gap: "4px"
        },
        indicator: {
          _icon: {
            width: "16px",
            height: "16px"
          }
        },
        item: {
          paddingY: "4px",
          paddingX: "6px"
        },
        itemGroup: {
          marginTop: "4px"
        },
        itemGroupLabel: {
          paddingY: "4px",
          paddingX: "6px"
        }
      },
      md: {
        root: {
          "--select-trigger-height": "40px",
          "--select-trigger-padding-x": "12px"
        },
        content: {
          padding: "4px",
          fontSize: "14px"
        },
        itemGroup: {
          marginTop: "6px"
        },
        item: {
          paddingY: "12px",
          paddingX: "16px"
        },
        itemIndicator: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        itemGroupLabel: {
          paddingY: "6px",
          paddingX: "8px"
        },
        trigger: {
          fontSize: "14px",
          gap: "8px"
        },
        indicator: {
          _icon: {
            width: "16px",
            height: "16px"
          }
        }
      },
      lg: {
        root: {
          "--select-trigger-height": "48px",
          "--select-trigger-padding-x": "16px"
        },
        content: {
          padding: "6px",
          fontSize: "16px"
        },
        itemGroup: {
          marginTop: "8px"
        },
        item: {
          paddingY: "8px",
          paddingX: "12px"
        },
        itemGroupLabel: {
          paddingY: "8px",
          paddingX: "12px"
        },
        trigger: {
          fontSize: "16px",
          paddingY: "12px",
          gap: "8px"
        },
        indicator: {
          _icon: {
            width: "20px",
            height: "20px"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/slider.ts
import { defineSlotRecipe as defineSlotRecipe33 } from "@chakra-ui/react";
var sliderSlotRecipe = defineSlotRecipe33({
  className: "chakra-slider",
  slots: [
    "root",
    "label",
    "thumb",
    "valueText",
    "track",
    "range",
    "control",
    "markerGroup",
    "marker",
    "draggingIndicator",
    "markerIndicator"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1",
      textStyle: "sm",
      position: "relative",
      isolation: "isolate",
      touchAction: "none"
    },
    label: {
      fontWeight: "medium",
      textStyle: "sm"
    },
    control: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative"
    },
    track: {
      overflow: "hidden",
      borderRadius: "full",
      flex: "1"
    },
    range: {
      width: "inherit",
      height: "inherit",
      _disabled: {
        background: "border.emphasized!"
      }
    },
    markerGroup: {
      position: "absolute!",
      zIndex: "1"
    },
    marker: {
      "--marker-bg": {
        base: "white",
        _underValue: "colors.bg"
      },
      display: "flex",
      alignItems: "center",
      gap: "calc(var(--slider-thumb-size) / 2)",
      color: "fg.muted",
      textStyle: "xs"
    },
    markerIndicator: {
      width: "var(--slider-marker-size)",
      height: "var(--slider-marker-size)",
      borderRadius: "full",
      background: "var(--marker-bg)"
    },
    thumb: {
      width: "var(--slider-thumb-size)",
      height: "var(--slider-thumb-size)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: 0,
      zIndex: "2",
      borderRadius: "full",
      _focusVisible: {
        ring: "2px",
        ringColor: "colorPalette.focusRing",
        ringOffset: "2px",
        ringOffsetColor: "bg"
      }
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          "--slider-thumb-size": "sizes.4",
          "--slider-track-size": "sizes.1.5",
          "--slider-marker-center": "6px",
          "--slider-marker-size": "sizes.1",
          "--slider-marker-inset": "3px"
        }
      },
      md: {
        root: {
          "--slider-thumb-size": "sizes.5",
          "--slider-track-size": "sizes.2",
          "--slider-marker-center": "8px",
          "--slider-marker-size": "sizes.1",
          "--slider-marker-inset": "4px"
        }
      },
      lg: {
        root: {
          "--slider-thumb-size": "sizes.6",
          "--slider-track-size": "sizes.2.5",
          "--slider-marker-center": "9px",
          "--slider-marker-size": "sizes.1.5",
          "--slider-marker-inset": "5px"
        }
      }
    },
    variant: {
      outline: {
        track: {
          shadow: "inset",
          background: "bg.emphasized/72"
        },
        range: {
          background: "colorPalette.solid"
        },
        thumb: {
          borderWidth: "2px",
          borderColor: "colorPalette.solid",
          background: "bg",
          _disabled: {
            background: "border.emphasized",
            borderColor: "border.emphasized"
          }
        }
      },
      solid: {
        track: {
          background: "colorPalette.subtle",
          _disabled: {
            background: "bg.muted"
          }
        },
        range: {
          background: "colorPalette.solid"
        },
        thumb: {
          background: "colorPalette.solid",
          _disabled: {
            background: "border.emphasized"
          }
        }
      }
    },
    orientation: {
      vertical: {
        root: {
          display: "inline-flex"
        },
        control: {
          flexDirection: "column",
          height: "100%",
          minWidth: "var(--slider-thumb-size)",
          "&[data-has-mark-label]": {
            marginEnd: "4"
          }
        },
        track: {
          width: "var(--slider-track-size)"
        },
        thumb: {
          left: "50%",
          translate: "-50% 0"
        },
        markerGroup: {
          insetStart: "var(--slider-marker-center)",
          insetBlock: "var(--slider-marker-inset)"
        },
        marker: {
          flexDirection: "row"
        }
      },
      horizontal: {
        control: {
          flexDirection: "row",
          width: "100%",
          minHeight: "var(--slider-thumb-size)",
          "&[data-has-mark-label]": {
            marginBottom: "4"
          }
        },
        track: {
          height: "var(--slider-track-size)"
        },
        thumb: {
          top: "50%",
          translate: "0 -50%"
        },
        markerGroup: {
          top: "var(--slider-marker-center)",
          insetInline: "var(--slider-marker-inset)"
        },
        marker: {
          flexDirection: "column"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    orientation: "horizontal"
  }
});

// src/core/theme/slot-recipes/stat.ts
import { defineSlotRecipe as defineSlotRecipe34 } from "@chakra-ui/react";
var statSlotRecipe = defineSlotRecipe34({
  className: "chakra-stat",
  slots: ["root", "label", "helpText", "valueText", "valueUnit", "indicator"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1",
      position: "relative",
      flex: "1"
    },
    label: {
      display: "inline-flex",
      gap: "1.5",
      alignItems: "center",
      color: "fg.muted",
      textStyle: "sm"
    },
    helpText: {
      color: "fg.muted",
      textStyle: "xs"
    },
    valueUnit: {
      color: "fg.muted",
      textStyle: "xs",
      fontWeight: "initial",
      letterSpacing: "initial"
    },
    valueText: {
      verticalAlign: "baseline",
      fontWeight: "semibold",
      letterSpacing: "tight",
      fontFeatureSettings: "pnum",
      fontVariantNumeric: "proportional-nums",
      display: "inline-flex",
      gap: "1"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      marginEnd: 1,
      "& :where(svg)": {
        w: "1em",
        height: "1em"
      },
      "&[data-type=up]": {
        color: "fg.success"
      },
      "&[data-type=down]": {
        color: "fg.error"
      }
    }
  },
  variants: {
    size: {
      sm: {
        valueText: {
          textStyle: "xl"
        }
      },
      md: {
        valueText: {
          textStyle: "2xl"
        }
      },
      lg: {
        valueText: {
          textStyle: "3xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/steps.ts
import { defineSlotRecipe as defineSlotRecipe35 } from "@chakra-ui/react";
var stepsSlotRecipe = defineSlotRecipe35({
  className: "chakra-steps",
  slots: [
    "root",
    "list",
    "item",
    "trigger",
    "indicator",
    "separator",
    "content",
    "title",
    "description",
    "nextTrigger",
    "prevTrigger",
    "progress"
  ],
  base: {
    root: {
      display: "flex",
      width: "full"
    },
    list: {
      display: "flex",
      justifyContent: "space-between",
      "--steps-gutter": "spacing.3",
      "--steps-thickness": "2px"
    },
    title: {
      fontWeight: "medium",
      color: "fg"
    },
    description: {
      color: "fg.muted"
    },
    separator: {
      background: "border",
      flex: "1"
    },
    indicator: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      borderRadius: "full",
      fontWeight: "medium",
      width: "var(--steps-size)",
      height: "var(--steps-size)",
      _icon: {
        flexShrink: "0",
        width: "var(--steps-icon-size)",
        height: "var(--steps-icon-size)"
      }
    },
    item: {
      position: "relative",
      display: "flex",
      flex: "1 0 0",
      "&:last-of-type": {
        flex: "initial",
        "& [data-part=separator]": {
          display: "none"
        }
      }
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      gap: "3",
      textAlign: "start",
      focusVisibleRing: "outside",
      borderRadius: "8px"
    },
    content: {
      focusVisibleRing: "outside"
    }
  },
  variants: {
    orientation: {
      vertical: {
        root: {
          flexDirection: "row",
          height: "100%"
        },
        list: {
          flexDirection: "column",
          alignItems: "flex-start"
        },
        separator: {
          position: "absolute",
          width: "var(--steps-thickness)",
          height: "100%",
          maxHeight: "calc(100% - var(--steps-size) - var(--steps-gutter) * 2)",
          top: "calc(var(--steps-size) + var(--steps-gutter))",
          insetStart: "calc(var(--steps-size) / 2 - 1px)"
        },
        item: {
          alignItems: "flex-start"
        }
      },
      horizontal: {
        root: {
          flexDirection: "column",
          width: "100%"
        },
        list: {
          flexDirection: "row",
          alignItems: "center"
        },
        separator: {
          width: "100%",
          height: "var(--steps-thickness)",
          marginX: "var(--steps-gutter)"
        },
        item: {
          alignItems: "center"
        }
      }
    },
    variant: {
      solid: {
        indicator: {
          _incomplete: {
            borderWidth: "var(--steps-thickness)"
          },
          _current: {
            background: "colorPalette.muted",
            borderWidth: "var(--steps-thickness)",
            borderColor: "colorPalette.solid",
            color: "colorPalette.fg"
          },
          _complete: {
            background: "colorPalette.solid",
            borderColor: "colorPalette.solid",
            color: "colorPalette.contrast"
          }
        },
        separator: {
          _complete: {
            background: "colorPalette.solid"
          }
        }
      },
      subtle: {
        indicator: {
          _incomplete: {
            background: "bg.muted"
          },
          _current: {
            background: "colorPalette.muted",
            color: "colorPalette.fg"
          },
          _complete: {
            background: "colorPalette.emphasized",
            color: "colorPalette.fg"
          }
        },
        separator: {
          _complete: {
            background: "colorPalette.emphasized"
          }
        }
      }
    },
    size: {
      xs: {
        root: {
          gap: "2.5"
        },
        list: {
          "--steps-size": "sizes.6",
          "--steps-icon-size": "sizes.3.5",
          textStyle: "xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      sm: {
        root: {
          gap: "3"
        },
        list: {
          "--steps-size": "sizes.8",
          "--steps-icon-size": "sizes.4",
          textStyle: "xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      md: {
        root: {
          gap: "4"
        },
        list: {
          "--steps-size": "sizes.100",
          "--steps-icon-size": "sizes.4",
          textStyle: "sm"
        },
        title: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          gap: "6"
        },
        list: {
          "--steps-size": "sizes.11",
          "--steps-icon-size": "sizes.5",
          textStyle: "md"
        },
        title: {
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid",
    orientation: "horizontal"
  }
});

// src/core/theme/slot-recipes/switch.ts
import { defineSlotRecipe as defineSlotRecipe36 } from "@chakra-ui/react";
var switchSlotRecipe = defineSlotRecipe36({
  slots: ["root", "label", "control", "thumb", "indicator"],
  className: "chakra-switch",
  base: {
    root: {
      display: "inline-flex",
      gap: "2.5",
      alignItems: "center",
      position: "relative",
      verticalAlign: "middle",
      "--switch-diff": "calc(var(--switch-width) - var(--switch-height))",
      "--switch-x": {
        base: "var(--switch-diff)",
        _rtl: "calc(var(--switch-diff) * -1)"
      }
    },
    label: {
      lineHeight: "1",
      userSelect: "none",
      fontSize: "sm",
      fontWeight: "medium",
      _disabled: {
        opacity: "0.5"
      }
    },
    indicator: {
      position: "absolute",
      height: "var(--switch-height)",
      width: "var(--switch-height)",
      fontSize: "var(--switch-indicator-font-size)",
      fontWeight: "medium",
      flexShrink: 0,
      userSelect: "none",
      display: "grid",
      placeContent: "center",
      transition: "inset-inline-start 0.12s ease",
      insetInlineStart: "calc(var(--switch-x) - 2px)",
      _checked: {
        insetInlineStart: "2px"
      }
    },
    control: {
      display: "inline-flex",
      gap: "0.5rem",
      flexShrink: 0,
      justifyContent: "flex-start",
      cursor: "switch",
      borderRadius: "full",
      position: "relative",
      width: "var(--switch-width)",
      height: "var(--switch-height)",
      _disabled: {
        opacity: "0.5",
        cursor: "not-allowed"
      },
      _invalid: {
        outline: "2px solid",
        outlineColor: "border.error",
        outlineOffset: "2px"
      }
    },
    thumb: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      transitionProperty: "translate",
      transitionDuration: "fast",
      borderRadius: "inherit",
      _checked: {
        translate: "var(--switch-x) 0"
      }
    }
  },
  variants: {
    variant: {
      solid: {
        control: {
          borderRadius: "full",
          background: "bg.emphasized",
          focusVisibleRing: "outside",
          _checked: {
            background: "colorPalette.solid"
          }
        },
        thumb: {
          background: "white",
          width: "var(--switch-height)",
          height: "var(--switch-height)",
          scale: "0.8",
          boxShadow: "sm",
          _checked: {
            background: "colorPalette.contrast"
          }
        }
      },
      raised: {
        control: {
          borderRadius: "full",
          height: "calc(var(--switch-height) / 2)",
          background: "bg.muted",
          boxShadow: "inset",
          _checked: {
            background: "colorPalette.solid/60"
          }
        },
        thumb: {
          width: "var(--switch-height)",
          height: "var(--switch-height)",
          position: "relative",
          top: "calc(var(--switch-height) * -0.25)",
          background: "white",
          boxShadow: "xs",
          focusVisibleRing: "outside",
          _checked: {
            background: "colorPalette.solid"
          }
        }
      }
    },
    size: {
      xs: {
        root: {
          "--switch-width": "sizes.6",
          "--switch-height": "sizes.3",
          "--switch-indicator-font-size": "fontSizes.xs"
        }
      },
      sm: {
        root: {
          "--switch-width": "sizes.8",
          "--switch-height": "sizes.4",
          "--switch-indicator-font-size": "fontSizes.xs"
        }
      },
      md: {
        root: {
          "--switch-width": "sizes.100",
          "--switch-height": "sizes.5",
          "--switch-indicator-font-size": "fontSizes.sm"
        }
      },
      lg: {
        root: {
          "--switch-width": "sizes.12",
          "--switch-height": "sizes.6",
          "--switch-indicator-font-size": "fontSizes.md"
        }
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
});

// src/core/theme/slot-recipes/table.ts
import { defineSlotRecipe as defineSlotRecipe37 } from "@chakra-ui/react";
var tableSlotRecipe = defineSlotRecipe37({
  className: "chakra-table",
  slots: ["root", "header", "body", "row", "columnHeader", "cell", "footer", "caption"],
  base: {
    root: {
      fontVariantNumeric: "lining-nums tabular-nums",
      borderCollapse: "collapse",
      width: "full",
      textAlign: "start",
      verticalAlign: "top"
    },
    row: {
      _selected: {
        background: "colorPalette.subtle"
      }
    },
    cell: {
      textAlign: "start",
      alignItems: "center"
    },
    columnHeader: {
      fontWeight: "medium",
      textAlign: "start",
      color: "fg"
    },
    caption: {
      fontWeight: "medium",
      textStyle: "xs"
    },
    footer: {
      fontWeight: "medium"
    }
  },
  variants: {
    interactive: {
      true: {
        body: {
          "& tr": {
            _hover: {
              background: "colorPalette.subtle"
            }
          }
        }
      }
    },
    stickyHeader: {
      true: {
        header: {
          "& :where(tr)": {
            top: "var(--table-sticky-offset, 0)",
            position: "sticky",
            zIndex: 1
          }
        }
      }
    },
    striped: {
      true: {
        row: {
          "&:nth-of-type(odd) td": {
            background: "bg.muted"
          }
        }
      }
    },
    showColumnBorder: {
      true: {
        columnHeader: {
          "&:not(:last-of-type)": {
            borderInlineEndWidth: "1px"
          }
        },
        cell: {
          "&:not(:last-of-type)": {
            borderInlineEndWidth: "1px"
          }
        }
      }
    },
    variant: {
      line: {
        columnHeader: {
          borderBottomWidth: "1px"
        },
        cell: {
          borderBottomWidth: "1px"
        },
        row: {
          background: "bg"
        }
      },
      outline: {
        root: {
          boxShadow: "0 0 0 1px {colors.border}",
          overflow: "hidden"
        },
        columnHeader: {
          borderBottomWidth: "1px"
        },
        header: {
          background: "bg.muted"
        },
        row: {
          "&:not(:last-of-type)": {
            borderBottomWidth: "1px"
          }
        },
        footer: {
          borderTopWidth: "1px"
        }
      }
    },
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        columnHeader: {
          paddingX: "2",
          paddingY: "2"
        },
        cell: {
          paddingX: "2",
          paddingY: "2"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        },
        columnHeader: {
          paddingX: "3",
          paddingY: "3"
        },
        cell: {
          paddingX: "3",
          paddingY: "3"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        },
        columnHeader: {
          paddingX: "4",
          paddingY: "3"
        },
        cell: {
          paddingX: "4",
          paddingY: "3"
        }
      }
    }
  },
  defaultVariants: {
    variant: "line",
    size: "md"
  }
});

// src/core/theme/slot-recipes/tabs.ts
import { defineSlotRecipe as defineSlotRecipe38 } from "@chakra-ui/react";
var tabsSlotRecipe = defineSlotRecipe38({
  slots: ["root", "trigger", "list", "content", "contentGroup", "indicator"],
  className: "chakra-tabs",
  base: {
    root: {
      "--tabs-trigger-radius": "radii.l2",
      position: "relative",
      _horizontal: {
        display: "block"
      },
      _vertical: {
        display: "flex"
      }
    },
    list: {
      display: "inline-flex",
      position: "relative",
      isolation: "isolate",
      "--tabs-indicator-shadow": "shadows.xs",
      "--tabs-indicator-bg": "colors.bg",
      minH: "var(--tabs-height)",
      _horizontal: {
        flexDirection: "row"
      },
      _vertical: {
        flexDirection: "column"
      }
    },
    trigger: {
      outline: "0",
      minWidth: "var(--tabs-height)",
      height: "var(--tabs-height)",
      display: "flex",
      alignItems: "center",
      fontWeight: "medium",
      position: "relative",
      cursor: "button",
      gap: "2",
      _focusVisible: {
        zIndex: 1,
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing"
      },
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.5
      }
    },
    content: {
      focusVisibleRing: "inside",
      _horizontal: {
        width: "100%",
        pt: "var(--tabs-content-padding)"
      },
      _vertical: {
        height: "100%",
        ps: "var(--tabs-content-padding)"
      }
    },
    indicator: {
      width: "var(--width)",
      height: "var(--height)",
      borderRadius: "var(--tabs-indicator-radius)",
      background: "var(--tabs-indicator-bg)",
      shadow: "var(--tabs-indicator-shadow)",
      zIndex: -1
    }
  },
  variants: {
    fitted: {
      true: {
        list: {
          display: "flex"
        },
        trigger: {
          flex: 1,
          textAlign: "center",
          justifyContent: "center"
        }
      }
    },
    justify: {
      start: {
        list: {
          justifyContent: "flex-start"
        }
      },
      center: {
        list: {
          justifyContent: "center"
        }
      },
      end: {
        list: {
          justifyContent: "flex-end"
        }
      }
    },
    size: {
      sm: {
        root: {
          "--tabs-height": "sizes.9",
          "--tabs-content-padding": "spacing.3"
        },
        trigger: {
          paddingY: "1",
          paddingX: "3",
          textStyle: "sm"
        }
      },
      md: {
        root: {
          "--tabs-height": "sizes.100",
          "--tabs-content-padding": "spacing.4"
        },
        trigger: {
          paddingY: "2",
          paddingX: "4",
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          "--tabs-height": "sizes.11",
          "--tabs-content-padding": "spacing.4.5"
        },
        trigger: {
          paddingY: "2",
          paddingX: "4.5",
          textStyle: "md"
        }
      }
    },
    variant: {
      line: {
        list: {
          display: "flex",
          borderColor: "border",
          _horizontal: {
            borderBottomWidth: "1px"
          },
          _vertical: {
            borderEndWidth: "1px"
          }
        },
        trigger: {
          color: "fg.muted",
          _disabled: {
            _active: {
              background: "initial"
            }
          },
          _selected: {
            color: "fg",
            _horizontal: {
              layerStyle: "indicator.bottom",
              "--indicator-offset-y": "-1px",
              "--indicator-color": "colors.colorPalette.solid"
            },
            _vertical: {
              layerStyle: "indicator.end",
              "--indicator-offset-x": "-1px"
            }
          }
        }
      },
      subtle: {
        trigger: {
          borderRadius: "var(--tabs-trigger-radius)",
          color: "fg.muted",
          _selected: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg"
          }
        }
      },
      enclosed: {
        list: {
          background: "bg.muted",
          padding: "1",
          borderRadius: "12px",
          minH: "calc(var(--tabs-height) - 4px)"
        },
        trigger: {
          justifyContent: "center",
          color: "fg.muted",
          borderRadius: "var(--tabs-trigger-radius)",
          _selected: {
            background: "bg",
            color: "colorPalette.fg",
            shadow: "xs"
          }
        }
      },
      outline: {
        list: {
          "--line-thickness": "1px",
          "--line-offset": "calc(var(--line-thickness) * -1)",
          borderColor: "border",
          display: "flex",
          _horizontal: {
            _before: {
              content: '""',
              position: "absolute",
              bottom: "0px",
              width: "100%",
              borderBottomWidth: "var(--line-thickness)",
              borderBottomColor: "border"
            }
          },
          _vertical: {
            _before: {
              content: '""',
              position: "absolute",
              insetInline: "var(--line-offset)",
              height: "calc(100% - calc(var(--line-thickness) * 2))",
              borderEndWidth: "var(--line-thickness)",
              borderEndColor: "border"
            }
          }
        },
        trigger: {
          color: "fg.muted",
          borderWidth: "1px",
          borderColor: "transparent",
          _selected: {
            background: "currentBg",
            color: "colorPalette.fg"
          },
          _horizontal: {
            borderTopRadius: "var(--tabs-trigger-radius)",
            marginBottom: "var(--line-offset)",
            marginEnd: {
              _notLast: "var(--line-offset)"
            },
            _selected: {
              borderColor: "border",
              borderBottomColor: "transparent"
            }
          },
          _vertical: {
            borderStartRadius: "var(--tabs-trigger-radius)",
            marginEnd: "var(--line-offset)",
            marginBottom: {
              _notLast: "var(--line-offset)"
            },
            _selected: {
              borderColor: "border",
              borderEndColor: "transparent"
            }
          }
        }
      },
      plain: {
        trigger: {
          color: "fg.muted",
          _selected: {
            color: "colorPalette.fg"
          },
          borderRadius: "var(--tabs-trigger-radius)",
          "&[data-selected][data-ssr]": {
            background: "var(--tabs-indicator-bg)",
            shadow: "var(--tabs-indicator-shadow)",
            borderRadius: "var(--tabs-indicator-radius)"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "line"
  }
});

// src/core/theme/slot-recipes/tag.ts
import { defineSlotRecipe as defineSlotRecipe39 } from "@chakra-ui/react";
var tagSlotRecipe = defineSlotRecipe39({
  slots: ["root", "label", "closeTrigger", "startElement", "endElement"],
  className: "chakra-tag",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      verticalAlign: "top",
      maxWidth: "100%",
      userSelect: "none",
      borderRadius: "8px",
      focusVisibleRing: "outside"
    },
    label: {
      lineClamp: "1"
    },
    closeTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "0",
      borderRadius: "4px",
      color: "currentColor",
      focusVisibleRing: "inside",
      focusRingWidth: "2px"
    },
    startElement: {
      flexShrink: 0,
      boxSize: "var(--tag-element-size)",
      ms: "var(--tag-element-offset)",
      "&:has([data-scope=avatar])": {
        boxSize: "var(--tag-avatar-size)",
        ms: "calc(var(--tag-element-offset) * 1.5)"
      },
      _icon: {
        boxSize: "100%"
      }
    },
    endElement: {
      flexShrink: 0,
      boxSize: "var(--tag-element-size)",
      me: "var(--tag-element-offset)",
      _icon: {
        boxSize: "100%"
      },
      "&:has(button)": {
        ms: "calc(var(--tag-element-offset) * -1)"
      }
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          paddingX: "1.5",
          minH: "4.5",
          gap: "1",
          "--tag-avatar-size": "spacing.3",
          "--tag-element-size": "spacing.3",
          "--tag-element-offset": "-2px"
        },
        label: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          paddingX: "1.5",
          minH: "5",
          gap: "1",
          "--tag-avatar-size": "spacing.3.5",
          "--tag-element-size": "spacing.3.5",
          "--tag-element-offset": "-2px"
        },
        label: {
          textStyle: "xs"
        }
      },
      lg: {
        root: {
          paddingX: "2",
          minH: "6",
          gap: "1.5",
          "--tag-avatar-size": "spacing.4.5",
          "--tag-element-size": "spacing.4",
          "--tag-element-offset": "-3px"
        },
        label: {
          textStyle: "sm"
        }
      },
      xl: {
        root: {
          paddingX: "2.5",
          minH: "8",
          gap: "1.5",
          "--tag-avatar-size": "spacing.6",
          "--tag-element-size": "spacing.4.5",
          "--tag-element-offset": "-4px"
        },
        label: {
          textStyle: "sm"
        }
      }
    },
    variant: {
      subtle: {
        root: {
          background: "colorPalette.subtle",
          color: "colorPalette.fg"
        }
      },
      solid: {
        root: {
          background: "colorPalette.solid",
          color: "colorPalette.contrast"
        }
      },
      outline: {
        root: {
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        }
      },
      surface: {
        root: {
          background: "colorPalette.subtle",
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "surface"
  }
});

// src/core/theme/slot-recipes/toast.ts
import { defineSlotRecipe as defineSlotRecipe40 } from "@chakra-ui/react";
var toastSlotRecipe = defineSlotRecipe40({
  slots: ["root", "title", "description", "indicator", "closeTrigger", "actionTrigger"],
  className: "chakra-toast",
  base: {
    root: {
      width: "full",
      display: "flex",
      alignItems: "flex-start",
      position: "relative",
      gap: "3",
      paddingY: "4",
      ps: "4",
      pe: "6",
      borderRadius: "8px",
      translate: "var(--x) var(--y)",
      scale: "var(--scale)",
      zIndex: "var(--z-index)",
      height: "var(--height)",
      opacity: "var(--opacity)",
      willChange: "translate, opacity, scale",
      transition: "translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms",
      transitionTimingFunction: "cubic-bezier(0.21, 1.02, 0.73, 1)",
      _closed: {
        transition: "translate 400ms, scale 400ms, opacity 200ms",
        transitionTimingFunction: "cubic-bezier(0.06, 0.71, 0.55, 1)"
      },
      background: "bg.panel",
      color: "fg",
      boxShadow: "xl",
      "--toast-trigger-bg": "colors.bg.muted",
      "&[data-type=warning]": {
        background: "orange.solid",
        color: "orange.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      },
      "&[data-type=success]": {
        background: "green.solid",
        color: "green.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      },
      "&[data-type=error]": {
        background: "red.solid",
        color: "red.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      }
    },
    title: {
      fontWeight: "medium",
      textStyle: "body2",
      marginEnd: "2"
    },
    description: {
      display: "inline",
      textStyle: "body3"
    },
    indicator: {
      flexShrink: "0",
      boxSize: "5"
    },
    actionTrigger: {
      textStyle: "body3",
      fontWeight: "medium",
      height: "8",
      paddingX: "3",
      borderRadius: "8px",
      alignSelf: "center",
      borderWidth: "1px",
      borderColor: "var(--toast-border-color, inherit)",
      transition: "background 200ms",
      _hover: {
        background: "var(--toast-trigger-bg)"
      }
    },
    closeTrigger: {
      position: "absolute",
      top: "1",
      insetEnd: "1",
      padding: "1",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "{currentColor/60}",
      borderRadius: "8px",
      textStyle: "body3",
      transition: "background 200ms",
      _icon: {
        boxSize: "1em"
      }
    }
  }
});

// src/core/theme/slot-recipes/tooltip.ts
import { defineSlotRecipe as defineSlotRecipe41 } from "@chakra-ui/react";
var tooltipSlotRecipe = defineSlotRecipe41({
  slots: ["trigger", "arrow", "arrowTip", "positioner", "content"],
  className: "chakra-tooltip",
  base: {
    content: {
      "--tooltip-bg": "colors.bg.inverted",
      background: "var(--tooltip-bg)",
      color: "fg.inverted",
      paddingX: "2.5",
      paddingY: "1",
      borderRadius: "8px",
      fontWeight: "medium",
      textStyle: "xs",
      boxShadow: "md",
      maxW: "xs",
      zIndex: "tooltip",
      transformOrigin: "var(--transform-origin)",
      _open: {
        animationStyle: "scale-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "scale-fade-out",
        animationDuration: "fast"
      }
    },
    arrow: {
      "--arrow-size": "sizes.2",
      "--arrow-background": "var(--tooltip-bg)"
    },
    arrowTip: {
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px",
      borderColor: "var(--tooltip-bg)"
    }
  }
});

// src/core/theme/slot-recipes/status.ts
import { defineSlotRecipe as defineSlotRecipe42 } from "@chakra-ui/react";
var statusSlotRecipe = defineSlotRecipe42({
  className: "chakra-status",
  slots: ["root", "indicator"],
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      gap: "2"
    },
    indicator: {
      width: "0.64em",
      height: "0.64em",
      flexShrink: 0,
      borderRadius: "full",
      forcedColorAdjust: "none",
      background: "colorPalette.solid"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/timeline.ts
import { defineSlotRecipe as defineSlotRecipe43 } from "@chakra-ui/react";
var timelineSlotRecipe = defineSlotRecipe43({
  slots: ["root", "item", "content", "separator", "indicator", "connector", "title", "description"],
  className: "chakra-timeline",
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "full",
      "--timeline-thickness": "1px",
      "--timeline-gutter": "4px"
    },
    item: {
      display: "flex",
      position: "relative",
      alignItems: "flex-start",
      flexShrink: 0,
      gap: "4",
      _last: {
        "& :where(.chakra-timeline__separator)": {
          display: "none"
        }
      }
    },
    separator: {
      position: "absolute",
      borderStartWidth: "var(--timeline-thickness)",
      ms: "calc(-1 * var(--timeline-thickness) / 2)",
      insetInlineStart: "calc(var(--timeline-indicator-size) / 2)",
      insetBlock: "0",
      borderColor: "border"
    },
    indicator: {
      outline: "2px solid {colors.bg}",
      position: "relative",
      flexShrink: "0",
      boxSize: "var(--timeline-indicator-size)",
      fontSize: "var(--timeline-font-size)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      fontWeight: "medium"
    },
    connector: {
      alignSelf: "stretch",
      position: "relative"
    },
    content: {
      pb: "6",
      display: "flex",
      flexDirection: "column",
      width: "full",
      gap: "2"
    },
    title: {
      display: "flex",
      fontWeight: "medium",
      flexWrap: "wrap",
      gap: "1.5",
      alignItems: "center",
      mt: "var(--timeline-margin)"
    },
    description: {
      color: "fg.muted",
      textStyle: "xs"
    }
  },
  variants: {
    variant: {
      subtle: {
        indicator: {
          background: "colorPalette.muted"
        }
      },
      solid: {
        indicator: {
          background: "colorPalette.solid",
          color: "colorPalette.contrast"
        }
      },
      outline: {
        indicator: {
          background: "currentBg",
          borderWidth: "1px",
          borderColor: "colorPalette.muted"
        }
      },
      plain: {}
    },
    size: {
      sm: {
        root: {
          "--timeline-indicator-size": "sizes.4",
          "--timeline-font-size": "fontSizes.2xs"
        },
        title: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          "--timeline-indicator-size": "sizes.5",
          "--timeline-font-size": "fontSizes.xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          "--timeline-indicator-size": "sizes.6",
          "--timeline-font-size": "fontSizes.xs"
        },
        title: {
          mt: "0.5",
          textStyle: "sm"
        }
      },
      xl: {
        root: {
          "--timeline-indicator-size": "sizes.8",
          "--timeline-font-size": "fontSizes.sm"
        },
        title: {
          mt: "1.5",
          textStyle: "sm"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid"
  }
});

// src/core/theme/slot-recipes/color-picker.ts
import { defineSlotRecipe as defineSlotRecipe44 } from "@chakra-ui/react";
var colorPickerSlotRecipe = defineSlotRecipe44({
  className: "colorPicker",
  slots: [
    "root",
    "label",
    "control",
    "trigger",
    "positioner",
    "content",
    "area",
    "areaThumb",
    "valueText",
    "areaBackground",
    "channelSlider",
    "channelSliderLabel",
    "channelSliderTrack",
    "channelSliderThumb",
    "channelSliderValueText",
    "channelInput",
    "transparencyGrid",
    "swatchGroup",
    "swatchTrigger",
    "swatchIndicator",
    "swatch",
    "eyeDropperTrigger",
    "formatTrigger",
    "formatSelect",
    "view"
  ],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    label: {
      color: "fg",
      fontWeight: "medium",
      textStyle: "sm"
    },
    valueText: {
      textAlign: "start"
    },
    control: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: "2",
      position: "relative"
    },
    swatchTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      flexShrink: "0",
      gap: "2",
      textStyle: "sm",
      minH: "var(--input-height)",
      minWidth: "var(--input-height)",
      paddingX: "1",
      rounded: "8px",
      _disabled: {
        opacity: "0.5"
      },
      "--focus-color": "colors.colorPalette.focusRing",
      "&:focus-visible": {
        borderColor: "var(--focus-color)",
        outline: "1px solid var(--focus-color)"
      },
      "&[data-fit-content]": {
        "--input-height": "unset",
        paddingX: "0",
        border: "0"
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      background: "bg.panel",
      borderRadius: "12px",
      boxShadow: "lg",
      width: "64",
      p: "4",
      gap: "3",
      zIndex: "dropdown",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    area: {
      height: "180px",
      borderRadius: "8px",
      overflow: "hidden"
    },
    areaThumb: {
      borderRadius: "full",
      height: "var(--thumb-size)",
      width: "var(--thumb-size)",
      borderWidth: "2px",
      borderColor: "white",
      shadow: "sm",
      focusVisibleRing: "mixed",
      focusRingColor: "white"
    },
    areaBackground: {
      height: "full"
    },
    channelSlider: {
      borderRadius: "8px",
      flex: "1"
    },
    channelSliderTrack: {
      height: "var(--slider-height)",
      borderRadius: "inherit",
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    },
    swatchGroup: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "2"
    },
    swatch: {
      boxSize: "var(--swatch-size)",
      shadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
      "--checker-size": "8px",
      "--checker-bg": "colors.bg",
      "--checker-fg": "colors.bg.emphasized",
      background: "linear-gradient(var(--color), var(--color)), repeating-conic-gradient(var(--checker-fg) 0%, var(--checker-fg) 25%, var(--checker-bg) 0%, var(--checker-bg) 50%) 0% 50% / var(--checker-size) var(--checker-size) !important",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      borderRadius: "4px"
    },
    swatchIndicator: {
      color: "white",
      rounded: "full"
    },
    channelSliderThumb: {
      borderRadius: "full",
      height: "var(--thumb-size)",
      width: "var(--thumb-size)",
      borderWidth: "2px",
      borderColor: "white",
      shadow: "sm",
      transform: "translate(-50%, -50%)",
      focusVisibleRing: "outside",
      focusRingOffset: "1px"
    },
    channelInput: {
      width: "100%",
      outline: "0",
      position: "relative",
      appearance: "none",
      textAlign: "start",
      borderRadius: "8px",
      _disabled: {
        layerStyle: "disabled"
      },
      height: "var(--input-height)",
      minWidth: "var(--input-height)",
      "--focus-color": "colors.colorPalette.focusRing",
      "--error-color": "colors.border.error",
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      },
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0
      }
    },
    formatSelect: {
      textStyle: "xs",
      textTransform: "uppercase",
      borderWidth: "1px",
      minH: "6",
      focusVisibleRing: "inside",
      rounded: "8px"
    },
    transparencyGrid: {
      borderRadius: "8px"
    },
    view: {
      display: "flex",
      flexDirection: "column",
      gap: "2"
    }
  },
  variants: {
    size: {
      "2xs": {
        channelInput: {
          textStyle: "xs",
          paddingX: "2",
          "--input-height": "sizes.7"
        },
        swatch: {
          "--swatch-size": "sizes.4.5"
        },
        trigger: {
          "--input-height": "sizes.7"
        },
        area: {
          "--thumb-size": "sizes.3"
        },
        channelSlider: {
          "--slider-height": "sizes.3",
          "--thumb-size": "sizes.3"
        }
      },
      xs: {
        channelInput: {
          textStyle: "xs",
          paddingX: "2",
          "--input-height": "sizes.8"
        },
        swatch: {
          "--swatch-size": "sizes.5"
        },
        trigger: {
          "--input-height": "sizes.8"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      sm: {
        channelInput: {
          textStyle: "sm",
          paddingX: "2.5",
          "--input-height": "sizes.9"
        },
        swatch: {
          "--swatch-size": "sizes.6"
        },
        trigger: {
          "--input-height": "sizes.9"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      md: {
        channelInput: {
          textStyle: "sm",
          paddingX: "3",
          "--input-height": "sizes.100"
        },
        swatch: {
          "--swatch-size": "sizes.7"
        },
        trigger: {
          "--input-height": "sizes.100"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      lg: {
        channelInput: {
          textStyle: "md",
          paddingX: "4",
          "--input-height": "sizes.11"
        },
        swatch: {
          "--swatch-size": "sizes.7"
        },
        trigger: {
          "--input-height": "sizes.11"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      xl: {
        channelInput: {
          textStyle: "md",
          paddingX: "4.5",
          "--input-height": "sizes.12"
        },
        swatch: {
          "--swatch-size": "sizes.8"
        },
        trigger: {
          "--input-height": "sizes.12"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      "2xl": {
        channelInput: {
          textStyle: "lg",
          paddingX: "5",
          "--input-height": "sizes.16"
        },
        swatch: {
          "--swatch-size": "sizes.100"
        },
        trigger: {
          "--input-height": "sizes.16"
        },
        area: {
          "--thumb-size": "sizes.3.5"
        },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      }
    },
    variant: {
      outline: {
        channelInput: {
          background: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          focusVisibleRing: "inside"
        },
        trigger: {
          borderWidth: "1px"
        }
      },
      subtle: {
        channelInput: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted",
          focusVisibleRing: "inside"
        },
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          background: "bg.muted"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});

// src/core/theme/slot-recipes/qr-code.ts
import { defineSlotRecipe as defineSlotRecipe45 } from "@chakra-ui/react";
var qrCodeSlotRecipe = defineSlotRecipe45({
  slots: ["root", "frame", "pattern", "overlay", "downloadTrigger"],
  className: "chakra-qr-code",
  base: {
    root: {
      position: "relative",
      width: "fit-content",
      "--qr-code-overlay-size": "calc(var(--qr-code-size) / 3)"
    },
    frame: {
      width: "var(--qr-code-size)",
      height: "var(--qr-code-size)",
      fill: "currentColor"
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "var(--qr-code-overlay-size)",
      height: "var(--qr-code-overlay-size)",
      padding: "1",
      background: "bg",
      rounded: "4px"
    }
  },
  variants: {
    size: {
      "2xs": {
        root: {
          "--qr-code-size": "40px"
        }
      },
      xs: {
        root: {
          "--qr-code-size": "64px"
        }
      },
      sm: {
        root: {
          "--qr-code-size": "80px"
        }
      },
      md: {
        root: {
          "--qr-code-size": "120px"
        }
      },
      lg: {
        root: {
          "--qr-code-size": "160px"
        }
      },
      xl: {
        root: {
          "--qr-code-size": "200px"
        }
      },
      "2xl": {
        root: {
          "--qr-code-size": "240px"
        }
      },
      full: {
        root: {
          "--qr-code-size": "100%"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});

// src/core/theme/slot-recipes/index.ts
var slotRecipes = {
  accordion: accordionSlotRecipe,
  actionBar: actionBarSlotRecipe,
  alert: alertSlotRecipe,
  avatar: avatarSlotRecipe,
  blockquote: blockquoteSlotRecipe,
  breadcrumb: breadcrumbSlotRecipe,
  card: cardSlotRecipe,
  checkbox: checkboxSlotRecipe,
  checkboxCard: checkboxCardSlotRecipe,
  collapsible: collapsibleSlotRecipe,
  dataList: dataListSlotRecipe,
  dialog: dialogSlotRecipe,
  drawer: drawerSlotRecipe,
  editable: editableSlotRecipe,
  emptyState: emptyStateSlotRecipe,
  field: fieldSlotRecipe,
  fieldset: fieldsetSlotRecipe,
  fileUpload: fileUploadSlotRecipe,
  hoverCard: hoverCardSlotRecipe,
  list: listSlotRecipe,
  menu: menuSlotRecipe,
  nativeSelect: nativeSelectSlotRecipe,
  numberInput: numberInputSlotRecipe,
  pinInput: pinInputSlotRecipe,
  popover: popoverSlotRecipe,
  progress: progressSlotRecipe,
  progressCircle: progressCircleSlotRecipe,
  radioCard: radioCardSlotRecipe,
  radioGroup: radioGroupSlotRecipe,
  ratingGroup: ratingGroupSlotRecipe,
  segmentGroup: segmentGroupSlotRecipe,
  select: selectSlotRecipe,
  slider: sliderSlotRecipe,
  stat: statSlotRecipe,
  steps: stepsSlotRecipe,
  switch: switchSlotRecipe,
  table: tableSlotRecipe,
  tabs: tabsSlotRecipe,
  tag: tagSlotRecipe,
  toast: toastSlotRecipe,
  tooltip: tooltipSlotRecipe,
  status: statusSlotRecipe,
  timeline: timelineSlotRecipe,
  colorPicker: colorPickerSlotRecipe,
  qrCode: qrCodeSlotRecipe
};

// src/core/theme/tokens/aspect-ratios.ts
import { defineTokens } from "@chakra-ui/react";
var aspectRatios = defineTokens.aspectRatios({
  square: {
    value: "1 / 1"
  },
  landscape: {
    value: "4 / 3"
  },
  portrait: {
    value: "3 / 4"
  },
  wide: {
    value: "16 / 9"
  },
  ultrawide: {
    value: "18 / 5"
  },
  golden: {
    value: "1.618 / 1"
  }
});

// src/core/theme/tokens/animations.ts
import { defineTokens as defineTokens2 } from "@chakra-ui/react";
var animations = defineTokens2.animations({
  spin: {
    value: "spin 1s linear infinite"
  },
  ping: {
    value: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite"
  },
  pulse: {
    value: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
  },
  bounce: {
    value: "bounce 1s infinite"
  }
});

// src/core/theme/tokens/blurs.ts
import { defineTokens as defineTokens3 } from "@chakra-ui/react";
var blurs = defineTokens3.blurs({
  // none: {
  //   value: ' ',
  // },
  // sm: {
  //   value: '4px',
  // },
  // md: {
  //   value: '8px',
  // },
  // lg: {
  //   value: '12px',
  // },
  // xl: {
  //   value: '16px',
  // },
  // '2xl': {
  //   value: '24px',
  // },
  // '3xl': {
  //   value: '40px',
  // },
  // '4xl': {
  //   value: '64px',
  // },
});

// src/core/theme/tokens/borders.ts
import { defineTokens as defineTokens4 } from "@chakra-ui/react";
var borders = defineTokens4.borders({
  // xs: {
  //   value: '0.5px solid',
  // },
  // sm: {
  //   value: '1px solid',
  // },
  // md: {
  //   value: '2px solid',
  // },
  // lg: {
  //   value: '4px solid',
  // },
  // xl: {
  //   value: '8px solid',
  // },
});

// src/core/theme/tokens/colors.ts
var colors2 = {
  primary: {
    50: { value: "#F7F3FF" },
    75: { value: "#ECE3FF" },
    100: { value: "#E1D3FF" },
    200: { value: "#C7ADFF" },
    300: { value: "#976DF3" },
    400: { value: "#6F3FD7" },
    500: { value: "#582DB5" },
    600: { value: "#3D1690" },
    700: { value: "#311275" },
    800: { value: "#250A5D" },
    900: { value: "#200D48" }
  },
  neutral: {
    50: { value: "#F7F7F9" },
    75: { value: "#E8E8EB" },
    100: { value: "#D9D9DC" },
    200: { value: "#BBBABE" },
    300: { value: "#9D9BA1" },
    400: { value: "#7E7C83" },
    500: { value: "#605D66" },
    600: { value: "#413E48" },
    700: { value: "#231F2A" },
    800: { value: "#14101B" },
    900: { value: "#04000C" }
  },
  success: {
    50: { value: "#F0FDF4" },
    75: { value: "#E6FDEE" },
    100: { value: "#DCFCE7" },
    200: { value: "#BBF7D0" },
    300: { value: "#86EFAC" },
    400: { value: "#05DF73" },
    500: { value: "#00C950" },
    600: { value: "#0DA63E" },
    700: { value: "#15803D" },
    800: { value: "#016730" },
    900: { value: "#14532D" }
  },
  warning: {
    50: { value: "#FFFBEB" },
    75: { value: "#FFF7D9" },
    100: { value: "#FEF3C7" },
    200: { value: "#FDE68A" },
    300: { value: "#FCD34D" },
    400: { value: "#FBBF24" },
    500: { value: "#F59E0B" },
    600: { value: "#D97706" },
    700: { value: "#B45309" },
    800: { value: "#92400E" },
    900: { value: "#78350F" }
  },
  error: {
    50: { value: "#FEF2F2" },
    75: { value: "#FEEAEA" },
    100: { value: "#FEE2E2" },
    200: { value: "#FECACA" },
    300: { value: "#FFA2A3" },
    400: { value: "#FF6467" },
    500: { value: "#FA2C37" },
    600: { value: "#E7000B" },
    700: { value: "#C10008" },
    800: { value: "#9F0812" },
    900: { value: "#82181A" }
  },
  generic: {
    0: { value: "#FFFFFF" },
    100: { value: "#000000" }
  }
};

// src/core/theme/tokens/durations.ts
import { defineTokens as defineTokens5 } from "@chakra-ui/react";
var durations = defineTokens5.durations({
  fastest: {
    value: "50ms"
  },
  faster: {
    value: "100ms"
  },
  fast: {
    value: "150ms"
  },
  default: {
    value: "200ms"
  },
  slow: {
    value: "300ms"
  },
  slower: {
    value: "400ms"
  },
  slowest: {
    value: "500ms"
  }
});

// src/core/theme/tokens/easings.ts
import { defineTokens as defineTokens6 } from "@chakra-ui/react";
var easings = defineTokens6.easings({
  "ease-in": {
    value: "cubic-bezier(0.42, 0, 1, 1)"
  },
  "ease-out": {
    value: "cubic-bezier(0, 0, 0.58, 1)"
  },
  "ease-in-out": {
    value: "cubic-bezier(0.42, 0, 0.58, 1)"
  },
  "ease-in-smooth": {
    value: "cubic-bezier(0.32, 0.72, 0, 1)"
  }
});

// src/core/theme/tokens/fonts.ts
import { defineTokens as defineTokens7 } from "@chakra-ui/react";
var fonts = defineTokens7.fonts({
  heading: {
    value: "var(--general-sans), system-ui, sans-serif"
  },
  body: {
    value: "var(--general-sans), system-ui, sans-serif"
  },
  mono: {
    value: "var(--general-sans), Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
  }
});

// src/core/theme/tokens/font-sizes.ts
import { defineTokens as defineTokens8 } from "@chakra-ui/react";
var fontSizes = defineTokens8.fontSizes({
  "2xs": {
    value: "10px"
  },
  xs: {
    value: "12px"
  },
  sm: {
    value: "14px"
  },
  md: {
    value: "16px"
  },
  lg: {
    value: "18px"
  },
  xl: {
    value: "20px"
  },
  "2xl": {
    value: "24px"
  },
  "3xl": {
    value: "28px"
  },
  "4xl": {
    value: "32px"
  },
  "5xl": {
    value: "36px"
  },
  "6xl": {
    value: "40px"
  },
  "7xl": {
    value: "48px"
  },
  "8xl": {
    value: "56px"
  },
  "9xl": {
    value: "64px"
  }
});

// src/core/theme/tokens/font-weights.ts
import { defineTokens as defineTokens9 } from "@chakra-ui/react";
var fontWeights = defineTokens9.fontWeights({
  regular: {
    value: "400"
  },
  medium: {
    value: "500"
  },
  semibold: {
    value: "600"
  },
  bold: {
    value: "700"
  }
});

// src/core/theme/tokens/letter-spacings.ts
import { defineTokens as defineTokens10 } from "@chakra-ui/react";
var letterSpacings = defineTokens10.letterSpacings({
  default: {
    value: 0
  }
  // tighter: {
  //   value: '-0.05em',
  // },
  // tight: {
  //   value: '-0.025em',
  // },
  // wide: {
  //   value: '0.025em',
  // },
  // wider: {
  //   value: '0.05em',
  // },
  // widest: {
  //   value: '0.1em',
  // },
});

// src/core/theme/tokens/line-heights.ts
import { defineTokens as defineTokens11 } from "@chakra-ui/react";
var lineHeights = defineTokens11.lineHeights({
  default: {
    value: "1.4"
  }
});

// src/core/theme/tokens/radii.ts
import { defineTokens as defineTokens12 } from "@chakra-ui/react";
var radii2 = defineTokens12.radii({
  none: {
    value: "0"
  }
  // '2xs': {
  //   value: '0.0625rem',
  // },
  // xs: {
  //   value: '0.125rem',
  // },
  // sm: {
  //   value: '0.25rem',
  // },
  // md: {
  //   value: '0.375rem',
  // },
  // lg: {
  //   value: '0.5rem',
  // },
  // xl: {
  //   value: '0.75rem',
  // },
  // '2xl': {
  //   value: '1rem',
  // },
  // '3xl': {
  //   value: '1.5rem',
  // },
  // '4xl': {
  //   value: '2rem',
  // },
  // full: {
  //   value: '9999px',
  // },
});

// src/core/theme/tokens/spacing.ts
import { defineTokens as defineTokens13 } from "@chakra-ui/react";
var spacing = defineTokens13.spacing({
  "1": {
    value: "4px"
  },
  "2": {
    value: "8px"
  },
  "3": {
    value: "12px"
  },
  "4": {
    value: "16px"
  },
  "5": {
    value: "20px"
  },
  "6": {
    value: "24px"
  },
  "7": {
    value: "28px"
  },
  "8": {
    value: "32px"
  },
  "9": {
    value: "36px"
  },
  "10": {
    value: "40px"
  },
  "11": {
    value: "44px"
  },
  "12": {
    value: "48px"
  },
  "14": {
    value: "56px"
  },
  "16": {
    value: "64px"
  },
  "18": {
    value: "72px"
  },
  "20": {
    value: "80px"
  },
  "24": {
    value: "96px"
  },
  "28": {
    value: "112px"
  },
  "32": {
    value: "128px"
  },
  "36": {
    value: "144px"
  },
  "40": {
    value: "160px"
  },
  "44": {
    value: "176px"
  },
  "48": {
    value: "192px"
  },
  "52": {
    value: "208px"
  },
  "56": {
    value: "224px"
  },
  "60": {
    value: "240px"
  },
  "64": {
    value: "256px"
  },
  "72": {
    value: "288px"
  },
  "80": {
    value: "320px"
  },
  "96": {
    value: "384px"
  },
  "0.5": {
    value: "2px"
  },
  "1.5": {
    value: "6px"
  },
  "2.5": {
    value: "10px"
  },
  "3.5": {
    value: "14px"
  },
  "4.5": {
    value: "18px"
  },
  "safe-area-bottom": {
    value: "env(safe-area-inset-bottom)"
  },
  "safe-area-top": {
    value: "env(safe-area-inset-top)"
  },
  "safe-area-left": {
    value: "env(safe-area-inset-left)"
  },
  "safe-area-right": {
    value: "env(safe-area-inset-right)"
  }
});

// src/core/theme/tokens/sizes.ts
import { defineTokens as defineTokens14 } from "@chakra-ui/react";
var sizes = defineTokens14.sizes({
  "1": {
    value: "0.25rem"
  },
  "2": {
    value: "0.5rem"
  },
  "3": {
    value: "0.75rem"
  },
  "4": {
    value: "1rem"
  },
  "5": {
    value: "1.25rem"
  },
  "6": {
    value: "1.5rem"
  },
  "7": {
    value: "1.75rem"
  },
  "8": {
    value: "2rem"
  },
  "9": {
    value: "2.25rem"
  },
  "10": {
    value: "2.5rem"
  },
  "11": {
    value: "2.75rem"
  },
  "12": {
    value: "3rem"
  },
  "14": {
    value: "3.5rem"
  },
  "16": {
    value: "4rem"
  },
  "20": {
    value: "5rem"
  },
  "24": {
    value: "6rem"
  },
  "28": {
    value: "7rem"
  },
  "32": {
    value: "8rem"
  },
  "36": {
    value: "9rem"
  },
  "40": {
    value: "10rem"
  },
  "44": {
    value: "11rem"
  },
  "48": {
    value: "12rem"
  },
  "52": {
    value: "13rem"
  },
  "56": {
    value: "14rem"
  },
  "60": {
    value: "15rem"
  },
  "64": {
    value: "16rem"
  },
  "72": {
    value: "18rem"
  },
  "80": {
    value: "20rem"
  },
  "96": {
    value: "24rem"
  },
  "3xs": {
    value: "14rem"
  },
  "2xs": {
    value: "16rem"
  },
  xs: {
    value: "20rem"
  },
  sm: {
    value: "24rem"
  },
  md: {
    value: "28rem"
  },
  lg: {
    value: "32rem"
  },
  xl: {
    value: "36rem"
  },
  "2xl": {
    value: "42rem"
  },
  "3xl": {
    value: "48rem"
  },
  "4xl": {
    value: "56rem"
  },
  "5xl": {
    value: "64rem"
  },
  "6xl": {
    value: "72rem"
  },
  "7xl": {
    value: "80rem"
  },
  "8xl": {
    value: "90rem"
  },
  "0.5": {
    value: "0.125rem"
  },
  "1.5": {
    value: "0.375rem"
  },
  "2.5": {
    value: "0.625rem"
  },
  "3.5": {
    value: "0.875rem"
  },
  "4.5": {
    value: "1.125rem"
  },
  "1/2": {
    value: "50%"
  },
  "1/3": {
    value: "33.333333%"
  },
  "2/3": {
    value: "66.666667%"
  },
  "1/4": {
    value: "25%"
  },
  "3/4": {
    value: "75%"
  },
  "1/5": {
    value: "20%"
  },
  "2/5": {
    value: "40%"
  },
  "3/5": {
    value: "60%"
  },
  "4/5": {
    value: "80%"
  },
  "1/6": {
    value: "16.666667%"
  },
  "2/6": {
    value: "33.333333%"
  },
  "3/6": {
    value: "50%"
  },
  "4/6": {
    value: "66.666667%"
  },
  "5/6": {
    value: "83.333333%"
  },
  "1/12": {
    value: "8.333333%"
  },
  "2/12": {
    value: "16.666667%"
  },
  "3/12": {
    value: "25%"
  },
  "4/12": {
    value: "33.333333%"
  },
  "5/12": {
    value: "41.666667%"
  },
  "6/12": {
    value: "50%"
  },
  "7/12": {
    value: "58.333333%"
  },
  "8/12": {
    value: "66.666667%"
  },
  "9/12": {
    value: "75%"
  },
  "10/12": {
    value: "83.333333%"
  },
  "11/12": {
    value: "91.666667%"
  },
  max: {
    value: "max-content"
  },
  min: {
    value: "min-content"
  },
  fit: {
    value: "fit-content"
  },
  prose: {
    value: "60ch"
  },
  full: {
    value: "100%"
  },
  dvh: {
    value: "100dvh"
  },
  svh: {
    value: "100svh"
  },
  lvh: {
    value: "100lvh"
  },
  dvw: {
    value: "100dvw"
  },
  svw: {
    value: "100svw"
  },
  lvw: {
    value: "100lvw"
  },
  vw: {
    value: "100vw"
  },
  vh: {
    value: "100vh"
  }
});

// src/core/theme/tokens/z-index.ts
import { defineTokens as defineTokens15 } from "@chakra-ui/react";
var zIndex = defineTokens15.zIndex({
  hide: {
    value: -1
  },
  base: {
    value: 0
  },
  docked: {
    value: 10
  },
  dropdown: {
    value: 1e3
  },
  sticky: {
    value: 1100
  },
  banner: {
    value: 1200
  },
  overlay: {
    value: 1300
  },
  modal: {
    value: 1400
  },
  popover: {
    value: 1500
  },
  skipNav: {
    value: 1600
  },
  toast: {
    value: 1700
  },
  tooltip: {
    value: 1800
  },
  max: {
    value: 2147483647
  }
});

// src/core/theme/tokens/cursor.ts
import { defineTokens as defineTokens16 } from "@chakra-ui/react";
var cursor = defineTokens16.cursor({
  button: {
    value: "pointer"
  },
  checkbox: {
    value: "default"
  },
  disabled: {
    value: "not-allowed"
  },
  menuitem: {
    value: "default"
  },
  option: {
    value: "default"
  },
  radio: {
    value: "default"
  },
  slider: {
    value: "default"
  },
  switch: {
    value: "pointer"
  }
});

// src/core/theme/tokens/index.ts
var tokens = {
  aspectRatios,
  animations,
  blurs,
  borders,
  colors: colors2,
  durations,
  easings,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  radii: radii2,
  spacing,
  sizes,
  zIndex,
  cursor
};

// src/core/theme/tokens/typographies.ts
import { defineTextStyles } from "@chakra-ui/react";
var FONT_FAMILY2 = "var(--general-sans)";
var typographies = {
  // Display Styles (Desktop only)
  "display.large": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "52px",
      lineHeight: "64px",
      letterSpacing: "0em"
    }
  },
  "display.small": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "44px",
      lineHeight: "52px",
      letterSpacing: "0em"
    }
  },
  // Heading Styles - Desktop
  "heading.h1": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "40px",
      lineHeight: "52px",
      letterSpacing: "0em"
    }
  },
  "heading.h2": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "36px",
      lineHeight: "48px",
      letterSpacing: "0em"
    }
  },
  "heading.h3": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "32px",
      lineHeight: "44px",
      letterSpacing: "0em"
    }
  },
  "heading.h4": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "28px",
      lineHeight: "36px",
      letterSpacing: "0em"
    }
  },
  "heading.h5": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0em"
    }
  },
  "heading.h6": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "0em"
    }
  },
  // Heading Styles - Mobile
  "heading.h1.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "36px",
      lineHeight: "48px",
      letterSpacing: "0em"
    }
  },
  "heading.h2.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "32px",
      lineHeight: "40px",
      letterSpacing: "0em"
    }
  },
  "heading.h3.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "28px",
      lineHeight: "36px",
      letterSpacing: "0em"
    }
  },
  "heading.h4.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0em"
    }
  },
  "heading.h5.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "0em"
    }
  },
  "heading.h6.mobile": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "18px",
      lineHeight: "24px",
      letterSpacing: "0em"
    }
  },
  // Paragraph Styles
  "paragraph.large": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "18px",
      lineHeight: "28px",
      letterSpacing: "0em"
    }
  },
  "paragraph.medium": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0em"
    }
  },
  "paragraph.small": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0em"
    }
  },
  "paragraph.xsmall": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "0em"
    }
  },
  // Overline (use with uppercase, fontWeight="medium")
  "paragraph.overline.large": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "1px"
    }
  },
  "paragraph.overline.small": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "12px",
      lineHeight: "20px",
      letterSpacing: "1px"
    }
  },
  // Label Styles
  "label.large": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0em"
    }
  },
  "label.medium": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0em"
    }
  },
  "label.small": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0em"
    }
  },
  "label.xsmall": {
    value: {
      fontFamily: FONT_FAMILY2,
      fontSize: "10px",
      lineHeight: "16px",
      letterSpacing: "0em"
    }
  }
};
var textStyles = defineTextStyles(typographies);

// src/core/theme/index.ts
var { theme: _theme, conditions: _conditions, ...rest } = defaultConfig;
var themeConfig = defineConfig({
  cssVarsRoot: ":where(:root, :host)",
  cssVarsPrefix: "ss",
  strictTokens: false,
  globalCss,
  conditions: {
    ..._conditions,
    active: "&&:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state=open])"
  },
  theme: {
    breakpoints,
    keyframes,
    tokens,
    semanticTokens,
    recipes,
    slotRecipes,
    textStyles,
    layerStyles,
    animationStyles
  }
});
var system = createSystem(rest, themeConfig);

// src/core/SSDesignSystemProvider.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var SSDesignSystemProvider = ({ children }) => {
  return /* @__PURE__ */ jsx16(ChakraProvider, { value: system, children: /* @__PURE__ */ jsx16(ThemeProvider, { attribute: "class", defaultTheme: "light", disableTransitionOnChange: true, children }) });
};

// src/hooks/index.ts
import { useBreakpointValue, useToken, useSelectContext, useListCollection } from "@chakra-ui/react";

// src/utils/index.ts
import { chakra, createListCollection, defineStyle } from "@chakra-ui/react";

// src/mobile/utils.ts
function convertColorTokenToFlat(colorToken) {
  const result = {};
  Object.entries(colorToken).forEach(([key, token]) => {
    result[key] = token.value;
  });
  return result;
}
function convertTypographyToken(typographyToken) {
  const { fontFamily, fontSize, lineHeight, letterSpacing, fontWeight } = typographyToken.value;
  return {
    fontFamily: fontFamily || "System",
    fontSize,
    lineHeight,
    letterSpacing,
    fontWeight
  };
}
function convertSpacingTokenToFlat(spacingToken) {
  const result = {};
  Object.entries(spacingToken).forEach(([key, token]) => {
    result[key] = token.value;
  });
  return result;
}
function convertFontSizeTokenToFlat(fontSizeToken) {
  const result = {};
  Object.entries(fontSizeToken).forEach(([key, token]) => {
    result[key] = token.value;
  });
  return result;
}
function convertFontWeightTokenToFlat(fontWeightToken) {
  const result = {};
  Object.entries(fontWeightToken).forEach(([key, token]) => {
    result[key] = token.value;
  });
  return result;
}
function createTailwindColors(colors3) {
  return {
    primary: convertColorTokenToFlat(colors3.primary),
    neutral: convertColorTokenToFlat(colors3.neutral),
    success: convertColorTokenToFlat(colors3.success),
    warning: convertColorTokenToFlat(colors3.warning),
    error: convertColorTokenToFlat(colors3.error),
    generic: convertColorTokenToFlat(colors3.generic)
  };
}
function createTailwindSpacing(spacing2) {
  return convertSpacingTokenToFlat(spacing2);
}
function createTailwindFontSizes(fontSizes2) {
  return convertFontSizeTokenToFlat(fontSizes2);
}
function createTailwindFontWeights(fontWeights2) {
  return convertFontWeightTokenToFlat(fontWeights2);
}
function getTypographyStyles(typography) {
  return {
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSize,
    lineHeight: typography.lineHeight,
    letterSpacing: typography.letterSpacing || "0"
  };
}
function convertBreakpointsToMobile(breakpoints2) {
  return {
    mobile: parseInt(breakpoints2.mobile, 10),
    tablet: parseInt(breakpoints2.tablet, 10),
    desktop: parseInt(breakpoints2.desktop, 10)
  };
}
function createTailwindBreakpoints(breakpoints2) {
  return {
    mobile: breakpoints2.mobile,
    tablet: breakpoints2.tablet,
    desktop: breakpoints2.desktop
  };
}
function createTailwindTextStyles(typographies2, customFontFamily) {
  const textStyles2 = {};
  const lineHeightOverrides = {
    "display.large": "65px",
    "display.small": "55px",
    "heading.h2": "45px",
    "heading.h1.mobile": "45px",
    "label.large": "20px",
    "label.medium": "18px",
    "paragraph.small": "18px"
  };
  Object.entries(typographies2).forEach(([key, token]) => {
    const utilityName = `text-style-${key.replace(/\./g, "-")}`;
    const { fontFamily, fontSize, lineHeight, letterSpacing } = token.value;
    const finalLineHeight = lineHeightOverrides[key] || lineHeight;
    textStyles2[`.${utilityName}`] = {
      fontFamily: customFontFamily || fontFamily || "System",
      fontSize,
      lineHeight: finalLineHeight,
      letterSpacing: letterSpacing || "0"
    };
  });
  return textStyles2;
}
function flattenTokens(tokens2) {
  const out = {};
  for (const group of Object.keys(tokens2)) {
    const shades = tokens2[group];
    for (const shade of Object.keys(shades)) {
      out[`${group}.${shade}`] = shades[shade].value;
    }
  }
  return out;
}
var colorMapper = flattenTokens(colors2);

// src/mobile/tokens.ts
var mobileColors = {
  primary: convertColorTokenToFlat(colors2.primary),
  neutral: convertColorTokenToFlat(colors2.neutral),
  success: convertColorTokenToFlat(colors2.success),
  warning: convertColorTokenToFlat(colors2.warning),
  error: convertColorTokenToFlat(colors2.error),
  generic: convertColorTokenToFlat(colors2.generic)
};
var mobileTypography = {
  display: {
    large: convertTypographyToken(typographies["display.large"]),
    small: convertTypographyToken(typographies["display.small"])
  },
  heading: {
    h1: convertTypographyToken(typographies["heading.h1"]),
    h2: convertTypographyToken(typographies["heading.h2"]),
    h3: convertTypographyToken(typographies["heading.h3"]),
    h4: convertTypographyToken(typographies["heading.h4"]),
    h5: convertTypographyToken(typographies["heading.h5"]),
    h6: convertTypographyToken(typographies["heading.h6"]),
    "h1.mobile": convertTypographyToken(typographies["heading.h1.mobile"]),
    "h2.mobile": convertTypographyToken(typographies["heading.h2.mobile"]),
    "h3.mobile": convertTypographyToken(typographies["heading.h3.mobile"]),
    "h4.mobile": convertTypographyToken(typographies["heading.h4.mobile"]),
    "h5.mobile": convertTypographyToken(typographies["heading.h5.mobile"]),
    "h6.mobile": convertTypographyToken(typographies["heading.h6.mobile"])
  },
  paragraph: {
    large: convertTypographyToken(typographies["paragraph.large"]),
    medium: convertTypographyToken(typographies["paragraph.medium"]),
    small: convertTypographyToken(typographies["paragraph.small"]),
    xsmall: convertTypographyToken(typographies["paragraph.xsmall"]),
    "overline.large": convertTypographyToken(typographies["paragraph.overline.large"]),
    "overline.small": convertTypographyToken(typographies["paragraph.overline.small"])
  },
  label: {
    large: convertTypographyToken(typographies["label.large"]),
    medium: convertTypographyToken(typographies["label.medium"]),
    small: convertTypographyToken(typographies["label.small"]),
    xsmall: convertTypographyToken(typographies["label.xsmall"])
  }
};
var mobileSpacing = convertSpacingTokenToFlat(spacing);
var mobileFontSizes = convertFontSizeTokenToFlat(fontSizes);
var mobileFontWeights = convertFontWeightTokenToFlat(fontWeights);
var mobileBreakpoints = convertBreakpointsToMobile(breakpoints);
var mobileDesignTokens = {
  colors: mobileColors,
  typography: mobileTypography,
  spacing: mobileSpacing,
  fontSizes: mobileFontSizes,
  fontWeights: mobileFontWeights,
  breakpoints: mobileBreakpoints
};
var tailwindColors = createTailwindColors(colors2);
var tailwindSpacing = createTailwindSpacing(spacing);
var tailwindFontSizes = createTailwindFontSizes(fontSizes);
var tailwindFontWeights = createTailwindFontWeights(fontWeights);
var tailwindBreakpoints = createTailwindBreakpoints(breakpoints);
var tailwindTextStyles = createTailwindTextStyles(
  typographies,
  "General Sans, system-ui, -apple-system, sans-serif"
);
var tailwindConfig = {
  colors: tailwindColors,
  spacing: tailwindSpacing,
  fontSize: tailwindFontSizes,
  fontWeight: tailwindFontWeights,
  screens: tailwindBreakpoints,
  textStyles: tailwindTextStyles
};
var { primary, neutral, success, warning, error, generic } = mobileColors;
export {
  Accordion,
  Alert,
  AspectRatio,
  Avatar,
  Badge,
  Box2 as Box,
  Breadcrumb,
  Button2 as Button,
  Card,
  Carousel,
  Center,
  Checkbox,
  CloseButton,
  Code,
  Collapsible,
  Combobox,
  Container,
  Dialog,
  Drawer,
  Editable,
  Field,
  Flex2 as Flex,
  Grid,
  GridItem,
  HStack,
  Heading,
  Icon2 as Icon,
  IconButton,
  Image2 as Image,
  Input,
  InputGroup,
  Kbd,
  LUCIDE_ICONS,
  Link,
  List,
  LucideIcon,
  Menu,
  NumberInput,
  PinInput,
  Popover,
  Progress,
  ProgressCircle,
  RadioGroup,
  SSDesignSystemProvider,
  Select,
  Separator,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  Slider,
  Spacer,
  Spinner2 as Spinner,
  Stack2 as Stack,
  Stat,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Text,
  Textarea,
  Toast2 as Toast,
  Toaster,
  Tooltip,
  VStack,
  Wrap,
  WrapItem,
  chakra,
  colorMapper,
  convertBreakpointsToMobile,
  convertColorTokenToFlat,
  convertFontSizeTokenToFlat,
  convertFontWeightTokenToFlat,
  convertSpacingTokenToFlat,
  convertTypographyToken,
  createListCollection,
  createTailwindBreakpoints,
  createTailwindColors,
  createTailwindFontSizes,
  createTailwindFontWeights,
  createTailwindSpacing,
  createTailwindTextStyles,
  defineStyle,
  error,
  generic,
  getTypographyStyles,
  mobileBreakpoints,
  mobileColors,
  mobileDesignTokens,
  mobileFontSizes,
  mobileFontWeights,
  mobileSpacing,
  mobileTypography,
  neutral,
  primary,
  success,
  system,
  tailwindBreakpoints,
  tailwindColors,
  tailwindConfig,
  tailwindFontSizes,
  tailwindFontWeights,
  tailwindSpacing,
  tailwindTextStyles,
  toaster,
  useBreakpointValue,
  useCarousel,
  useListCollection,
  useSelectContext,
  useToken,
  warning
};
